// // // // // src/pages/AdminPage.jsx
// // // // import { useState, useEffect, useCallback } from "react";
// // // // import { useNavigate } from "react-router-dom";
// // // // import { useAuth } from "../hooks/useAuth";
// // // // import {
// // // //   //collection, getDocs, doc, getDoc, query, orderBy, limit,
// // // //   collection, getDocs, 
// // // // } from "firebase/firestore";
// // // // import { db } from "../utils/firebase";
// // // // import servicesConfig from "../utils/servicesConfig";

// // // // // ── Hardcoded admin emails — add yours here ──
// // // // const ADMIN_EMAILS = ["arsh1916@gmail.com", "support@smartaicareer.com"];

// // // // // ── Helpers ──
// // // // function fmtDate(ts) {
// // // //   if (!ts) return "—";
// // // //   const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
// // // //   return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
// // // // }
// // // // function fmtTime(ts) {
// // // //   if (!ts) return "—";
// // // //   const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
// // // //   return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
// // // // }
// // // // function fmtMoney(cents) {
// // // //   return `$${(cents / 100).toFixed(2)}`;
// // // // }
// // // // function getPlanPrice(planId) {
// // // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // // //   return plan?.priceInCents || 199;
// // // // }
// // // // function getPlanName(planId) {
// // // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // // //   return plan?.name || planId || "Unknown";
// // // // }
// // // // function getPlanIncludes(planId, includes) {
// // // //   if (Array.isArray(includes) && includes.length > 0) return includes;
// // // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // // //   return plan?.includes || [];
// // // // }

// // // // // ── Stat card ──
// // // // function StatCard({ label, value, sub, color = "#2563eb", icon }) {
// // // //   return (
// // // //     <div style={{ background: "#fff", borderRadius: 14, padding: "20px 22px", border: "1px solid #e2e8f0", flex: 1, minWidth: 140 }}>
// // // //       <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
// // // //         <div style={{ width: 36, height: 36, borderRadius: 10, background: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>{icon}</div>
// // // //         <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</span>
// // // //       </div>
// // // //       <div style={{ fontSize: 28, fontWeight: 800, color: "#0f172a", letterSpacing: "-0.02em" }}>{value}</div>
// // // //       {sub && <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{sub}</div>}
// // // //     </div>
// // // //   );
// // // // }

// // // // // ── Service tag ──
// // // // function ServiceTag({ code, used }) {
// // // //   const svc = servicesConfig.services.find(s => s.serviceCode === code);
// // // //   return (
// // // //     <span style={{
// // // //       display: "inline-flex", alignItems: "center", gap: 4,
// // // //       fontSize: 11, padding: "3px 8px", borderRadius: 20, fontWeight: 600,
// // // //       background: used ? "#f0fdf4" : "#f8fafc",
// // // //       color: used ? "#059669" : "#94a3b8",
// // // //       border: `1px solid ${used ? "#bbf7d0" : "#e2e8f0"}`,
// // // //     }}>
// // // //       {svc?.icon || "•"} {svc?.title || code}
// // // //       {used ? " ✓" : " —"}
// // // //     </span>
// // // //   );
// // // // }

// // // // export default function AdminPage() {
// // // //   const { user } = useAuth();
// // // //   const navigate = useNavigate();

// // // //   const [activeTab, setActiveTab]  = useState("users"); // users | plans
// // // //   const [loading, setLoading]     = useState(true);
// // // //   const [users, setUsers]         = useState([]);
// // // //   const [filter, setFilter]       = useState("all");    // all | paid | analysed | pending
// // // //   const [planFilter, setPlanFilter] = useState("all");  // all | ats_basic | doc_pro
// // // //   const [search, setSearch]       = useState("");
// // // //   const [expanded, setExpanded]   = useState(null);     // expanded user id
// // // //   const [sortBy, setSortBy]       = useState("recent"); // recent | revenue | name

// // // //   // ── Guard: redirect non-admins ──
// // // //   useEffect(() => {
// // // //     if (!user) { navigate("/login"); return; }
// // // //     if (!ADMIN_EMAILS.includes(user.email)) { navigate("/dashboard"); return; }
// // // //   }, [user, navigate]);

// // // //   // ── Load all users + their transactions + analyses ──
// // // //   const loadData = useCallback(async () => {
// // // //     setLoading(true);
// // // //     try {
// // // //       // Get all user documents
// // // //       const usersSnap = await getDocs(collection(db, "users"));
// // // //       const usersData = [];

// // // //       for (const userDoc of usersSnap.docs) {
// // // //         const userData = userDoc.data();
// // // //         const uid = userDoc.id;

// // // //         // Get transactions
// // // //         const txSnap = await getDocs(collection(db, "users", uid, "transactions"));
// // // //         const transactions = txSnap.docs.map(d => ({ id: d.id, ...d.data() }))
// // // //           .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //         // Get analyses
// // // //         const analysesSnap = await getDocs(collection(db, "users", uid, "analyses"));
// // // //         const analyses = analysesSnap.docs.map(d => ({ id: d.id, ...d.data() }))
// // // //           .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //         const paidTransactions = transactions.filter(t => t.status === "paid");
// // // //         const totalRevenue = paidTransactions.reduce((sum, t) => sum + getPlanPrice(t.planId), 0);

// // // //         // ── Derive display name from all possible sources ──
// // // //         const firstName  = userData.firstName  || userData.displayName?.split(" ")[0]  || "";
// // // //         const lastName   = userData.lastName   || userData.displayName?.split(" ").slice(1).join(" ") || "";
// // // //         const email      = userData.email      || uid;

// // // //         // ── Resume template usage stats ──
// // // //         const templatesUsed = transactions
// // // //           .filter(t => t.resumeGenerated && t.resumeTemplateId)
// // // //           .map(t => t.resumeTemplateId);
// // // //         const templateCounts = templatesUsed.reduce((acc, t) => {
// // // //           acc[t] = (acc[t] || 0) + 1; return acc;
// // // //         }, {});

// // // //         usersData.push({
// // // //           uid,
// // // //           email,
// // // //           firstName,
// // // //           lastName,
// // // //           createdAt:    userData.createdAt,
// // // //           lastPaymentAt: userData.lastPaymentAt,
// // // //           totalPayments: userData.totalPayments  || paidTransactions.length,
// // // //           totalAnalyses: userData.totalAnalyses  || transactions.filter(t => t.analysed).length,
// // // //           totalResumesGenerated: userData.totalResumesGenerated || transactions.filter(t => t.resumeGenerated).length,
// // // //           transactions:  paidTransactions,
// // // //           analyses,
// // // //           totalRevenue,
// // // //           templateCounts,
// // // //         });
// // // //       }

// // // //       setUsers(usersData);
// // // //     } catch (err) {
// // // //       console.error("Admin load error:", err);
// // // //     }
// // // //     setLoading(false);
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     if (user && ADMIN_EMAILS.includes(user.email)) loadData();
// // // //   }, [user, loadData]);

// // // //   // ── Derived stats ──
// // // //   const totalUsers    = users.length;
// // // //   const totalRevenue  = users.reduce((s, u) => s + u.totalRevenue, 0);
// // // //   const totalTx       = users.reduce((s, u) => s + u.transactions.length, 0);
// // // //   const totalAnalyses = users.reduce((s, u) => s + u.totalAnalyses, 0);
// // // //   const pendingUsers  = users.filter(u => u.transactions.some(t => !t.analysed)).length;

// // // //   // ── Filtered + sorted users ──
// // // //   const filteredUsers = users
// // // //     .filter(u => {
// // // //       if (search) {
// // // //         const q = search.toLowerCase();
// // // //         if (!u.email.toLowerCase().includes(q) &&
// // // //             !`${u.firstName} ${u.lastName}`.toLowerCase().includes(q)) return false;
// // // //       }
// // // //       if (planFilter !== "all") {
// // // //         if (!u.transactions.some(t => t.planId === planFilter)) return false;
// // // //       }
// // // //       if (filter === "paid")     return u.transactions.length > 0;
// // // //       if (filter === "analysed") return u.totalAnalyses > 0;
// // // //       if (filter === "pending")  return u.transactions.some(t => t.status === "paid" && !t.analysed);
// // // //       return true;
// // // //     })
// // // //     .sort((a, b) => {
// // // //       if (sortBy === "revenue") return b.totalRevenue - a.totalRevenue;
// // // //       if (sortBy === "name")    return `${a.firstName}${a.lastName}`.localeCompare(`${b.firstName}${b.lastName}`);
// // // //       return (b.lastPaymentAt?.seconds || b.createdAt?.seconds || 0) - (a.lastPaymentAt?.seconds || a.createdAt?.seconds || 0);
// // // //     });

// // // //   if (!user || !ADMIN_EMAILS.includes(user?.email)) return null;

// // // //   return (
// // // //     <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Inter',-apple-system,sans-serif" }}>

// // // //       <style>{`
// // // //         * { box-sizing: border-box; }
// // // //         @media (max-width: 768px) {
// // // //           .admin-stats { flex-wrap: wrap !important; }
// // // //           .admin-stats > div { min-width: calc(50% - 8px) !important; }
// // // //           .admin-filters { flex-wrap: wrap !important; }
// // // //           .admin-table-wrap { overflow-x: auto; }
// // // //         }
// // // //       `}</style>

// // // //       {/* ── NAV ── */}
// // // //       <nav style={{ background: "#0f172a", padding: "0 24px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
// // // //         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
// // // //           <div style={{ width: 32, height: 32, background: "linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
// // // //             <span style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>R</span>
// // // //           </div>
// // // //           <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>ResumeScoreAI</span>
// // // //           <span style={{ background: "#1e293b", color: "#94a3b8", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20, marginLeft: 4 }}>Admin</span>
// // // //         </div>
// // // //         <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
// // // //           {/* Tabs */}
// // // //           <div style={{ display: "flex", background: "#1e293b", borderRadius: 9, padding: 3, gap: 2 }}>
// // // //             {[{ id: "users", label: "👥 Users" }, { id: "plans", label: "📦 Plans & Services" }].map(tab => (
// // // //               <button key={tab.id} onClick={() => setActiveTab(tab.id)}
// // // //                 style={{ padding: "6px 14px", borderRadius: 7, border: "none", fontSize: 12, fontWeight: 600, cursor: "pointer", background: activeTab === tab.id ? "#fff" : "transparent", color: activeTab === tab.id ? "#0f172a" : "#64748b", transition: "all 0.2s" }}
// // // //               >{tab.label}</button>
// // // //             ))}
// // // //           </div>
// // // //           <button onClick={loadData} style={{ padding: "7px 14px", background: "#1e293b", color: "#94a3b8", border: "1px solid #334155", borderRadius: 8, fontSize: 13, cursor: "pointer", fontWeight: 500 }}>
// // // //             🔄 Refresh
// // // //           </button>
// // // //           <button onClick={() => navigate("/dashboard")} style={{ padding: "7px 14px", background: "transparent", color: "#64748b", border: "1px solid #334155", borderRadius: 8, fontSize: 13, cursor: "pointer" }}>
// // // //             ← Dashboard
// // // //           </button>
// // // //         </div>
// // // //       </nav>

// // // //       <div style={{ maxWidth: 1300, margin: "0 auto", padding: "32px 20px" }}>

// // // //         {/* ── HEADER ── */}
// // // //         <div style={{ marginBottom: 28 }}>
// // // //           <h1 style={{ fontSize: 26, fontWeight: 800, color: "#0f172a", marginBottom: 4, letterSpacing: "-0.02em" }}>Admin Dashboard</h1>
// // // //           <p style={{ fontSize: 14, color: "#64748b" }}>User transactions and service utilization</p>
// // // //         </div>

// // // //         {/* ── PLANS & SERVICES TAB ── */}
// // // //         {activeTab === "plans" && <PlansTab />}

// // // //         {/* ── USERS TAB ── */}
// // // //         {activeTab === "users" && (loading ? (
// // // //           <div style={{ textAlign: "center", padding: "80px 20px" }}>
// // // //             <div style={{ width: 40, height: 40, borderRadius: "50%", border: "4px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.8s linear infinite", margin: "0 auto 16px" }} />
// // // //             <p style={{ color: "#64748b", fontSize: 14 }}>Loading all user data...</p>
// // // //             <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
// // // //           </div>
// // // //         ) : (
// // // //           <>
// // // //             {/* ── STATS ── */}
// // // //             <div className="admin-stats" style={{ display: "flex", gap: 16, marginBottom: 28, flexWrap: "wrap" }}>
// // // //               <StatCard label="Total Users"    value={totalUsers}           icon="👥" color="#2563eb" sub={`${pendingUsers} with pending analysis`} />
// // // //               <StatCard label="Total Revenue"  value={fmtMoney(totalRevenue)} icon="💰" color="#059669" sub={`${totalTx} transactions`} />
// // // //               <StatCard label="Analyses Done"  value={totalAnalyses}        icon="🎯" color="#7c3aed" sub="completed analyses" />
// // // //               <StatCard label="Pending"        value={pendingUsers}          icon="⏳" color="#d97706" sub="paid but not analysed" />
// // // //             </div>

// // // //             {/* ── PLAN BREAKDOWN ── */}
// // // //             <div style={{ background: "#fff", borderRadius: 14, padding: "20px 24px", border: "1px solid #e2e8f0", marginBottom: 24 }}>
// // // //               <h3 style={{ fontSize: 14, fontWeight: 700, color: "#374151", marginBottom: 16 }}>Revenue by Plan</h3>
// // // //               <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
// // // //                 {servicesConfig.plans.filter(p => p.enabled).map(plan => {
// // // //                   const planTxs = users.flatMap(u => u.transactions.filter(t => t.planId === plan.id));
// // // //                   const planRevenue = planTxs.length * plan.priceInCents;
// // // //                   return (
// // // //                     <div key={plan.id} style={{ flex: 1, minWidth: 160, background: "#f8fafc", borderRadius: 10, padding: "14px 16px", border: "1px solid #e2e8f0" }}>
// // // //                       <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 4 }}>{plan.name}</div>
// // // //                       <div style={{ fontSize: 22, fontWeight: 800, color: "#0f172a" }}>{fmtMoney(planRevenue)}</div>
// // // //                       <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{planTxs.length} purchases · {plan.price} each</div>
// // // //                     </div>
// // // //                   );
// // // //                 })}
// // // //               </div>
// // // //             </div>

// // // //             {/* ── FILTERS ── */}
// // // //             <div className="admin-filters" style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap", alignItems: "center" }}>
// // // //               {/* Search */}
// // // //               <input
// // // //                 type="text"
// // // //                 placeholder="🔍 Search by name or email..."
// // // //                 value={search}
// // // //                 onChange={e => setSearch(e.target.value)}
// // // //                 style={{ padding: "9px 14px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 13, width: 240, outline: "none", background: "#fff" }}
// // // //               />

// // // //               {/* Status filter */}
// // // //               <div style={{ display: "flex", gap: 6 }}>
// // // //                 {[
// // // //                   { id: "all",      label: "All Users" },
// // // //                   { id: "paid",     label: "💳 Paid" },
// // // //                   { id: "analysed", label: "✅ Analysed" },
// // // //                   { id: "pending",  label: "⏳ Pending" },
// // // //                 ].map(f => (
// // // //                   <button key={f.id} onClick={() => setFilter(f.id)}
// // // //                     style={{ padding: "7px 14px", borderRadius: 8, border: "1px solid", fontSize: 12, fontWeight: 600, cursor: "pointer", borderColor: filter === f.id ? "#2563eb" : "#e2e8f0", background: filter === f.id ? "#eff6ff" : "#fff", color: filter === f.id ? "#2563eb" : "#64748b" }}
// // // //                   >{f.label}</button>
// // // //                 ))}
// // // //               </div>

// // // //               {/* Plan filter */}
// // // //               <select value={planFilter} onChange={e => setPlanFilter(e.target.value)}
// // // //                 style={{ padding: "8px 14px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 12, fontWeight: 600, color: "#374151", background: "#fff", cursor: "pointer" }}
// // // //               >
// // // //                 <option value="all">All Plans</option>
// // // //                 {servicesConfig.plans.filter(p => p.enabled).map(p => (
// // // //                   <option key={p.id} value={p.id}>{p.name}</option>
// // // //                 ))}
// // // //               </select>

// // // //               {/* Sort */}
// // // //               <select value={sortBy} onChange={e => setSortBy(e.target.value)}
// // // //                 style={{ padding: "8px 14px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 12, fontWeight: 600, color: "#374151", background: "#fff", cursor: "pointer" }}
// // // //               >
// // // //                 <option value="recent">Sort: Most Recent</option>
// // // //                 <option value="revenue">Sort: Highest Revenue</option>
// // // //                 <option value="name">Sort: Name A–Z</option>
// // // //               </select>

// // // //               <span style={{ fontSize: 13, color: "#94a3b8", marginLeft: "auto" }}>
// // // //                 {filteredUsers.length} of {totalUsers} users
// // // //               </span>
// // // //             </div>

// // // //             {/* ── USERS TABLE ── */}
// // // //             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
// // // //               {filteredUsers.length === 0 ? (
// // // //                 <div style={{ textAlign: "center", padding: "48px", background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", color: "#94a3b8" }}>
// // // //                   No users match your filters.
// // // //                 </div>
// // // //               ) : filteredUsers.map(u => (
// // // //                 <div key={u.uid} style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>

// // // //                   {/* ── User row ── */}
// // // //                   <div
// // // //                     onClick={() => setExpanded(expanded === u.uid ? null : u.uid)}
// // // //                     style={{ padding: "16px 20px", cursor: "pointer", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}
// // // //                   >
// // // //                     {/* Avatar */}
// // // //                     <div style={{ width: 42, height: 42, borderRadius: "50%", background: `linear-gradient(135deg,${["#2563eb","#7c3aed","#059669","#d97706"][u.uid.charCodeAt(0) % 4]},${["#1d4ed8","#6d28d9","#047857","#b45309"][u.uid.charCodeAt(0) % 4]})`, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: 15, flexShrink: 0 }}>
// // // //                       {(u.firstName?.[0] || u.email?.[0] || "?").toUpperCase()}
// // // //                     </div>

// // // //                     {/* Name + email */}
// // // //                     <div style={{ flex: 1, minWidth: 180 }}>
// // // //                       <div style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>
// // // //                         {u.firstName || u.lastName
// // // //                           ? `${u.firstName} ${u.lastName}`.trim()
// // // //                           : u.email?.split("@")[0] || "Unknown User"}
// // // //                       </div>
// // // //                       <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{u.email}</div>
// // // //                       {Object.keys(u.templateCounts || {}).length > 0 && (
// // // //                         <div style={{ display: "flex", gap: 4, marginTop: 4, flexWrap: "wrap" }}>
// // // //                           {Object.entries(u.templateCounts).map(([tmpl, count]) => {
// // // //                             const t = servicesConfig.resumeTemplates?.find(r => r.id === tmpl);
// // // //                             return (
// // // //                               <span key={tmpl} style={{ fontSize: 10, padding: "1px 7px", borderRadius: 20, background: `${t?.accent || "#2563eb"}15`, color: t?.accent || "#2563eb", fontWeight: 600, border: `1px solid ${t?.accent || "#2563eb"}25` }}>
// // // //                                 🎨 {t?.name || tmpl} ×{count}
// // // //                               </span>
// // // //                             );
// // // //                           })}
// // // //                         </div>
// // // //                       )}
// // // //                     </div>

// // // //                     {/* Stats pills */}
// // // //                     <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
// // // //                       <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.transactions.length > 0 ? "#eff6ff" : "#f8fafc", color: u.transactions.length > 0 ? "#2563eb" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.transactions.length > 0 ? "#bfdbfe" : "#e2e8f0" }}>
// // // //                         💳 {u.transactions.length} {u.transactions.length === 1 ? "payment" : "payments"}
// // // //                       </span>
// // // //                       <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.totalAnalyses > 0 ? "#f0fdf4" : "#f8fafc", color: u.totalAnalyses > 0 ? "#059669" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.totalAnalyses > 0 ? "#bbf7d0" : "#e2e8f0" }}>
// // // //                         🎯 {u.totalAnalyses} {u.totalAnalyses === 1 ? "analysis" : "analyses"}
// // // //                       </span>
// // // //                       <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.totalResumesGenerated > 0 ? "#fdf4ff" : "#f8fafc", color: u.totalResumesGenerated > 0 ? "#7c3aed" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.totalResumesGenerated > 0 ? "#e9d5ff" : "#e2e8f0" }}>
// // // //                         ✨ {u.totalResumesGenerated} resume{u.totalResumesGenerated !== 1 ? "s" : ""}
// // // //                       </span>
// // // //                       {u.totalRevenue > 0 && (
// // // //                         <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#f0fdf4", color: "#059669", fontWeight: 700, border: "1px solid #bbf7d0" }}>
// // // //                           {fmtMoney(u.totalRevenue)}
// // // //                         </span>
// // // //                       )}
// // // //                       {u.transactions.some(t => !t.analysed) && (
// // // //                         <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#fffbeb", color: "#d97706", fontWeight: 600, border: "1px solid #fde68a" }}>
// // // //                           ⏳ Pending
// // // //                         </span>
// // // //                       )}
// // // //                     </div>

// // // //                     {/* Joined */}
// // // //                     <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "right", minWidth: 90 }}>
// // // //                       Joined {fmtDate(u.createdAt)}
// // // //                     </div>

// // // //                     {/* Expand icon */}
// // // //                     <span style={{ fontSize: 12, color: "#94a3b8", transition: "transform 0.2s", display: "inline-block", transform: expanded === u.uid ? "rotate(180deg)" : "rotate(0)" }}>▼</span>
// // // //                   </div>

// // // //                   {/* ── Expanded detail ── */}
// // // //                   {expanded === u.uid && (
// // // //                     <div style={{ borderTop: "1px solid #f1f5f9", padding: "20px 20px 24px" }}>

// // // //                       {u.transactions.length === 0 ? (
// // // //                         <p style={{ fontSize: 13, color: "#94a3b8", fontStyle: "italic" }}>No transactions yet.</p>
// // // //                       ) : (
// // // //                         <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
// // // //                           <h4 style={{ fontSize: 13, fontWeight: 700, color: "#374151", margin: 0 }}>
// // // //                             Transactions ({u.transactions.length})
// // // //                           </h4>

// // // //                           {u.transactions.map(tx => {
// // // //                             const includes = getPlanIncludes(tx.planId, tx.includes);
// // // //                             // Find matching analysis for this transaction
// // // //                             const analysis = u.analyses.find(a => a.transactionId === tx.id);

// // // //                             return (
// // // //                               <div key={tx.id} style={{ background: "#f8fafc", borderRadius: 12, padding: "16px 18px", border: "1px solid #e2e8f0" }}>

// // // //                                 {/* Transaction header */}
// // // //                                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
// // // //                                   <div>
// // // //                                     <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
// // // //                                       <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{getPlanName(tx.planId)}</span>
// // // //                                       <span style={{ fontSize: 11, background: "#eff6ff", color: "#2563eb", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: "1px solid #bfdbfe" }}>
// // // //                                         {fmtMoney(getPlanPrice(tx.planId))}
// // // //                                       </span>
// // // //                                       <span style={{ fontSize: 11, background: tx.analysed ? "#f0fdf4" : "#fffbeb", color: tx.analysed ? "#059669" : "#d97706", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: `1px solid ${tx.analysed ? "#bbf7d0" : "#fde68a"}` }}>
// // // //                                         {tx.analysed ? "✅ Analysed" : "⏳ Pending"}
// // // //                                       </span>
// // // //                                     </div>
// // // //                                     <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
// // // //                                       {fmtTime(tx.createdAt)} · TX: {tx.id?.slice(-8)?.toUpperCase()}
// // // //                                     </div>
// // // //                                   </div>
// // // //                                   <div style={{ fontSize: 11, color: "#94a3b8" }}>
// // // //                                     Payment: {tx.paymentIntentId?.slice(-12)}
// // // //                                   </div>
// // // //                                 </div>

// // // //                                 {/* Services included in this plan */}
// // // //                                 <div style={{ marginBottom: 12 }}>
// // // //                                   <div style={{ fontSize: 11, fontWeight: 600, color: "#64748b", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>Services in this plan</div>
// // // //                                   <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
// // // //                                     {includes.map(code => {
// // // //                                       // Determine if service was actually used
// // // //                                       let used = false;
// // // //                                       if (code === "ATS_ANALYSIS") used = tx.analysed;
// // // //                                       if (code === "ATS_RESUME_SAMPLE") used = tx.resumeGenerated;
// // // //                                       if (code === "DOCUMENT_SUMMARY") used = tx.documentSummarized;
// // // //                                       if (code === "DOCUMENT_CHAT") used = tx.documentChatUsed;
// // // //                                       return (
// // // //                                         <div key={code} style={{ display: "flex", alignItems: "center", gap: 6 }}>
// // // //                                           <ServiceTag code={code} used={used} />
// // // //                                           {code === "ATS_RESUME_SAMPLE" && tx.resumeTemplateId && (() => {
// // // //                                             const tmpl = servicesConfig.resumeTemplates?.find(r => r.id === tx.resumeTemplateId);
// // // //                                             return (
// // // //                                               <span style={{ fontSize: 10, background: `${tmpl?.accent || "#2563eb"}15`, color: tmpl?.accent || "#2563eb", padding: "2px 8px", borderRadius: 20, fontWeight: 700, border: `1px solid ${tmpl?.accent || "#2563eb"}25`, display: "inline-flex", alignItems: "center", gap: 3 }}>
// // // //                                                 <span style={{ width: 6, height: 6, borderRadius: "50%", background: tmpl?.accent || "#2563eb", display: "inline-block" }} />
// // // //                                                 {tmpl?.name || tx.resumeTemplateId}
// // // //                                               </span>
// // // //                                             );
// // // //                                           })()}
// // // //                                         </div>
// // // //                                       );
// // // //                                     })}
// // // //                                   </div>
// // // //                                 </div>

// // // //                                 {/* Analysis details if done */}
// // // //                                 {analysis && (
// // // //                                   <div style={{ background: "#fff", borderRadius: 8, padding: "12px 14px", border: "1px solid #e2e8f0" }}>
// // // //                                     <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 8 }}>Analysis Result</div>
// // // //                                     <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
// // // //                                       <div style={{ textAlign: "center" }}>
// // // //                                         <div style={{ fontSize: 22, fontWeight: 800, color: analysis.ats_score >= 70 ? "#059669" : analysis.ats_score >= 50 ? "#d97706" : "#dc2626" }}>
// // // //                                           {analysis.ats_score}
// // // //                                         </div>
// // // //                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>ATS SCORE</div>
// // // //                                       </div>
// // // //                                       <div style={{ textAlign: "center" }}>
// // // //                                         <div style={{ fontSize: 22, fontWeight: 800, color: "#374151" }}>{analysis.match_rate || "—"}%</div>
// // // //                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>MATCH RATE</div>
// // // //                                       </div>
// // // //                                       <div style={{ textAlign: "center" }}>
// // // //                                         <div style={{ fontSize: 22, fontWeight: 800, color: "#374151" }}>{analysis.missing_count || 0}</div>
// // // //                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>MISSING KW</div>
// // // //                                       </div>
// // // //                                       <div style={{ flex: 1, minWidth: 160 }}>
// // // //                                         <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
// // // //                                           {analysis.summary?.slice(0, 120)}{analysis.summary?.length > 120 ? "..." : ""}
// // // //                                         </div>
// // // //                                       </div>
// // // //                                     </div>
// // // //                                     <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>
// // // //                                       Completed {fmtTime(analysis.createdAt)}
// // // //                                     </div>
// // // //                                   </div>
// // // //                                 )}
// // // //                               </div>
// // // //                             );
// // // //                           })}
// // // //                         </div>
// // // //                       )}
// // // //                     </div>
// // // //                   )}
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           </>
// // // //         ))}
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // PLANS & SERVICES TAB
// // // // // ─────────────────────────────────────────────
// // // // function PlansTab() {
// // // //   const plans    = servicesConfig.plans;
// // // //   const services = servicesConfig.services;

// // // //   return (
// // // //     <div style={{ display: "flex", flexDirection: "column", gap: 28 }}>

// // // //       {/* ── PLANS ── */}
// // // //       <div>
// // // //         <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>
// // // //           Plans ({plans.length})
// // // //         </h2>
// // // //         <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
// // // //           {plans.map(plan => (
// // // //             <div key={plan.id} style={{ background: "#fff", borderRadius: 14, border: `1.5px solid ${plan.active ? "#bfdbfe" : "#e2e8f0"}`, overflow: "hidden" }}>

// // // //               {/* Plan header */}
// // // //               <div style={{ padding: "16px 20px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap", background: plan.active ? "#f0f7ff" : "#f8fafc" }}>
// // // //                 <div style={{ flex: 1, minWidth: 200 }}>
// // // //                   <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
// // // //                     <span style={{ fontSize: 15, fontWeight: 800, color: "#0f172a" }}>{plan.name}</span>
// // // //                     <span style={{ fontSize: 11, background: plan.active ? "#dcfce7" : "#f1f5f9", color: plan.active ? "#059669" : "#94a3b8", padding: "2px 8px", borderRadius: 20, fontWeight: 700, border: `1px solid ${plan.active ? "#bbf7d0" : "#e2e8f0"}` }}>
// // // //                       {plan.active ? "● Active" : "○ Coming Soon"}
// // // //                     </span>
// // // //                     <span style={{ fontSize: 11, background: plan.enabled ? "#eff6ff" : "#f8fafc", color: plan.enabled ? "#2563eb" : "#94a3b8", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: `1px solid ${plan.enabled ? "#bfdbfe" : "#e2e8f0"}` }}>
// // // //                       {plan.enabled ? "Visible" : "Hidden"}
// // // //                     </span>
// // // //                     {plan.badge && (
// // // //                       <span style={{ fontSize: 11, background: "#fef3c7", color: "#d97706", padding: "2px 8px", borderRadius: 20, fontWeight: 700, border: "1px solid #fde68a" }}>
// // // //                         {plan.badge}
// // // //                       </span>
// // // //                     )}
// // // //                   </div>
// // // //                   <div style={{ fontSize: 13, color: "#64748b" }}>{plan.description}</div>
// // // //                 </div>
// // // //                 <div style={{ textAlign: "right" }}>
// // // //                   <div style={{ fontSize: 26, fontWeight: 800, color: "#1d4ed8" }}>{plan.price}</div>
// // // //                   <div style={{ fontSize: 11, color: "#94a3b8" }}>{plan.period}</div>
// // // //                 </div>
// // // //               </div>

// // // //               {/* Plan body */}
// // // //               <div style={{ padding: "16px 20px", display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>

// // // //                 {/* Included services */}
// // // //                 <div>
// // // //                   <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.05em" }}>
// // // //                     Services ({plan.includes?.length || 0})
// // // //                   </div>
// // // //                   <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
// // // //                     {(plan.includes || []).map(code => {
// // // //                       const svc = services.find(s => s.serviceCode === code);
// // // //                       return (
// // // //                         <div key={code} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
// // // //                           <span style={{ fontSize: 15 }}>{svc?.icon || "•"}</span>
// // // //                           <div style={{ flex: 1, minWidth: 0 }}>
// // // //                             <div style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>{svc?.title || code}</div>
// // // //                             <div style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>{svc?.serviceCode}</div>
// // // //                           </div>
// // // //                           {svc?.isFree && <span style={{ fontSize: 10, background: "#dcfce7", color: "#166534", padding: "1px 6px", borderRadius: 10, fontWeight: 700, flexShrink: 0 }}>FREE</span>}
// // // //                           <span style={{ fontSize: 10, background: svc?.active ? "#f0fdf4" : "#fef3c7", color: svc?.active ? "#059669" : "#d97706", padding: "1px 6px", borderRadius: 10, fontWeight: 600, flexShrink: 0 }}>
// // // //                             {svc?.active ? "✓" : "⏳"}
// // // //                           </span>
// // // //                         </div>
// // // //                       );
// // // //                     })}
// // // //                   </div>
// // // //                 </div>

// // // //                 {/* Resume Templates */}
// // // //                 <div>
// // // //                   <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.05em" }}>
// // // //                     Resume Templates ({plan.resumeTemplateIds?.length || 0}) · Pick {plan.resumeTemplateCount ?? "∞"}
// // // //                   </div>
// // // //                   <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
// // // //                     {(plan.resumeTemplateIds || []).map(tmplId => {
// // // //                       const tmpl = servicesConfig.resumeTemplates?.find(r => r.id === tmplId);
// // // //                       return (
// // // //                         <div key={tmplId} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
// // // //                           <div style={{ width: 10, height: 10, borderRadius: "50%", background: tmpl?.accent || "#2563eb", flexShrink: 0 }} />
// // // //                           <span style={{ fontSize: 12, fontWeight: 600, color: "#374151", flex: 1 }}>{tmpl?.name || tmplId}</span>
// // // //                           <span style={{ fontSize: 10, background: tmpl?.active ? "#f0fdf4" : "#f8fafc", color: tmpl?.active ? "#059669" : "#94a3b8", padding: "1px 6px", borderRadius: 10, fontWeight: 600 }}>
// // // //                             {tmpl?.active ? "✓ Active" : "Inactive"}
// // // //                           </span>
// // // //                         </div>
// // // //                       );
// // // //                     })}
// // // //                     {(!plan.resumeTemplateIds || plan.resumeTemplateIds.length === 0) && (
// // // //                       <div style={{ fontSize: 12, color: "#94a3b8", fontStyle: "italic" }}>No templates configured</div>
// // // //                     )}
// // // //                   </div>
// // // //                 </div>

// // // //                 {/* Features list */}
// // // //                 <div>
// // // //                   <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.05em" }}>
// // // //                     Features
// // // //                   </div>
// // // //                   <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
// // // //                     {(plan.features || []).map(f => (
// // // //                       <div key={f.text} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: f.included ? "#374151" : "#cbd5e1" }}>
// // // //                         <span style={{ fontSize: 10 }}>{f.included ? "✅" : "❌"}</span>
// // // //                         <span>{f.text}</span>
// // // //                       </div>
// // // //                     ))}
// // // //                   </div>
// // // //                 </div>
// // // //               </div>

// // // //               {/* Config hint */}
// // // //               <div style={{ padding: "10px 20px", background: "#f8fafc", borderTop: "1px solid #f1f5f9", fontSize: 10, color: "#94a3b8", fontFamily: "monospace", display: "flex", gap: 16, flexWrap: "wrap" }}>
// // // //                 <span>id: "{plan.id}"</span>
// // // //                 <span>priceInCents: {plan.priceInCents}</span>
// // // //                 <span>templateCount: {plan.resumeTemplateCount ?? "unlimited"}</span>
// // // //                 <span>includes: [{(plan.includes || []).join(", ")}]</span>
// // // //               </div>
// // // //             </div>
// // // //           ))}
// // // //         </div>
// // // //       </div>

// // // //       {/* ── SERVICES ── */}
// // // //       <div>
// // // //         <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>
// // // //           Services ({services.length})
// // // //         </h2>
// // // //         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 12 }}>
// // // //           {services.map(svc => {
// // // //             const plan = plans.find(p => p.id === svc.planId);
// // // //             return (
// // // //               <div key={svc.serviceCode} style={{ background: "#fff", borderRadius: 12, border: `1.5px solid ${svc.active ? "#bbf7d0" : svc.comingSoon ? "#fde68a" : "#e2e8f0"}`, padding: "16px" }}>

// // // //                 {/* Header */}
// // // //                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
// // // //                   <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
// // // //                     <span style={{ fontSize: 22 }}>{svc.icon}</span>
// // // //                     <div>
// // // //                       <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{svc.title}</div>
// // // //                       <div style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>{svc.serviceCode}</div>
// // // //                     </div>
// // // //                   </div>
// // // //                   <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-end" }}>
// // // //                     <span style={{ fontSize: 10, background: svc.active ? "#dcfce7" : svc.comingSoon ? "#fffbeb" : "#f1f5f9", color: svc.active ? "#059669" : svc.comingSoon ? "#d97706" : "#94a3b8", padding: "2px 8px", borderRadius: 10, fontWeight: 700 }}>
// // // //                       {svc.active ? "● Active" : svc.comingSoon ? "⏳ Soon" : "○ Inactive"}
// // // //                     </span>
// // // //                     {svc.isFree && (
// // // //                       <span style={{ fontSize: 10, background: "#dcfce7", color: "#166534", padding: "2px 8px", borderRadius: 10, fontWeight: 700 }}>FREE</span>
// // // //                     )}
// // // //                   </div>
// // // //                 </div>

// // // //                 {/* Description */}
// // // //                 <p style={{ fontSize: 12, color: "#64748b", lineHeight: 1.6, marginBottom: 10 }}>{svc.description}</p>

// // // //                 {/* Highlights */}
// // // //                 <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 10 }}>
// // // //                   {svc.highlights.map(h => (
// // // //                     <span key={h} style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, background: "#eff6ff", color: "#2563eb", fontWeight: 600 }}>{h}</span>
// // // //                   ))}
// // // //                 </div>

// // // //                 {/* Plan link */}
// // // //                 <div style={{ fontSize: 11, color: "#64748b", borderTop: "1px solid #f1f5f9", paddingTop: 8, display: "flex", justifyContent: "space-between" }}>
// // // //                   <span>Plan: <strong>{plan?.name || (svc.isFree ? "Free with parent plan" : "None")}</strong></span>
// // // //                   {svc.route && <span style={{ color: "#2563eb", fontFamily: "monospace" }}>{svc.route}</span>}
// // // //                 </div>

// // // //                 {/* Visibility flags */}
// // // //                 <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 6, display: "flex", gap: 10 }}>
// // // //                   <span style={{ color: svc.enabled ? "#059669" : "#ef4444" }}>{svc.enabled ? "✓ Enabled" : "✗ Disabled"}</span>
// // // //                   <span style={{ color: svc.active ? "#059669" : "#94a3b8" }}>{svc.active ? "✓ Active" : "✗ Inactive"}</span>
// // // //                   <span style={{ color: svc.comingSoon ? "#d97706" : "#94a3b8" }}>{svc.comingSoon ? "⏳ Coming Soon" : "✓ Live"}</span>
// // // //                 </div>
// // // //               </div>
// // // //             );
// // // //           })}
// // // //         </div>
// // // //       </div>

// // // //       {/* ── RESUME TEMPLATES ── */}
// // // //       {servicesConfig.resumeTemplates?.length > 0 && (
// // // //         <div>
// // // //           <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>
// // // //             Resume Templates ({servicesConfig.resumeTemplates.length})
// // // //           </h2>
// // // //           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 12 }}>
// // // //             {servicesConfig.resumeTemplates.map(tmpl => (
// // // //               <div key={tmpl.id} style={{ background: "#fff", borderRadius: 12, border: `2px solid ${tmpl.accent}30`, overflow: "hidden" }}>
// // // //                 {/* Color header bar */}
// // // //                 <div style={{ height: 6, background: `linear-gradient(90deg,${tmpl.accent},${tmpl.headerBg})` }} />
// // // //                 <div style={{ padding: "14px 16px" }}>
// // // //                   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
// // // //                     <div>
// // // //                       <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 2 }}>{tmpl.name}</div>
// // // //                       <div style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>{tmpl.id}</div>
// // // //                     </div>
// // // //                     <span style={{ fontSize: 10, background: tmpl.active ? "#dcfce7" : "#f1f5f9", color: tmpl.active ? "#059669" : "#94a3b8", padding: "2px 8px", borderRadius: 10, fontWeight: 700, flexShrink: 0 }}>
// // // //                       {tmpl.active ? "● Active" : "○ Inactive"}
// // // //                     </span>
// // // //                   </div>
// // // //                   <p style={{ fontSize: 11, color: "#64748b", lineHeight: 1.5, marginBottom: 10 }}>{tmpl.description}</p>
// // // //                   <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 10 }}>
// // // //                     {tmpl.tags.map(tag => (
// // // //                       <span key={tag} style={{ fontSize: 10, padding: "2px 7px", borderRadius: 20, background: `${tmpl.accent}12`, color: tmpl.accent, fontWeight: 600 }}>{tag}</span>
// // // //                     ))}
// // // //                   </div>
// // // //                   <div style={{ display: "flex", gap: 8, fontSize: 10, color: "#94a3b8" }}>
// // // //                     <span>Accent: <strong style={{ color: tmpl.accent }}>{tmpl.accent}</strong></span>
// // // //                     <span>Header: <strong style={{ color: tmpl.headerBg }}>{tmpl.headerBg}</strong></span>
// // // //                   </div>
// // // //                   {/* Which plans include this template */}
// // // //                   <div style={{ marginTop: 8, paddingTop: 8, borderTop: "1px solid #f1f5f9" }}>
// // // //                     <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 4 }}>Used in plans:</div>
// // // //                     <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
// // // //                       {plans.filter(p => p.resumeTemplateIds?.includes(tmpl.id)).map(p => (
// // // //                         <span key={p.id} style={{ fontSize: 10, background: "#eff6ff", color: "#2563eb", padding: "1px 7px", borderRadius: 10, fontWeight: 600 }}>{p.name}</span>
// // // //                       ))}
// // // //                     </div>
// // // //                   </div>
// // // //                 </div>
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {/* ── CONFIG GUIDE ── */}
// // // //       <div style={{ background: "#0f172a", borderRadius: 14, padding: "24px", color: "#e2e8f0" }}>
// // // //         <h3 style={{ fontSize: 14, fontWeight: 700, color: "#fff", marginBottom: 16 }}>⚙️ Configuration Guide</h3>
// // // //         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: 20 }}>
// // // //           {[
// // // //             { title: "Launch a new plan", steps: ["Add plan to servicesConfig.js plans[]", "Set enabled: true, active: true", "Add price to backend/server.js PLAN_PRICES", "Redeploy backend"] },
// // // //             { title: "Activate a service", steps: ["Set active: true in servicesConfig.js", "Set comingSoon: false", "Add serviceCode to plan includes[]", "Build the route/page first"] },
// // // //             { title: "Change a price", steps: ["Update priceInCents in servicesConfig.js", "Update PLAN_PRICES in backend/server.js", "Redeploy backend only"] },
// // // //             { title: "Hide a plan/service", steps: ["Set enabled: false to hide everywhere", "Set active: false to hide from dashboard", "Keep comingSoon: true to show teaser"] },
// // // //           ].map(guide => (
// // // //             <div key={guide.title}>
// // // //               <div style={{ fontSize: 12, fontWeight: 700, color: "#60a5fa", marginBottom: 8 }}>{guide.title}</div>
// // // //               <ol style={{ margin: 0, paddingLeft: 18 }}>
// // // //                 {guide.steps.map((step, i) => (
// // // //                   <li key={i} style={{ fontSize: 12, color: "#94a3b8", lineHeight: 1.7 }}>{step}</li>
// // // //                 ))}
// // // //               </ol>
// // // //             </div>
// // // //           ))}
// // // //         </div>
// // // //       </div>

// // // //     </div>
// // // //   );
// // // // }

// // // // src/pages/AdminPage.jsx
// // // import { useState, useEffect, useCallback } from "react";
// // // import { useNavigate } from "react-router-dom";
// // // import { useAuth } from "../hooks/useAuth";
// // // import {
// // //   //collection, getDocs, doc, getDoc, query, orderBy, limit,
// // //   collection, getDocs, 
// // // } from "firebase/firestore";
// // // import { db } from "../utils/firebase";
// // // import servicesConfig from "../utils/servicesConfig";

// // // // ── Hardcoded admin emails — add yours here ──
// // // const ADMIN_EMAILS = ["arsh1916@gmail.com", "support@smartaicareer.com"];

// // // // ── Helpers ──
// // // function fmtDate(ts) {
// // //   if (!ts) return "—";
// // //   const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
// // //   return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
// // // }
// // // function fmtTime(ts) {
// // //   if (!ts) return "—";
// // //   const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
// // //   return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
// // // }
// // // function fmtMoney(cents) {
// // //   return `$${(cents / 100).toFixed(2)}`;
// // // }
// // // function getPlanPrice(planId) {
// // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // //   return plan?.priceInCents || 199;
// // // }
// // // function getPlanName(planId) {
// // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // //   return plan?.name || planId || "Unknown";
// // // }
// // // function getPlanIncludes(planId, includes) {
// // //   if (Array.isArray(includes) && includes.length > 0) return includes;
// // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // //   return plan?.includes || [];
// // // }

// // // // ── Stat card ──
// // // function StatCard({ label, value, sub, color = "#2563eb", icon }) {
// // //   return (
// // //     <div style={{ background: "#fff", borderRadius: 14, padding: "20px 22px", border: "1px solid #e2e8f0", flex: 1, minWidth: 140 }}>
// // //       <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
// // //         <div style={{ width: 36, height: 36, borderRadius: 10, background: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>{icon}</div>
// // //         <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</span>
// // //       </div>
// // //       <div style={{ fontSize: 28, fontWeight: 800, color: "#0f172a", letterSpacing: "-0.02em" }}>{value}</div>
// // //       {sub && <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{sub}</div>}
// // //     </div>
// // //   );
// // // }

// // // // ── Service tag ──
// // // function ServiceTag({ code, used }) {
// // //   const svc = servicesConfig.services.find(s => s.serviceCode === code);
// // //   return (
// // //     <span style={{
// // //       display: "inline-flex", alignItems: "center", gap: 4,
// // //       fontSize: 11, padding: "3px 8px", borderRadius: 20, fontWeight: 600,
// // //       background: used ? "#f0fdf4" : "#f8fafc",
// // //       color: used ? "#059669" : "#94a3b8",
// // //       border: `1px solid ${used ? "#bbf7d0" : "#e2e8f0"}`,
// // //     }}>
// // //       {svc?.icon || "•"} {svc?.title || code}
// // //       {used ? " ✓" : " —"}
// // //     </span>
// // //   );
// // // }

// // // export default function AdminPage() {
// // //   const { user } = useAuth();
// // //   const navigate = useNavigate();

// // //   const [activeTab, setActiveTab]  = useState("users"); // users | plans
// // //   const [loading, setLoading]     = useState(true);
// // //   const [users, setUsers]         = useState([]);
// // //   const [filter, setFilter]       = useState("all");    // all | paid | analysed | pending
// // //   const [planFilter, setPlanFilter] = useState("all");  // all | ats_basic | doc_pro
// // //   const [search, setSearch]       = useState("");
// // //   const [expanded, setExpanded]   = useState(null);     // expanded user id
// // //   const [sortBy, setSortBy]       = useState("recent"); // recent | revenue | name

// // //   // ── Guard: redirect non-admins ──
// // //   useEffect(() => {
// // //     if (!user) { navigate("/login"); return; }
// // //     if (!ADMIN_EMAILS.includes(user.email)) { navigate("/dashboard"); return; }
// // //   }, [user, navigate]);

// // //   // ── Load all users + their transactions + analyses ──
// // //   const loadData = useCallback(async () => {
// // //     setLoading(true);
// // //     try {
// // //       // Get all user documents
// // //       const usersSnap = await getDocs(collection(db, "users"));
// // //       const usersData = [];

// // //       for (const userDoc of usersSnap.docs) {
// // //         const userData = userDoc.data();
// // //         const uid = userDoc.id;

// // //         // Get transactions
// // //         const txSnap = await getDocs(collection(db, "users", uid, "transactions"));
// // //         const transactions = txSnap.docs.map(d => ({ id: d.id, ...d.data() }))
// // //           .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //         // Get analyses
// // //         const analysesSnap = await getDocs(collection(db, "users", uid, "analyses"));
// // //         const analyses = analysesSnap.docs.map(d => ({ id: d.id, ...d.data() }))
// // //           .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //         const paidTransactions = transactions.filter(t => t.status === "paid");
// // //         const totalRevenue = paidTransactions.reduce((sum, t) => sum + getPlanPrice(t.planId), 0);

// // //         // ── Derive display name from all possible sources ──
// // //         const firstName  = userData.firstName  || userData.displayName?.split(" ")[0]  || "";
// // //         const lastName   = userData.lastName   || userData.displayName?.split(" ").slice(1).join(" ") || "";
// // //         const email      = userData.email      || uid;

// // //         // ── Resume template usage stats ──
// // //         const templatesUsed = transactions
// // //           .filter(t => t.resumeGenerated && t.resumeTemplateId)
// // //           .map(t => t.resumeTemplateId);
// // //         const templateCounts = templatesUsed.reduce((acc, t) => {
// // //           acc[t] = (acc[t] || 0) + 1; return acc;
// // //         }, {});

// // //         usersData.push({
// // //           uid,
// // //           email,
// // //           firstName,
// // //           lastName,
// // //           createdAt:    userData.createdAt,
// // //           lastPaymentAt: userData.lastPaymentAt,
// // //           totalPayments: userData.totalPayments  || paidTransactions.length,
// // //           totalAnalyses: userData.totalAnalyses  || transactions.filter(t => t.analysed).length,
// // //           totalResumesGenerated: userData.totalResumesGenerated || transactions.filter(t => t.resumeGenerated).length,
// // //           transactions:  paidTransactions,
// // //           analyses,
// // //           totalRevenue,
// // //           templateCounts,
// // //         });
// // //       }

// // //       setUsers(usersData);
// // //     } catch (err) {
// // //       console.error("Admin load error:", err);
// // //     }
// // //     setLoading(false);
// // //   }, []);

// // //   useEffect(() => {
// // //     if (user && ADMIN_EMAILS.includes(user.email)) loadData();
// // //   }, [user, loadData]);

// // //   // ── Derived stats ──
// // //   const totalUsers    = users.length;
// // //   const totalRevenue  = users.reduce((s, u) => s + u.totalRevenue, 0);
// // //   const totalTx       = users.reduce((s, u) => s + u.transactions.length, 0);
// // //   const totalAnalyses = users.reduce((s, u) => s + u.totalAnalyses, 0);
// // //   const pendingUsers  = users.filter(u => u.transactions.some(t => !t.analysed)).length;

// // //   // ── Filtered + sorted users ──
// // //   const filteredUsers = users
// // //     .filter(u => {
// // //       if (search) {
// // //         const q = search.toLowerCase();
// // //         if (!u.email.toLowerCase().includes(q) &&
// // //             !`${u.firstName} ${u.lastName}`.toLowerCase().includes(q)) return false;
// // //       }
// // //       if (planFilter !== "all") {
// // //         if (!u.transactions.some(t => t.planId === planFilter)) return false;
// // //       }
// // //       if (filter === "paid")     return u.transactions.length > 0;
// // //       if (filter === "analysed") return u.totalAnalyses > 0;
// // //       if (filter === "pending")  return u.transactions.some(t => t.status === "paid" && !t.analysed);
// // //       return true;
// // //     })
// // //     .sort((a, b) => {
// // //       if (sortBy === "revenue") return b.totalRevenue - a.totalRevenue;
// // //       if (sortBy === "name")    return `${a.firstName}${a.lastName}`.localeCompare(`${b.firstName}${b.lastName}`);
// // //       return (b.lastPaymentAt?.seconds || b.createdAt?.seconds || 0) - (a.lastPaymentAt?.seconds || a.createdAt?.seconds || 0);
// // //     });

// // //   if (!user || !ADMIN_EMAILS.includes(user?.email)) return null;

// // //   return (
// // //     <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Inter',-apple-system,sans-serif" }}>

// // //       <style>{`
// // //         * { box-sizing: border-box; }
        
// // //         /* Responsive styles */
// // //         @media (max-width: 768px) {
// // //           .admin-stats { flex-wrap: wrap !important; }
// // //           .admin-stats > div { min-width: calc(50% - 8px) !important; }
// // //           .admin-filters { flex-wrap: wrap !important; }
// // //           .admin-table-wrap { overflow-x: auto; }
// // //           .nav-container { flex-wrap: wrap !important; gap: 10px !important; }
// // //           .nav-buttons { flex-wrap: wrap !important; justify-content: center !important; }
// // //           .plan-body-grid { grid-template-columns: 1fr !important; gap: 20px !important; }
// // //           .services-grid { grid-template-columns: 1fr !important; }
// // //           .templates-grid { grid-template-columns: 1fr !important; }
// // //           .config-guide-grid { grid-template-columns: 1fr !important; }
// // //           .revenue-breakdown { flex-direction: column !important; }
// // //           .user-row { flex-direction: column !important; align-items: flex-start !important; }
// // //           .user-pills { justify-content: flex-start !important; }
// // //           .transaction-header { flex-direction: column !important; align-items: flex-start !important; }
// // //           .analysis-details { flex-direction: column !important; align-items: flex-start !important; gap: 12px !important; }
// // //           .filter-buttons { flex-wrap: wrap !important; }
// // //         }

// // //         @media (max-width: 480px) {
// // //           .admin-stats > div { min-width: 100% !important; }
// // //           .stat-card { padding: 16px !important; }
// // //           .plan-header { flex-direction: column !important; align-items: flex-start !important; gap: 12px !important; }
// // //           .plan-price { text-align: left !important; }
// // //           .expanded-content { padding: 16px !important; }
// // //         }
// // //       `}</style>

// // //       {/* ── NAV ── */}
// // //       <nav className="nav-container" style={{ background: "#0f172a", padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "12px" }}>
// // //         <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
// // //           <div style={{ width: 32, height: 32, background: "linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
// // //             <span style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>R</span>
// // //           </div>
// // //           <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>ResumeScoreAI</span>
// // //           <span style={{ background: "#1e293b", color: "#94a3b8", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20, marginLeft: 4 }}>Admin</span>
// // //         </div>
// // //         <div className="nav-buttons" style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
// // //           {/* Tabs */}
// // //           <div style={{ display: "flex", background: "#1e293b", borderRadius: 9, padding: 3, gap: 2 }}>
// // //             {[{ id: "users", label: "👥 Users" }, { id: "plans", label: "📦 Plans & Services" }].map(tab => (
// // //               <button key={tab.id} onClick={() => setActiveTab(tab.id)}
// // //                 style={{ padding: "6px 12px", borderRadius: 7, border: "none", fontSize: 12, fontWeight: 600, cursor: "pointer", background: activeTab === tab.id ? "#fff" : "transparent", color: activeTab === tab.id ? "#0f172a" : "#64748b", transition: "all 0.2s", whiteSpace: "nowrap" }}
// // //               >{tab.label}</button>
// // //             ))}
// // //           </div>
// // //           <button onClick={loadData} style={{ padding: "7px 14px", background: "#1e293b", color: "#94a3b8", border: "1px solid #334155", borderRadius: 8, fontSize: 13, cursor: "pointer", fontWeight: 500 }}>
// // //             🔄 Refresh
// // //           </button>
// // //           <button onClick={() => navigate("/dashboard")} style={{ padding: "7px 14px", background: "transparent", color: "#64748b", border: "1px solid #334155", borderRadius: 8, fontSize: 13, cursor: "pointer" }}>
// // //             ← Dashboard
// // //           </button>
// // //         </div>
// // //       </nav>

// // //       <div style={{ maxWidth: 1300, margin: "0 auto", padding: "24px 16px" }}>

// // //         {/* ── HEADER ── */}
// // //         <div style={{ marginBottom: 24 }}>
// // //           <h1 style={{ fontSize: "clamp(22px, 6vw, 26px)", fontWeight: 800, color: "#0f172a", marginBottom: 4, letterSpacing: "-0.02em" }}>Admin Dashboard</h1>
// // //           <p style={{ fontSize: 14, color: "#64748b" }}>User transactions and service utilization</p>
// // //         </div>

// // //         {/* ── PLANS & SERVICES TAB ── */}
// // //         {activeTab === "plans" && <PlansTab />}

// // //         {/* ── USERS TAB ── */}
// // //         {activeTab === "users" && (loading ? (
// // //           <div style={{ textAlign: "center", padding: "80px 20px" }}>
// // //             <div style={{ width: 40, height: 40, borderRadius: "50%", border: "4px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.8s linear infinite", margin: "0 auto 16px" }} />
// // //             <p style={{ color: "#64748b", fontSize: 14 }}>Loading all user data...</p>
// // //             <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
// // //           </div>
// // //         ) : (
// // //           <>
// // //             {/* ── STATS ── */}
// // //             <div className="admin-stats" style={{ display: "flex", gap: 16, marginBottom: 28, flexWrap: "wrap" }}>
// // //               <StatCard label="Total Users"    value={totalUsers}           icon="👥" color="#2563eb" sub={`${pendingUsers} with pending analysis`} />
// // //               <StatCard label="Total Revenue"  value={fmtMoney(totalRevenue)} icon="💰" color="#059669" sub={`${totalTx} transactions`} />
// // //               <StatCard label="Analyses Done"  value={totalAnalyses}        icon="🎯" color="#7c3aed" sub="completed analyses" />
// // //               <StatCard label="Pending"        value={pendingUsers}          icon="⏳" color="#d97706" sub="paid but not analysed" />
// // //             </div>

// // //             {/* ── PLAN BREAKDOWN ── */}
// // //             <div style={{ background: "#fff", borderRadius: 14, padding: "16px 20px", border: "1px solid #e2e8f0", marginBottom: 24 }}>
// // //               <h3 style={{ fontSize: 14, fontWeight: 700, color: "#374151", marginBottom: 16 }}>Revenue by Plan</h3>
// // //               <div className="revenue-breakdown" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
// // //                 {servicesConfig.plans.filter(p => p.enabled).map(plan => {
// // //                   const planTxs = users.flatMap(u => u.transactions.filter(t => t.planId === plan.id));
// // //                   const planRevenue = planTxs.length * plan.priceInCents;
// // //                   return (
// // //                     <div key={plan.id} style={{ flex: 1, minWidth: 150, background: "#f8fafc", borderRadius: 10, padding: "12px 14px", border: "1px solid #e2e8f0" }}>
// // //                       <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 4 }}>{plan.name}</div>
// // //                       <div style={{ fontSize: "clamp(18px, 5vw, 22px)", fontWeight: 800, color: "#0f172a" }}>{fmtMoney(planRevenue)}</div>
// // //                       <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>{planTxs.length} purchases · {plan.price} each</div>
// // //                     </div>
// // //                   );
// // //                 })}
// // //               </div>
// // //             </div>

// // //             {/* ── FILTERS ── */}
// // //             <div className="admin-filters" style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap", alignItems: "center" }}>
// // //               {/* Search */}
// // //               <input
// // //                 type="text"
// // //                 placeholder="🔍 Search by name or email..."
// // //                 value={search}
// // //                 onChange={e => setSearch(e.target.value)}
// // //                 style={{ padding: "9px 14px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 13, minWidth: 200, flex: "1 1 200px", outline: "none", background: "#fff" }}
// // //               />

// // //               {/* Status filter */}
// // //               <div className="filter-buttons" style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
// // //                 {[
// // //                   { id: "all",      label: "All Users" },
// // //                   { id: "paid",     label: "💳 Paid" },
// // //                   { id: "analysed", label: "✅ Analysed" },
// // //                   { id: "pending",  label: "⏳ Pending" },
// // //                 ].map(f => (
// // //                   <button key={f.id} onClick={() => setFilter(f.id)}
// // //                     style={{ padding: "7px 12px", borderRadius: 8, border: "1px solid", fontSize: 12, fontWeight: 600, cursor: "pointer", borderColor: filter === f.id ? "#2563eb" : "#e2e8f0", background: filter === f.id ? "#eff6ff" : "#fff", color: filter === f.id ? "#2563eb" : "#64748b", whiteSpace: "nowrap" }}
// // //                   >{f.label}</button>
// // //                 ))}
// // //               </div>

// // //               {/* Plan filter */}
// // //               <select value={planFilter} onChange={e => setPlanFilter(e.target.value)}
// // //                 style={{ padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 12, fontWeight: 600, color: "#374151", background: "#fff", cursor: "pointer" }}
// // //               >
// // //                 <option value="all">All Plans</option>
// // //                 {servicesConfig.plans.filter(p => p.enabled).map(p => (
// // //                   <option key={p.id} value={p.id}>{p.name}</option>
// // //                 ))}
// // //               </select>

// // //               {/* Sort */}
// // //               <select value={sortBy} onChange={e => setSortBy(e.target.value)}
// // //                 style={{ padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 12, fontWeight: 600, color: "#374151", background: "#fff", cursor: "pointer" }}
// // //               >
// // //                 <option value="recent">Sort: Most Recent</option>
// // //                 <option value="revenue">Sort: Highest Revenue</option>
// // //                 <option value="name">Sort: Name A–Z</option>
// // //               </select>

// // //               <span style={{ fontSize: 13, color: "#94a3b8", marginLeft: "auto" }}>
// // //                 {filteredUsers.length} of {totalUsers} users
// // //               </span>
// // //             </div>

// // //             {/* ── USERS TABLE ── */}
// // //             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
// // //               {filteredUsers.length === 0 ? (
// // //                 <div style={{ textAlign: "center", padding: "48px", background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", color: "#94a3b8" }}>
// // //                   No users match your filters.
// // //                 </div>
// // //               ) : filteredUsers.map(u => (
// // //                 <div key={u.uid} style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>

// // //                   {/* ── User row ── */}
// // //                   <div
// // //                     onClick={() => setExpanded(expanded === u.uid ? null : u.uid)}
// // //                     className="user-row"
// // //                     style={{ padding: "16px 20px", cursor: "pointer", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}
// // //                   >
// // //                     {/* Avatar */}
// // //                     <div style={{ width: 42, height: 42, borderRadius: "50%", background: `linear-gradient(135deg,${["#2563eb","#7c3aed","#059669","#d97706"][u.uid.charCodeAt(0) % 4]},${["#1d4ed8","#6d28d9","#047857","#b45309"][u.uid.charCodeAt(0) % 4]})`, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: 15, flexShrink: 0 }}>
// // //                       {(u.firstName?.[0] || u.email?.[0] || "?").toUpperCase()}
// // //                     </div>

// // //                     {/* Name + email */}
// // //                     <div style={{ flex: 1, minWidth: 160 }}>
// // //                       <div style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>
// // //                         {u.firstName || u.lastName
// // //                           ? `${u.firstName} ${u.lastName}`.trim()
// // //                           : u.email?.split("@")[0] || "Unknown User"}
// // //                       </div>
// // //                       <div style={{ fontSize: 12, color: "#64748b", marginTop: 2, wordBreak: "break-all" }}>{u.email}</div>
// // //                       {Object.keys(u.templateCounts || {}).length > 0 && (
// // //                         <div style={{ display: "flex", gap: 4, marginTop: 4, flexWrap: "wrap" }}>
// // //                           {Object.entries(u.templateCounts).map(([tmpl, count]) => {
// // //                             const t = servicesConfig.resumeTemplates?.find(r => r.id === tmpl);
// // //                             return (
// // //                               <span key={tmpl} style={{ fontSize: 10, padding: "1px 7px", borderRadius: 20, background: `${t?.accent || "#2563eb"}15`, color: t?.accent || "#2563eb", fontWeight: 600, border: `1px solid ${t?.accent || "#2563eb"}25` }}>
// // //                                 🎨 {t?.name || tmpl} ×{count}
// // //                               </span>
// // //                             );
// // //                           })}
// // //                         </div>
// // //                       )}
// // //                     </div>

// // //                     {/* Stats pills */}
// // //                     <div className="user-pills" style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
// // //                       <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.transactions.length > 0 ? "#eff6ff" : "#f8fafc", color: u.transactions.length > 0 ? "#2563eb" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.transactions.length > 0 ? "#bfdbfe" : "#e2e8f0" }}>
// // //                         💳 {u.transactions.length} {u.transactions.length === 1 ? "payment" : "payments"}
// // //                       </span>
// // //                       <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.totalAnalyses > 0 ? "#f0fdf4" : "#f8fafc", color: u.totalAnalyses > 0 ? "#059669" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.totalAnalyses > 0 ? "#bbf7d0" : "#e2e8f0" }}>
// // //                         🎯 {u.totalAnalyses} {u.totalAnalyses === 1 ? "analysis" : "analyses"}
// // //                       </span>
// // //                       <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.totalResumesGenerated > 0 ? "#fdf4ff" : "#f8fafc", color: u.totalResumesGenerated > 0 ? "#7c3aed" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.totalResumesGenerated > 0 ? "#e9d5ff" : "#e2e8f0" }}>
// // //                         ✨ {u.totalResumesGenerated} resume{u.totalResumesGenerated !== 1 ? "s" : ""}
// // //                       </span>
// // //                       {u.totalRevenue > 0 && (
// // //                         <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#f0fdf4", color: "#059669", fontWeight: 700, border: "1px solid #bbf7d0" }}>
// // //                           {fmtMoney(u.totalRevenue)}
// // //                         </span>
// // //                       )}
// // //                       {u.transactions.some(t => !t.analysed) && (
// // //                         <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#fffbeb", color: "#d97706", fontWeight: 600, border: "1px solid #fde68a" }}>
// // //                           ⏳ Pending
// // //                         </span>
// // //                       )}
// // //                     </div>

// // //                     {/* Joined */}
// // //                     <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "right", minWidth: 90 }}>
// // //                       Joined {fmtDate(u.createdAt)}
// // //                     </div>

// // //                     {/* Expand icon */}
// // //                     <span style={{ fontSize: 12, color: "#94a3b8", transition: "transform 0.2s", display: "inline-block", transform: expanded === u.uid ? "rotate(180deg)" : "rotate(0)" }}>▼</span>
// // //                   </div>

// // //                   {/* ── Expanded detail ── */}
// // //                   {expanded === u.uid && (
// // //                     <div className="expanded-content" style={{ borderTop: "1px solid #f1f5f9", padding: "20px 20px 24px" }}>

// // //                       {u.transactions.length === 0 ? (
// // //                         <p style={{ fontSize: 13, color: "#94a3b8", fontStyle: "italic" }}>No transactions yet.</p>
// // //                       ) : (
// // //                         <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
// // //                           <h4 style={{ fontSize: 13, fontWeight: 700, color: "#374151", margin: 0 }}>
// // //                             Transactions ({u.transactions.length})
// // //                           </h4>

// // //                           {u.transactions.map(tx => {
// // //                             const includes = getPlanIncludes(tx.planId, tx.includes);
// // //                             // Find matching analysis for this transaction
// // //                             const analysis = u.analyses.find(a => a.transactionId === tx.id);

// // //                             return (
// // //                               <div key={tx.id} style={{ background: "#f8fafc", borderRadius: 12, padding: "16px 18px", border: "1px solid #e2e8f0" }}>

// // //                                 {/* Transaction header */}
// // //                                 <div className="transaction-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
// // //                                   <div>
// // //                                     <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
// // //                                       <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{getPlanName(tx.planId)}</span>
// // //                                       <span style={{ fontSize: 11, background: "#eff6ff", color: "#2563eb", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: "1px solid #bfdbfe" }}>
// // //                                         {fmtMoney(getPlanPrice(tx.planId))}
// // //                                       </span>
// // //                                       <span style={{ fontSize: 11, background: tx.analysed ? "#f0fdf4" : "#fffbeb", color: tx.analysed ? "#059669" : "#d97706", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: `1px solid ${tx.analysed ? "#bbf7d0" : "#fde68a"}` }}>
// // //                                         {tx.analysed ? "✅ Analysed" : "⏳ Pending"}
// // //                                       </span>
// // //                                     </div>
// // //                                     <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4, wordBreak: "break-word" }}>
// // //                                       {fmtTime(tx.createdAt)} · TX: {tx.id?.slice(-8)?.toUpperCase()}
// // //                                     </div>
// // //                                   </div>
// // //                                   <div style={{ fontSize: 11, color: "#94a3b8", wordBreak: "break-word" }}>
// // //                                     Payment: {tx.paymentIntentId?.slice(-12)}
// // //                                   </div>
// // //                                 </div>

// // //                                 {/* Services included in this plan */}
// // //                                 <div style={{ marginBottom: 12 }}>
// // //                                   <div style={{ fontSize: 11, fontWeight: 600, color: "#64748b", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>Services in this plan</div>
// // //                                   <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
// // //                                     {includes.map(code => {
// // //                                       // Determine if service was actually used
// // //                                       let used = false;
// // //                                       if (code === "ATS_ANALYSIS") used = tx.analysed;
// // //                                       if (code === "ATS_RESUME_SAMPLE") used = tx.resumeGenerated;
// // //                                       if (code === "DOCUMENT_SUMMARY") used = tx.documentSummarized;
// // //                                       if (code === "DOCUMENT_CHAT") used = tx.documentChatUsed;
// // //                                       return (
// // //                                         <div key={code} style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
// // //                                           <ServiceTag code={code} used={used} />
// // //                                           {code === "ATS_RESUME_SAMPLE" && tx.resumeTemplateId && (() => {
// // //                                             const tmpl = servicesConfig.resumeTemplates?.find(r => r.id === tx.resumeTemplateId);
// // //                                             return (
// // //                                               <span style={{ fontSize: 10, background: `${tmpl?.accent || "#2563eb"}15`, color: tmpl?.accent || "#2563eb", padding: "2px 8px", borderRadius: 20, fontWeight: 700, border: `1px solid ${tmpl?.accent || "#2563eb"}25`, display: "inline-flex", alignItems: "center", gap: 3 }}>
// // //                                                 <span style={{ width: 6, height: 6, borderRadius: "50%", background: tmpl?.accent || "#2563eb", display: "inline-block" }} />
// // //                                                 {tmpl?.name || tx.resumeTemplateId}
// // //                                               </span>
// // //                                             );
// // //                                           })()}
// // //                                         </div>
// // //                                       );
// // //                                     })}
// // //                                   </div>
// // //                                 </div>

// // //                                 {/* Analysis details if done */}
// // //                                 {analysis && (
// // //                                   <div style={{ background: "#fff", borderRadius: 8, padding: "12px 14px", border: "1px solid #e2e8f0" }}>
// // //                                     <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 8 }}>Analysis Result</div>
// // //                                     <div className="analysis-details" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
// // //                                       <div style={{ textAlign: "center" }}>
// // //                                         <div style={{ fontSize: "clamp(18px, 6vw, 22px)", fontWeight: 800, color: analysis.ats_score >= 70 ? "#059669" : analysis.ats_score >= 50 ? "#d97706" : "#dc2626" }}>
// // //                                           {analysis.ats_score}
// // //                                         </div>
// // //                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>ATS SCORE</div>
// // //                                       </div>
// // //                                       <div style={{ textAlign: "center" }}>
// // //                                         <div style={{ fontSize: "clamp(18px, 6vw, 22px)", fontWeight: 800, color: "#374151" }}>{analysis.match_rate || "—"}%</div>
// // //                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>MATCH RATE</div>
// // //                                       </div>
// // //                                       <div style={{ textAlign: "center" }}>
// // //                                         <div style={{ fontSize: "clamp(18px, 6vw, 22px)", fontWeight: 800, color: "#374151" }}>{analysis.missing_count || 0}</div>
// // //                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>MISSING KW</div>
// // //                                       </div>
// // //                                       <div style={{ flex: 1, minWidth: 160 }}>
// // //                                         <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
// // //                                           {analysis.summary?.slice(0, 120)}{analysis.summary?.length > 120 ? "..." : ""}
// // //                                         </div>
// // //                                       </div>
// // //                                     </div>
// // //                                     <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>
// // //                                       Completed {fmtTime(analysis.createdAt)}
// // //                                     </div>
// // //                                   </div>
// // //                                 )}
// // //                               </div>
// // //                             );
// // //                           })}
// // //                         </div>
// // //                       )}
// // //                     </div>
// // //                   )}
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </>
// // //         ))}
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // // ─────────────────────────────────────────────
// // // // PLANS & SERVICES TAB (with responsive styles)
// // // // ─────────────────────────────────────────────
// // // function PlansTab() {
// // //   const plans    = servicesConfig.plans;
// // //   const services = servicesConfig.services;

// // //   return (
// // //     <div style={{ display: "flex", flexDirection: "column", gap: 28 }}>

// // //       {/* ── PLANS ── */}
// // //       <div>
// // //         <h2 style={{ fontSize: "clamp(14px, 4vw, 16px)", fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>
// // //           Plans ({plans.length})
// // //         </h2>
// // //         <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
// // //           {plans.map(plan => (
// // //             <div key={plan.id} style={{ background: "#fff", borderRadius: 14, border: `1.5px solid ${plan.active ? "#bfdbfe" : "#e2e8f0"}`, overflow: "hidden" }}>

// // //               {/* Plan header */}
// // //               <div className="plan-header" style={{ padding: "16px 20px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap", background: plan.active ? "#f0f7ff" : "#f8fafc" }}>
// // //                 <div style={{ flex: 1, minWidth: 200 }}>
// // //                   <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 4 }}>
// // //                     <span style={{ fontSize: "clamp(14px, 4vw, 15px)", fontWeight: 800, color: "#0f172a" }}>{plan.name}</span>
// // //                     <span style={{ fontSize: 11, background: plan.active ? "#dcfce7" : "#f1f5f9", color: plan.active ? "#059669" : "#94a3b8", padding: "2px 8px", borderRadius: 20, fontWeight: 700, border: `1px solid ${plan.active ? "#bbf7d0" : "#e2e8f0"}` }}>
// // //                       {plan.active ? "● Active" : "○ Coming Soon"}
// // //                     </span>
// // //                     <span style={{ fontSize: 11, background: plan.enabled ? "#eff6ff" : "#f8fafc", color: plan.enabled ? "#2563eb" : "#94a3b8", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: `1px solid ${plan.enabled ? "#bfdbfe" : "#e2e8f0"}` }}>
// // //                       {plan.enabled ? "Visible" : "Hidden"}
// // //                     </span>
// // //                     {plan.badge && (
// // //                       <span style={{ fontSize: 11, background: "#fef3c7", color: "#d97706", padding: "2px 8px", borderRadius: 20, fontWeight: 700, border: "1px solid #fde68a" }}>
// // //                         {plan.badge}
// // //                       </span>
// // //                     )}
// // //                   </div>
// // //                   <div style={{ fontSize: 13, color: "#64748b" }}>{plan.description}</div>
// // //                 </div>
// // //                 <div className="plan-price" style={{ textAlign: "right" }}>
// // //                   <div style={{ fontSize: "clamp(20px, 6vw, 26px)", fontWeight: 800, color: "#1d4ed8" }}>{plan.price}</div>
// // //                   <div style={{ fontSize: 11, color: "#94a3b8" }}>{plan.period}</div>
// // //                 </div>
// // //               </div>

// // //               {/* Plan body - responsive grid */}
// // //               <div className="plan-body-grid" style={{ padding: "16px 20px", display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
// // //                 {/* Included services */}
// // //                 <div>
// // //                   <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.05em" }}>
// // //                     Services ({plan.includes?.length || 0})
// // //                   </div>
// // //                   <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
// // //                     {(plan.includes || []).map(code => {
// // //                       const svc = services.find(s => s.serviceCode === code);
// // //                       return (
// // //                         <div key={code} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
// // //                           <span style={{ fontSize: 15, flexShrink: 0 }}>{svc?.icon || "•"}</span>
// // //                           <div style={{ flex: 1, minWidth: 0 }}>
// // //                             <div style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>{svc?.title || code}</div>
// // //                             <div style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>{svc?.serviceCode}</div>
// // //                           </div>
// // //                           {svc?.isFree && <span style={{ fontSize: 10, background: "#dcfce7", color: "#166534", padding: "1px 6px", borderRadius: 10, fontWeight: 700, flexShrink: 0 }}>FREE</span>}
// // //                           <span style={{ fontSize: 10, background: svc?.active ? "#f0fdf4" : "#fef3c7", color: svc?.active ? "#059669" : "#d97706", padding: "1px 6px", borderRadius: 10, fontWeight: 600, flexShrink: 0 }}>
// // //                             {svc?.active ? "✓" : "⏳"}
// // //                           </span>
// // //                         </div>
// // //                       );
// // //                     })}
// // //                   </div>
// // //                 </div>

// // //                 {/* Resume Templates */}
// // //                 <div>
// // //                   <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.05em" }}>
// // //                     Resume Templates ({plan.resumeTemplateIds?.length || 0}) · Pick {plan.resumeTemplateCount ?? "∞"}
// // //                   </div>
// // //                   <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
// // //                     {(plan.resumeTemplateIds || []).map(tmplId => {
// // //                       const tmpl = servicesConfig.resumeTemplates?.find(r => r.id === tmplId);
// // //                       return (
// // //                         <div key={tmplId} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
// // //                           <div style={{ width: 10, height: 10, borderRadius: "50%", background: tmpl?.accent || "#2563eb", flexShrink: 0 }} />
// // //                           <span style={{ fontSize: 12, fontWeight: 600, color: "#374151", flex: 1 }}>{tmpl?.name || tmplId}</span>
// // //                           <span style={{ fontSize: 10, background: tmpl?.active ? "#f0fdf4" : "#f8fafc", color: tmpl?.active ? "#059669" : "#94a3b8", padding: "1px 6px", borderRadius: 10, fontWeight: 600 }}>
// // //                             {tmpl?.active ? "✓ Active" : "Inactive"}
// // //                           </span>
// // //                         </div>
// // //                       );
// // //                     })}
// // //                     {(!plan.resumeTemplateIds || plan.resumeTemplateIds.length === 0) && (
// // //                       <div style={{ fontSize: 12, color: "#94a3b8", fontStyle: "italic" }}>No templates configured</div>
// // //                     )}
// // //                   </div>
// // //                 </div>

// // //                 {/* Features list */}
// // //                 <div>
// // //                   <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.05em" }}>
// // //                     Features
// // //                   </div>
// // //                   <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
// // //                     {(plan.features || []).map(f => (
// // //                       <div key={f.text} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: f.included ? "#374151" : "#cbd5e1" }}>
// // //                         <span style={{ fontSize: 10 }}>{f.included ? "✅" : "❌"}</span>
// // //                         <span>{f.text}</span>
// // //                       </div>
// // //                     ))}
// // //                   </div>
// // //                 </div>
// // //               </div>

// // //               {/* Config hint */}
// // //               <div style={{ padding: "10px 20px", background: "#f8fafc", borderTop: "1px solid #f1f5f9", fontSize: 10, color: "#94a3b8", fontFamily: "monospace", display: "flex", gap: 16, flexWrap: "wrap" }}>
// // //                 <span>id: "{plan.id}"</span>
// // //                 <span>priceInCents: {plan.priceInCents}</span>
// // //                 <span>templateCount: {plan.resumeTemplateCount ?? "unlimited"}</span>
// // //                 <span>includes: [{(plan.includes || []).join(", ")}]</span>
// // //               </div>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>

// // //       {/* ── SERVICES ── */}
// // //       <div>
// // //         <h2 style={{ fontSize: "clamp(14px, 4vw, 16px)", fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>
// // //           Services ({services.length})
// // //         </h2>
// // //         <div className="services-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 12 }}>
// // //           {services.map(svc => {
// // //             const plan = plans.find(p => p.id === svc.planId);
// // //             return (
// // //               <div key={svc.serviceCode} style={{ background: "#fff", borderRadius: 12, border: `1.5px solid ${svc.active ? "#bbf7d0" : svc.comingSoon ? "#fde68a" : "#e2e8f0"}`, padding: "16px" }}>

// // //                 {/* Header */}
// // //                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
// // //                   <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
// // //                     <span style={{ fontSize: 22 }}>{svc.icon}</span>
// // //                     <div>
// // //                       <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{svc.title}</div>
// // //                       <div style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>{svc.serviceCode}</div>
// // //                     </div>
// // //                   </div>
// // //                   <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-end" }}>
// // //                     <span style={{ fontSize: 10, background: svc.active ? "#dcfce7" : svc.comingSoon ? "#fffbeb" : "#f1f5f9", color: svc.active ? "#059669" : svc.comingSoon ? "#d97706" : "#94a3b8", padding: "2px 8px", borderRadius: 10, fontWeight: 700 }}>
// // //                       {svc.active ? "● Active" : svc.comingSoon ? "⏳ Soon" : "○ Inactive"}
// // //                     </span>
// // //                     {svc.isFree && (
// // //                       <span style={{ fontSize: 10, background: "#dcfce7", color: "#166534", padding: "2px 8px", borderRadius: 10, fontWeight: 700 }}>FREE</span>
// // //                     )}
// // //                   </div>
// // //                 </div>

// // //                 {/* Description */}
// // //                 <p style={{ fontSize: 12, color: "#64748b", lineHeight: 1.6, marginBottom: 10 }}>{svc.description}</p>

// // //                 {/* Highlights */}
// // //                 <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 10 }}>
// // //                   {svc.highlights.map(h => (
// // //                     <span key={h} style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, background: "#eff6ff", color: "#2563eb", fontWeight: 600 }}>{h}</span>
// // //                   ))}
// // //                 </div>

// // //                 {/* Plan link */}
// // //                 <div style={{ fontSize: 11, color: "#64748b", borderTop: "1px solid #f1f5f9", paddingTop: 8, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
// // //                   <span>Plan: <strong>{plan?.name || (svc.isFree ? "Free with parent plan" : "None")}</strong></span>
// // //                   {svc.route && <span style={{ color: "#2563eb", fontFamily: "monospace", wordBreak: "break-word" }}>{svc.route}</span>}
// // //                 </div>

// // //                 {/* Visibility flags */}
// // //                 <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 6, display: "flex", gap: 10, flexWrap: "wrap" }}>
// // //                   <span style={{ color: svc.enabled ? "#059669" : "#ef4444" }}>{svc.enabled ? "✓ Enabled" : "✗ Disabled"}</span>
// // //                   <span style={{ color: svc.active ? "#059669" : "#94a3b8" }}>{svc.active ? "✓ Active" : "✗ Inactive"}</span>
// // //                   <span style={{ color: svc.comingSoon ? "#d97706" : "#94a3b8" }}>{svc.comingSoon ? "⏳ Coming Soon" : "✓ Live"}</span>
// // //                 </div>
// // //               </div>
// // //             );
// // //           })}
// // //         </div>
// // //       </div>

// // //       {/* ── RESUME TEMPLATES ── */}
// // //       {servicesConfig.resumeTemplates?.length > 0 && (
// // //         <div>
// // //           <h2 style={{ fontSize: "clamp(14px, 4vw, 16px)", fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>
// // //             Resume Templates ({servicesConfig.resumeTemplates.length})
// // //           </h2>
// // //           <div className="templates-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 12 }}>
// // //             {servicesConfig.resumeTemplates.map(tmpl => (
// // //               <div key={tmpl.id} style={{ background: "#fff", borderRadius: 12, border: `2px solid ${tmpl.accent}30`, overflow: "hidden" }}>
// // //                 {/* Color header bar */}
// // //                 <div style={{ height: 6, background: `linear-gradient(90deg,${tmpl.accent},${tmpl.headerBg})` }} />
// // //                 <div style={{ padding: "14px 16px" }}>
// // //                   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
// // //                     <div>
// // //                       <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 2 }}>{tmpl.name}</div>
// // //                       <div style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>{tmpl.id}</div>
// // //                     </div>
// // //                     <span style={{ fontSize: 10, background: tmpl.active ? "#dcfce7" : "#f1f5f9", color: tmpl.active ? "#059669" : "#94a3b8", padding: "2px 8px", borderRadius: 10, fontWeight: 700, flexShrink: 0 }}>
// // //                       {tmpl.active ? "● Active" : "○ Inactive"}
// // //                     </span>
// // //                   </div>
// // //                   <p style={{ fontSize: 11, color: "#64748b", lineHeight: 1.5, marginBottom: 10 }}>{tmpl.description}</p>
// // //                   <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 10 }}>
// // //                     {tmpl.tags.map(tag => (
// // //                       <span key={tag} style={{ fontSize: 10, padding: "2px 7px", borderRadius: 20, background: `${tmpl.accent}12`, color: tmpl.accent, fontWeight: 600 }}>{tag}</span>
// // //                     ))}
// // //                   </div>
// // //                   <div style={{ display: "flex", gap: 8, fontSize: 10, color: "#94a3b8", flexWrap: "wrap" }}>
// // //                     <span>Accent: <strong style={{ color: tmpl.accent }}>{tmpl.accent}</strong></span>
// // //                     <span>Header: <strong style={{ color: tmpl.headerBg }}>{tmpl.headerBg}</strong></span>
// // //                   </div>
// // //                   {/* Which plans include this template */}
// // //                   <div style={{ marginTop: 8, paddingTop: 8, borderTop: "1px solid #f1f5f9" }}>
// // //                     <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 4 }}>Used in plans:</div>
// // //                     <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
// // //                       {plans.filter(p => p.resumeTemplateIds?.includes(tmpl.id)).map(p => (
// // //                         <span key={p.id} style={{ fontSize: 10, background: "#eff6ff", color: "#2563eb", padding: "1px 7px", borderRadius: 10, fontWeight: 600 }}>{p.name}</span>
// // //                       ))}
// // //                     </div>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* ── CONFIG GUIDE ── */}
// // //       <div style={{ background: "#0f172a", borderRadius: 14, padding: "24px", color: "#e2e8f0" }}>
// // //         <h3 style={{ fontSize: "clamp(13px, 4vw, 14px)", fontWeight: 700, color: "#fff", marginBottom: 16 }}>⚙️ Configuration Guide</h3>
// // //         <div className="config-guide-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: 20 }}>
// // //           {[
// // //             { title: "Launch a new plan", steps: ["Add plan to servicesConfig.js plans[]", "Set enabled: true, active: true", "Add price to backend/server.js PLAN_PRICES", "Redeploy backend"] },
// // //             { title: "Activate a service", steps: ["Set active: true in servicesConfig.js", "Set comingSoon: false", "Add serviceCode to plan includes[]", "Build the route/page first"] },
// // //             { title: "Change a price", steps: ["Update priceInCents in servicesConfig.js", "Update PLAN_PRICES in backend/server.js", "Redeploy backend only"] },
// // //             { title: "Hide a plan/service", steps: ["Set enabled: false to hide everywhere", "Set active: false to hide from dashboard", "Keep comingSoon: true to show teaser"] },
// // //           ].map(guide => (
// // //             <div key={guide.title}>
// // //               <div style={{ fontSize: 12, fontWeight: 700, color: "#60a5fa", marginBottom: 8 }}>{guide.title}</div>
// // //               <ol style={{ margin: 0, paddingLeft: 18 }}>
// // //                 {guide.steps.map((step, i) => (
// // //                   <li key={i} style={{ fontSize: 12, color: "#94a3b8", lineHeight: 1.7 }}>{step}</li>
// // //                 ))}
// // //               </ol>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>

// // //     </div>
// // //   );
// // // }

// // // new code for refund logic
// // import { useState, useEffect, useCallback } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { useAuth } from "../hooks/useAuth";
// // import {
// //   collection, getDocs, doc, updateDoc, serverTimestamp,
// // } from "firebase/firestore";
// // import { db } from "../utils/firebase";
// // import servicesConfig from "../utils/servicesConfig";
// // import apiConfig from "../utils/apiConfig";

// // const ADMIN_EMAILS  = ["arsh1916@gmail.com", "support@smartaicareer.com"];
// // const ADMIN_SECRET  = process.env.REACT_APP_ADMIN_SECRET || "";
// // const BACKEND       = apiConfig?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";

// // // ── Helpers ──
// // function fmtDate(ts) {
// //   if (!ts) return "—";
// //   const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
// //   return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
// // }
// // function fmtTime(ts) {
// //   if (!ts) return "—";
// //   const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
// //   return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
// // }
// // function fmtMoney(cents) { return `$${(cents / 100).toFixed(2)}`; }
// // function getPlanPrice(planId) {
// //   return servicesConfig.plans.find(p => p.id === planId)?.priceInCents || 199;
// // }
// // function getPlanName(planId) {
// //   return servicesConfig.plans.find(p => p.id === planId)?.name || planId || "Unknown";
// // }
// // function getPlanIncludes(planId, includes) {
// //   if (Array.isArray(includes) && includes.length > 0) return includes;
// //   return servicesConfig.plans.find(p => p.id === planId)?.includes || [];
// // }

// // // ── Stat card ──
// // function StatCard({ label, value, sub, color = "#2563eb", icon }) {
// //   return (
// //     <div style={{ background: "#fff", borderRadius: 14, padding: "20px 22px", border: "1px solid #e2e8f0", flex: 1, minWidth: 140 }}>
// //       <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
// //         <div style={{ width: 36, height: 36, borderRadius: 10, background: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>{icon}</div>
// //         <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</span>
// //       </div>
// //       <div style={{ fontSize: 28, fontWeight: 800, color: "#0f172a", letterSpacing: "-0.02em" }}>{value}</div>
// //       {sub && <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{sub}</div>}
// //     </div>
// //   );
// // }

// // // ── Service tag ──
// // function ServiceTag({ code, used }) {
// //   const svc = servicesConfig.services.find(s => s.serviceCode === code);
// //   return (
// //     <span style={{
// //       display: "inline-flex", alignItems: "center", gap: 4,
// //       fontSize: 11, padding: "3px 8px", borderRadius: 20, fontWeight: 600,
// //       background: used ? "#f0fdf4" : "#f8fafc",
// //       color: used ? "#059669" : "#94a3b8",
// //       border: `1px solid ${used ? "#bbf7d0" : "#e2e8f0"}`,
// //     }}>
// //       {svc?.icon || "•"} {svc?.title || code}
// //       {used ? " ✓" : " —"}
// //     </span>
// //   );
// // }

// // // ── Refund button — handles the full flow ──
// // function RefundButton({ uid, tx, userEmail, userName, onRefunded }) {
// //   const [state,  setState]  = useState("idle"); // idle | confirm | loading | done | error
// //   const [error,  setError]  = useState("");
// //   const [reason, setReason] = useState("requested_by_customer");

// //   const REASONS = [
// //     { value: "requested_by_customer", label: "Requested by customer" },
// //     { value: "duplicate",             label: "Duplicate charge" },
// //     { value: "fraudulent",            label: "Fraudulent" },
// //     { value: "service_not_delivered", label: "Service not delivered" },
// //   ];

// //   // Already refunded — show badge only
// //   if (tx.refunded) {
// //     return (
// //       <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
// //         <span style={{ fontSize: 11, background: "#fef2f2", color: "#dc2626", padding: "3px 10px", borderRadius: 20, fontWeight: 700, border: "1px solid #fecaca" }}>
// //           ↩ Refunded {tx.refundAmount ? fmtMoney(tx.refundAmount) : ""} · {fmtDate(tx.refundedAt)}
// //         </span>
// //         {tx.refundId && (
// //           <span style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>
// //             {tx.refundId.slice(-8)}
// //           </span>
// //         )}
// //       </div>
// //     );
// //   }

// //   async function handleRefund() {
// //     setState("loading");
// //     setError("");
// //     try {
// //       // Step 1 — call server to issue Stripe refund
// //       console.log("ADMIN_SECRET being sent:", ADMIN_SECRET);
// //       const res = await fetch(`${BACKEND}/admin/refund`, {
// //         method:  "POST",
// //         headers: {
// //           "Content-Type":  "application/json",
// //           "x-admin-token": ADMIN_SECRET,
// //         },
// //         body: JSON.stringify({
// //           paymentIntentId: tx.paymentIntentId,
// //           reason,
// //         }),
// //       });

// //       const data = await res.json();
// //       if (!res.ok) throw new Error(data.error || "Refund failed");

// //       // Step 2 — record refund in Firestore on the transaction doc
// //       await updateDoc(doc(db, "users", uid, "transactions", tx.id), {
// //         refunded:    true,
// //         refundId:    data.refundId,
// //         refundAmount: data.amount,
// //         refundReason: reason,
// //         refundStatus: data.status,
// //         refundedAt:  serverTimestamp(),
// //         refundedBy:  "admin",
// //       });

// //       setState("done");
// //       onRefunded(tx.id, {
// //         refunded:     true,
// //         refundId:     data.refundId,
// //         refundAmount: data.amount,
// //         refundReason: reason,
// //         refundStatus: data.status,
// //       });

// //       // Send refund confirmation email — non-blocking
// //       // Send refund confirmation email — non-blocking
// //       fetch(`${BACKEND}/email/refund`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({
// //           userEmail:     userEmail,   // ← prop, not u.email
// //           userName:      userName,    // ← prop, not u.firstName
// //           amount:        fmtMoney(data.amount),
// //           reason:        reason,
// //           transactionId: tx.id?.slice(-8)?.toUpperCase(),
// //         }),
// //       }).catch(err => console.warn("Refund email failed (non-critical):", err.message));


// //     } catch (err) {
// //       console.error("Refund error:", err.message);
// //       setError(err.message);
// //       setState("error");
// //     }
// //   }

// //   if (state === "done") {
// //     return (
// //       <span style={{ fontSize: 11, background: "#f0fdf4", color: "#059669", padding: "3px 10px", borderRadius: 20, fontWeight: 700, border: "1px solid #bbf7d0" }}>
// //         ✓ Refund issued
// //       </span>
// //     );
// //   }

// //   if (state === "confirm") {
// //     return (
// //       <div style={{ background: "#fef2f2", borderRadius: 10, padding: "12px 14px", border: "1px solid #fecaca", marginTop: 8 }}>
// //         <div style={{ fontSize: 12, fontWeight: 700, color: "#dc2626", marginBottom: 8 }}>
// //           Confirm refund of {fmtMoney(getPlanPrice(tx.planId))} to this user?
// //         </div>
// //         <div style={{ marginBottom: 10 }}>
// //           <select
// //             value={reason}
// //             onChange={e => setReason(e.target.value)}
// //             style={{ width: "100%", padding: "6px 10px", border: "1px solid #fecaca", borderRadius: 7, fontSize: 12, background: "#fff" }}
// //           >
// //             {REASONS.map(r => (
// //               <option key={r.value} value={r.value}>{r.label}</option>
// //             ))}
// //           </select>
// //         </div>
// //         <div style={{ display: "flex", gap: 8 }}>
// //           <button
// //             onClick={handleRefund}
// //             style={{ padding: "6px 14px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer" }}
// //           >
// //             Yes, refund now
// //           </button>
// //           <button
// //             onClick={() => setState("idle")}
// //             style={{ padding: "6px 14px", background: "#fff", color: "#64748b", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, cursor: "pointer" }}
// //           >
// //             Cancel
// //           </button>
// //         </div>
// //         {state === "error" && (
// //           <div style={{ fontSize: 12, color: "#dc2626", marginTop: 8 }}>{error}</div>
// //         )}
// //       </div>
// //     );
// //   }

// //   if (state === "loading") {
// //     return (
// //       <span style={{ fontSize: 12, color: "#64748b", display: "flex", alignItems: "center", gap: 6 }}>
// //         <span style={{ width: 12, height: 12, borderRadius: "50%", border: "2px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.7s linear infinite", display: "inline-block" }} />
// //         Processing refund...
// //       </span>
// //     );
// //   }

// //   return (
// //     <div>
// //       <button
// //         onClick={() => setState("confirm")}
// //         style={{ padding: "5px 12px", background: "#fff", color: "#dc2626", border: "1.5px solid #fca5a5", borderRadius: 7, fontSize: 11, fontWeight: 700, cursor: "pointer", transition: "all 0.15s" }}
// //         onMouseEnter={e => { e.currentTarget.style.background = "#fef2f2"; }}
// //         onMouseLeave={e => { e.currentTarget.style.background = "#fff"; }}
// //       >
// //         ↩ Issue Refund
// //       </button>
// //       {state === "error" && (
// //         <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>{error}</div>
// //       )}
// //     </div>
// //   );
// // }

// // export default function AdminPage() {
// //   const { user } = useAuth();
// //   const navigate = useNavigate();

// //   const [activeTab,   setActiveTab]   = useState("users");
// //   const [loading,     setLoading]     = useState(true);
// //   const [users,       setUsers]       = useState([]);
// //   const [filter,      setFilter]      = useState("all");
// //   const [planFilter,  setPlanFilter]  = useState("all");
// //   const [search,      setSearch]      = useState("");
// //   const [expanded,    setExpanded]    = useState(null);
// //   const [sortBy,      setSortBy]      = useState("recent");

// //   useEffect(() => {
// //     if (!user) { navigate("/login"); return; }
// //     if (!ADMIN_EMAILS.includes(user.email)) { navigate("/dashboard"); return; }
// //   }, [user, navigate]);

// //   const loadData = useCallback(async () => {
// //     setLoading(true);
// //     try {
// //       const usersSnap = await getDocs(collection(db, "users"));
// //       const usersData = [];

// //       for (const userDoc of usersSnap.docs) {
// //         const userData = userDoc.data();
// //         const uid = userDoc.id;

// //         const txSnap = await getDocs(collection(db, "users", uid, "transactions"));
// //         const transactions = txSnap.docs.map(d => ({ id: d.id, ...d.data() }))
// //           .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //         const analysesSnap = await getDocs(collection(db, "users", uid, "analyses"));
// //         const analyses = analysesSnap.docs.map(d => ({ id: d.id, ...d.data() }))
// //           .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //         const paidTransactions = transactions.filter(t => t.status === "paid");
// //         const totalRevenue = paidTransactions.reduce((sum, t) => sum + getPlanPrice(t.planId), 0);
// //         const refundedAmount = paidTransactions
// //           .filter(t => t.refunded)
// //           .reduce((sum, t) => sum + (t.refundAmount || getPlanPrice(t.planId)), 0);

// //         const firstName = userData.firstName || userData.displayName?.split(" ")[0] || "";
// //         const lastName  = userData.lastName  || userData.displayName?.split(" ").slice(1).join(" ") || "";
// //         const email     = userData.email     || uid;

// //         const templatesUsed = transactions
// //           .filter(t => t.resumeGenerated && t.resumeTemplateId)
// //           .map(t => t.resumeTemplateId);
// //         const templateCounts = templatesUsed.reduce((acc, t) => {
// //           acc[t] = (acc[t] || 0) + 1; return acc;
// //         }, {});

// //         usersData.push({
// //           uid, email, firstName, lastName,
// //           createdAt:             userData.createdAt,
// //           lastPaymentAt:         userData.lastPaymentAt,
// //           totalPayments:         userData.totalPayments  || paidTransactions.length,
// //           totalAnalyses:         userData.totalAnalyses  || transactions.filter(t => t.analysed).length,
// //           totalResumesGenerated: userData.totalResumesGenerated || transactions.filter(t => t.resumeGenerated).length,
// //           transactions:          paidTransactions,
// //           analyses,
// //           totalRevenue,
// //           refundedAmount,
// //           templateCounts,
// //         });
// //       }

// //       setUsers(usersData);
// //     } catch (err) {
// //       console.error("Admin load error:", err);
// //     }
// //     setLoading(false);
// //   }, []);

// //   useEffect(() => {
// //     if (user && ADMIN_EMAILS.includes(user.email)) loadData();
// //   }, [user, loadData]);

// //   // ── Update a transaction locally after refund — no reload needed ──
// //   function handleRefunded(uid, txId, refundData) {
// //     setUsers(prev => prev.map(u => {
// //       if (u.uid !== uid) return u;
// //       return {
// //         ...u,
// //         refundedAmount: (u.refundedAmount || 0) + (refundData.refundAmount || 0),
// //         transactions: u.transactions.map(t =>
// //           t.id === txId ? { ...t, ...refundData } : t
// //         ),
// //       };
// //     }));
// //   }

// //   // ── Derived stats ──
// //   const totalUsers      = users.length;
// //   const totalRevenue    = users.reduce((s, u) => s + u.totalRevenue, 0);
// //   const totalRefunded   = users.reduce((s, u) => s + (u.refundedAmount || 0), 0);
// //   const totalTx         = users.reduce((s, u) => s + u.transactions.length, 0);
// //   const totalAnalyses   = users.reduce((s, u) => s + u.totalAnalyses, 0);
// //   const pendingUsers    = users.filter(u => u.transactions.some(t => !t.analysed)).length;
// //   const refundedCount   = users.reduce((s, u) => s + u.transactions.filter(t => t.refunded).length, 0);

// //   const filteredUsers = users
// //     .filter(u => {
// //       if (search) {
// //         const q = search.toLowerCase();
// //         if (!u.email.toLowerCase().includes(q) &&
// //             !`${u.firstName} ${u.lastName}`.toLowerCase().includes(q)) return false;
// //       }
// //       if (planFilter !== "all") {
// //         if (!u.transactions.some(t => t.planId === planFilter)) return false;
// //       }
// //       if (filter === "paid")     return u.transactions.length > 0;
// //       if (filter === "analysed") return u.totalAnalyses > 0;
// //       if (filter === "pending")  return u.transactions.some(t => t.status === "paid" && !t.analysed);
// //       if (filter === "refunded") return u.transactions.some(t => t.refunded);
// //       return true;
// //     })
// //     .sort((a, b) => {
// //       if (sortBy === "revenue") return b.totalRevenue - a.totalRevenue;
// //       if (sortBy === "name")    return `${a.firstName}${a.lastName}`.localeCompare(`${b.firstName}${b.lastName}`);
// //       return (b.lastPaymentAt?.seconds || b.createdAt?.seconds || 0) - (a.lastPaymentAt?.seconds || a.createdAt?.seconds || 0);
// //     });

// //   if (!user || !ADMIN_EMAILS.includes(user?.email)) return null;

// //   return (
// //     <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Inter',-apple-system,sans-serif" }}>
// //       <style>{`
// //         * { box-sizing: border-box; }
// //         @keyframes spin { to { transform: rotate(360deg); } }
// //         @media (max-width: 768px) {
// //           .admin-stats { flex-wrap: wrap !important; }
// //           .admin-stats > div { min-width: calc(50% - 8px) !important; }
// //           .admin-filters { flex-wrap: wrap !important; }
// //           .plan-body-grid { grid-template-columns: 1fr !important; gap: 20px !important; }
// //           .services-grid { grid-template-columns: 1fr !important; }
// //           .templates-grid { grid-template-columns: 1fr !important; }
// //           .revenue-breakdown { flex-direction: column !important; }
// //           .user-row { flex-wrap: wrap !important; }
// //           .filter-buttons { flex-wrap: wrap !important; }
// //           .transaction-header { flex-direction: column !important; align-items: flex-start !important; }
// //           .analysis-details { flex-direction: column !important; align-items: flex-start !important; }
// //         }
// //         @media (max-width: 480px) {
// //           .admin-stats > div { min-width: 100% !important; }
// //         }
// //       `}</style>

// //       {/* NAV */}
// //       <nav style={{ background: "#0f172a", padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
// //         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
// //           <div style={{ width: 32, height: 32, background: "linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
// //             <span style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>R</span>
// //           </div>
// //           <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>ResumeScoreAI</span>
// //           <span style={{ background: "#1e293b", color: "#94a3b8", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>Admin</span>
// //         </div>
// //         <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
// //           <div style={{ display: "flex", background: "#1e293b", borderRadius: 9, padding: 3, gap: 2 }}>
// //             {[{ id: "users", label: "👥 Users" }, { id: "plans", label: "📦 Plans" }].map(tab => (
// //               <button key={tab.id} onClick={() => setActiveTab(tab.id)}
// //                 style={{ padding: "6px 12px", borderRadius: 7, border: "none", fontSize: 12, fontWeight: 600, cursor: "pointer", background: activeTab === tab.id ? "#fff" : "transparent", color: activeTab === tab.id ? "#0f172a" : "#64748b", transition: "all 0.2s" }}
// //               >{tab.label}</button>
// //             ))}
// //           </div>
// //           <button onClick={loadData} style={{ padding: "7px 14px", background: "#1e293b", color: "#94a3b8", border: "1px solid #334155", borderRadius: 8, fontSize: 13, cursor: "pointer" }}>🔄 Refresh</button>
// //           <button onClick={() => navigate("/dashboard")} style={{ padding: "7px 14px", background: "transparent", color: "#64748b", border: "1px solid #334155", borderRadius: 8, fontSize: 13, cursor: "pointer" }}>← Dashboard</button>
// //         </div>
// //       </nav>

// //       <div style={{ maxWidth: 1300, margin: "0 auto", padding: "24px 16px" }}>
// //         <div style={{ marginBottom: 24 }}>
// //           <h1 style={{ fontSize: "clamp(22px,6vw,26px)", fontWeight: 800, color: "#0f172a", marginBottom: 4, letterSpacing: "-0.02em" }}>Admin Dashboard</h1>
// //           <p style={{ fontSize: 14, color: "#64748b" }}>User transactions, refunds, and service utilization</p>
// //         </div>

// //         {activeTab === "plans" && <PlansTab />}

// //         {activeTab === "users" && (loading ? (
// //           <div style={{ textAlign: "center", padding: "80px 20px" }}>
// //             <div style={{ width: 40, height: 40, borderRadius: "50%", border: "4px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.8s linear infinite", margin: "0 auto 16px" }} />
// //             <p style={{ color: "#64748b", fontSize: 14 }}>Loading all user data...</p>
// //           </div>
// //         ) : (
// //           <>
// //             {/* STATS */}
// //             <div className="admin-stats" style={{ display: "flex", gap: 16, marginBottom: 28, flexWrap: "wrap" }}>
// //               <StatCard label="Total Users"    value={totalUsers}             icon="👥" color="#2563eb" sub={`${pendingUsers} with pending analysis`} />
// //               <StatCard label="Gross Revenue"  value={fmtMoney(totalRevenue)} icon="💰" color="#059669" sub={`${totalTx} transactions`} />
// //               <StatCard label="Refunded"       value={fmtMoney(totalRefunded)} icon="↩" color="#dc2626" sub={`${refundedCount} refunds issued`} />
// //               <StatCard label="Net Revenue"    value={fmtMoney(totalRevenue - totalRefunded)} icon="📈" color="#7c3aed" sub="after refunds" />
// //               <StatCard label="Analyses Done"  value={totalAnalyses}          icon="🎯" color="#0891b2" sub="completed analyses" />
// //             </div>

// //             {/* PLAN BREAKDOWN */}
// //             <div style={{ background: "#fff", borderRadius: 14, padding: "16px 20px", border: "1px solid #e2e8f0", marginBottom: 24 }}>
// //               <h3 style={{ fontSize: 14, fontWeight: 700, color: "#374151", marginBottom: 16 }}>Revenue by Plan</h3>
// //               <div className="revenue-breakdown" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
// //                 {servicesConfig.plans.filter(p => p.enabled).map(plan => {
// //                   const planTxs = users.flatMap(u => u.transactions.filter(t => t.planId === plan.id));
// //                   const planRevenue = planTxs.length * plan.priceInCents;
// //                   const planRefunds = planTxs.filter(t => t.refunded).length * plan.priceInCents;
// //                   return (
// //                     <div key={plan.id} style={{ flex: 1, minWidth: 150, background: "#f8fafc", borderRadius: 10, padding: "12px 14px", border: "1px solid #e2e8f0" }}>
// //                       <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 4 }}>{plan.name}</div>
// //                       <div style={{ fontSize: 22, fontWeight: 800, color: "#0f172a" }}>{fmtMoney(planRevenue)}</div>
// //                       {planRefunds > 0 && (
// //                         <div style={{ fontSize: 11, color: "#dc2626", marginTop: 2 }}>↩ {fmtMoney(planRefunds)} refunded</div>
// //                       )}
// //                       <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>{planTxs.length} purchases · {plan.price} each</div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>

// //             {/* FILTERS */}
// //             <div className="admin-filters" style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap", alignItems: "center" }}>
// //               <input
// //                 type="text" placeholder="🔍 Search by name or email..."
// //                 value={search} onChange={e => setSearch(e.target.value)}
// //                 style={{ padding: "9px 14px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 13, minWidth: 200, flex: "1 1 200px", outline: "none", background: "#fff" }}
// //               />
// //               <div className="filter-buttons" style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
// //                 {[
// //                   { id: "all",      label: "All Users" },
// //                   { id: "paid",     label: "💳 Paid" },
// //                   { id: "analysed", label: "✅ Analysed" },
// //                   { id: "pending",  label: "⏳ Pending" },
// //                   { id: "refunded", label: "↩ Refunded" },
// //                 ].map(f => (
// //                   <button key={f.id} onClick={() => setFilter(f.id)}
// //                     style={{ padding: "7px 12px", borderRadius: 8, border: "1px solid", fontSize: 12, fontWeight: 600, cursor: "pointer", borderColor: filter === f.id ? "#2563eb" : "#e2e8f0", background: filter === f.id ? "#eff6ff" : "#fff", color: filter === f.id ? "#2563eb" : "#64748b", whiteSpace: "nowrap" }}
// //                   >{f.label}</button>
// //                 ))}
// //               </div>
// //               <select value={planFilter} onChange={e => setPlanFilter(e.target.value)}
// //                 style={{ padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 12, fontWeight: 600, color: "#374151", background: "#fff", cursor: "pointer" }}>
// //                 <option value="all">All Plans</option>
// //                 {servicesConfig.plans.filter(p => p.enabled).map(p => (
// //                   <option key={p.id} value={p.id}>{p.name}</option>
// //                 ))}
// //               </select>
// //               <select value={sortBy} onChange={e => setSortBy(e.target.value)}
// //                 style={{ padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 12, fontWeight: 600, color: "#374151", background: "#fff", cursor: "pointer" }}>
// //                 <option value="recent">Sort: Most Recent</option>
// //                 <option value="revenue">Sort: Highest Revenue</option>
// //                 <option value="name">Sort: Name A–Z</option>
// //               </select>
// //               <span style={{ fontSize: 13, color: "#94a3b8", marginLeft: "auto" }}>{filteredUsers.length} of {totalUsers} users</span>
// //             </div>

// //             {/* USERS LIST */}
// //             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
// //               {filteredUsers.length === 0 ? (
// //                 <div style={{ textAlign: "center", padding: "48px", background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", color: "#94a3b8" }}>
// //                   No users match your filters.
// //                 </div>
// //               ) : filteredUsers.map(u => (
// //                 <div key={u.uid} style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>

// //                   {/* User row */}
// //                   <div
// //                     onClick={() => setExpanded(expanded === u.uid ? null : u.uid)}
// //                     className="user-row"
// //                     style={{ padding: "16px 20px", cursor: "pointer", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}
// //                   >
// //                     <div style={{ width: 42, height: 42, borderRadius: "50%", background: `linear-gradient(135deg,${["#2563eb","#7c3aed","#059669","#d97706"][u.uid.charCodeAt(0) % 4]},${["#1d4ed8","#6d28d9","#047857","#b45309"][u.uid.charCodeAt(0) % 4]})`, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: 15, flexShrink: 0 }}>
// //                       {(u.firstName?.[0] || u.email?.[0] || "?").toUpperCase()}
// //                     </div>
// //                     <div style={{ flex: 1, minWidth: 160 }}>
// //                       <div style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>
// //                         {u.firstName || u.lastName ? `${u.firstName} ${u.lastName}`.trim() : u.email?.split("@")[0] || "Unknown"}
// //                       </div>
// //                       <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{u.email}</div>
// //                     </div>
// //                     <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
// //                       <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.transactions.length > 0 ? "#eff6ff" : "#f8fafc", color: u.transactions.length > 0 ? "#2563eb" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.transactions.length > 0 ? "#bfdbfe" : "#e2e8f0" }}>
// //                         💳 {u.transactions.length} {u.transactions.length === 1 ? "payment" : "payments"}
// //                       </span>
// //                       <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.totalAnalyses > 0 ? "#f0fdf4" : "#f8fafc", color: u.totalAnalyses > 0 ? "#059669" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.totalAnalyses > 0 ? "#bbf7d0" : "#e2e8f0" }}>
// //                         🎯 {u.totalAnalyses} {u.totalAnalyses === 1 ? "analysis" : "analyses"}
// //                       </span>
// //                       {u.totalRevenue > 0 && (
// //                         <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#f0fdf4", color: "#059669", fontWeight: 700, border: "1px solid #bbf7d0" }}>
// //                           {fmtMoney(u.totalRevenue)}
// //                         </span>
// //                       )}
// //                       {u.refundedAmount > 0 && (
// //                         <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#fef2f2", color: "#dc2626", fontWeight: 700, border: "1px solid #fecaca" }}>
// //                           ↩ {fmtMoney(u.refundedAmount)}
// //                         </span>
// //                       )}
// //                       {u.transactions.some(t => !t.analysed && !t.refunded) && (
// //                         <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#fffbeb", color: "#d97706", fontWeight: 600, border: "1px solid #fde68a" }}>⏳ Pending</span>
// //                       )}
// //                     </div>
// //                     <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "right", minWidth: 90 }}>Joined {fmtDate(u.createdAt)}</div>
// //                     <span style={{ fontSize: 12, color: "#94a3b8", transition: "transform 0.2s", display: "inline-block", transform: expanded === u.uid ? "rotate(180deg)" : "rotate(0)" }}>▼</span>
// //                   </div>

// //                   {/* Expanded detail */}
// //                   {expanded === u.uid && (
// //                     <div style={{ borderTop: "1px solid #f1f5f9", padding: "20px 20px 24px" }}>
// //                       {u.transactions.length === 0 ? (
// //                         <p style={{ fontSize: 13, color: "#94a3b8", fontStyle: "italic" }}>No transactions yet.</p>
// //                       ) : (
// //                         <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
// //                           <h4 style={{ fontSize: 13, fontWeight: 700, color: "#374151", margin: 0 }}>
// //                             Transactions ({u.transactions.length})
// //                           </h4>

// //                           {u.transactions.map(tx => {
// //                             const includes  = getPlanIncludes(tx.planId, tx.includes);
// //                             const analysis  = u.analyses.find(a => a.transactionId === tx.id);

// //                             return (
// //                               <div key={tx.id} style={{ background: tx.refunded ? "#fef9f9" : "#f8fafc", borderRadius: 12, padding: "16px 18px", border: `1px solid ${tx.refunded ? "#fecaca" : "#e2e8f0"}` }}>

// //                                 {/* Transaction header */}
// //                                 <div className="transaction-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
// //                                   <div>
// //                                     <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
// //                                       <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{getPlanName(tx.planId)}</span>
// //                                       <span style={{ fontSize: 11, background: "#eff6ff", color: "#2563eb", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: "1px solid #bfdbfe" }}>
// //                                         {fmtMoney(getPlanPrice(tx.planId))}
// //                                       </span>
// //                                       <span style={{ fontSize: 11, background: tx.analysed ? "#f0fdf4" : "#fffbeb", color: tx.analysed ? "#059669" : "#d97706", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: `1px solid ${tx.analysed ? "#bbf7d0" : "#fde68a"}` }}>
// //                                         {tx.analysed ? "✅ Analysed" : "⏳ Pending"}
// //                                       </span>
// //                                       {tx.refunded && (
// //                                         <span style={{ fontSize: 11, background: "#fef2f2", color: "#dc2626", padding: "2px 8px", borderRadius: 20, fontWeight: 700, border: "1px solid #fecaca" }}>
// //                                           ↩ Refunded
// //                                         </span>
// //                                       )}
// //                                     </div>
// //                                     <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
// //                                       {fmtTime(tx.createdAt)} · TX: {tx.id?.slice(-8)?.toUpperCase()}
// //                                     </div>
// //                                     <div style={{ fontSize: 11, color: "#94a3b8" }}>
// //                                       Payment: {tx.paymentIntentId?.slice(-12)}
// //                                     </div>
// //                                   </div>

// //                                   {/* Refund button — only for paid, non-refunded transactions */}
// //                                   <RefundButton
// //                                     uid={u.uid}
// //                                     tx={tx}
// //                                     userEmail={u.email}                                          // ← add this
// //                                     userName={`${u.firstName} ${u.lastName}`.trim() || u.email} // ← add this
// //                                     onRefunded={(txId, refundData) => handleRefunded(u.uid, txId, refundData)}
// //                                   />
// //                                 </div>

// //                                 {/* Services */}
// //                                 <div style={{ marginBottom: 12 }}>
// //                                   <div style={{ fontSize: 11, fontWeight: 600, color: "#64748b", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>Services in this plan</div>
// //                                   <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
// //                                     {includes.map(code => {
// //                                       let used = false;
// //                                       if (code === "ATS_ANALYSIS")     used = tx.analysed;
// //                                       if (code === "ATS_RESUME_SAMPLE") used = tx.resumeGenerated;
// //                                       if (code === "DOCUMENT_SUMMARY") used = tx.documentSummarized;
// //                                       if (code === "DOCUMENT_CHAT")    used = tx.documentChatUsed;
// //                                       return <ServiceTag key={code} code={code} used={used} />;
// //                                     })}
// //                                   </div>
// //                                 </div>

// //                                 {/* Analysis */}
// //                                 {analysis && (
// //                                   <div style={{ background: "#fff", borderRadius: 8, padding: "12px 14px", border: "1px solid #e2e8f0" }}>
// //                                     <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 8 }}>Analysis Result</div>
// //                                     <div className="analysis-details" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
// //                                       <div style={{ textAlign: "center" }}>
// //                                         <div style={{ fontSize: 22, fontWeight: 800, color: analysis.ats_score >= 70 ? "#059669" : analysis.ats_score >= 50 ? "#d97706" : "#dc2626" }}>
// //                                           {analysis.ats_score}
// //                                         </div>
// //                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>ATS SCORE</div>
// //                                       </div>
// //                                       <div style={{ textAlign: "center" }}>
// //                                         <div style={{ fontSize: 22, fontWeight: 800, color: "#374151" }}>{analysis.match_rate || "—"}%</div>
// //                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>MATCH RATE</div>
// //                                       </div>
// //                                       <div style={{ textAlign: "center" }}>
// //                                         <div style={{ fontSize: 22, fontWeight: 800, color: "#374151" }}>{analysis.missing_count || 0}</div>
// //                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>MISSING KW</div>
// //                                       </div>
// //                                       <div style={{ flex: 1, minWidth: 160, fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
// //                                         {analysis.summary?.slice(0, 120)}{analysis.summary?.length > 120 ? "..." : ""}
// //                                       </div>
// //                                     </div>
// //                                     <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>Completed {fmtTime(analysis.createdAt)}</div>
// //                                   </div>
// //                                 )}

// //                                 {/* Refund record if done */}
// //                                 {tx.refunded && tx.refundId && (
// //                                   <div style={{ marginTop: 10, background: "#fef2f2", borderRadius: 8, padding: "10px 14px", border: "1px solid #fecaca" }}>
// //                                     <div style={{ fontSize: 11, fontWeight: 700, color: "#dc2626", marginBottom: 4 }}>Refund Record</div>
// //                                     <div style={{ fontSize: 11, color: "#7f1d1d", lineHeight: 1.7 }}>
// //                                       <div>Refund ID: <code style={{ fontFamily: "monospace" }}>{tx.refundId}</code></div>
// //                                       <div>Amount: {tx.refundAmount ? fmtMoney(tx.refundAmount) : "Full amount"}</div>
// //                                       <div>Reason: {tx.refundReason || "—"}</div>
// //                                       <div>Status: {tx.refundStatus || "—"}</div>
// //                                       <div>Issued: {fmtDate(tx.refundedAt)}</div>
// //                                     </div>
// //                                   </div>
// //                                 )}

// //                               </div>
// //                             );
// //                           })}
// //                         </div>
// //                       )}
// //                     </div>
// //                   )}
// //                 </div>
// //               ))}
// //             </div>
// //           </>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }

// // // ── Plans tab — unchanged from original ──
// // function PlansTab() {
// //   const plans    = servicesConfig.plans;
// //   const services = servicesConfig.services;

// //   return (
// //     <div style={{ display: "flex", flexDirection: "column", gap: 28 }}>
// //       <div>
// //         <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>Plans ({plans.length})</h2>
// //         <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
// //           {plans.map(plan => (
// //             <div key={plan.id} style={{ background: "#fff", borderRadius: 14, border: `1.5px solid ${plan.active ? "#bfdbfe" : "#e2e8f0"}`, overflow: "hidden" }}>
// //               <div style={{ padding: "16px 20px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap", background: plan.active ? "#f0f7ff" : "#f8fafc" }}>
// //                 <div style={{ flex: 1 }}>
// //                   <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 4 }}>
// //                     <span style={{ fontSize: 15, fontWeight: 800, color: "#0f172a" }}>{plan.name}</span>
// //                     <span style={{ fontSize: 11, background: plan.active ? "#dcfce7" : "#f1f5f9", color: plan.active ? "#059669" : "#94a3b8", padding: "2px 8px", borderRadius: 20, fontWeight: 700 }}>
// //                       {plan.active ? "● Active" : "○ Coming Soon"}
// //                     </span>
// //                   </div>
// //                   <div style={{ fontSize: 13, color: "#64748b" }}>{plan.description}</div>
// //                 </div>
// //                 <div style={{ textAlign: "right" }}>
// //                   <div style={{ fontSize: 26, fontWeight: 800, color: "#1d4ed8" }}>{plan.price}</div>
// //                   <div style={{ fontSize: 11, color: "#94a3b8" }}>{plan.period}</div>
// //                 </div>
// //               </div>
// //               <div style={{ padding: "12px 20px", background: "#f8fafc", borderTop: "1px solid #f1f5f9", fontSize: 10, color: "#94a3b8", fontFamily: "monospace", display: "flex", gap: 16, flexWrap: "wrap" }}>
// //                 <span>id: "{plan.id}"</span>
// //                 <span>priceInCents: {plan.priceInCents}</span>
// //                 <span>includes: [{(plan.includes || []).join(", ")}]</span>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>

// //       <div>
// //         <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>Services ({services.length})</h2>
// //         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 12 }}>
// //           {services.map(svc => (
// //             <div key={svc.serviceCode} style={{ background: "#fff", borderRadius: 12, border: `1.5px solid ${svc.active ? "#bbf7d0" : "#e2e8f0"}`, padding: "16px" }}>
// //               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
// //                 <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
// //                   <span style={{ fontSize: 22 }}>{svc.icon}</span>
// //                   <div>
// //                     <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{svc.title}</div>
// //                     <div style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>{svc.serviceCode}</div>
// //                   </div>
// //                 </div>
// //                 <span style={{ fontSize: 10, background: svc.active ? "#dcfce7" : "#f1f5f9", color: svc.active ? "#059669" : "#94a3b8", padding: "2px 8px", borderRadius: 10, fontWeight: 700 }}>
// //                   {svc.active ? "● Active" : "○ Inactive"}
// //                 </span>
// //               </div>
// //               <p style={{ fontSize: 12, color: "#64748b", lineHeight: 1.6 }}>{svc.description}</p>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }


// // new code
// import { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";
// import {
//   // eslint-disable-next-line no-unused-vars
//   collection, getDocs, doc, updateDoc, deleteDoc,
//   // eslint-disable-next-line no-unused-vars
//   serverTimestamp, writeBatch, query, where,
// } from "firebase/firestore";
// import { db } from "../utils/firebase";
// import servicesConfig from "../utils/servicesConfig";
// import apiConfig from "../utils/apiConfig";

// const ADMIN_EMAILS  = ["arsh1916@gmail.com", "support@smartaicareer.com"];
// const ADMIN_SECRET  = process.env.REACT_APP_ADMIN_SECRET || "";
// const BACKEND       = apiConfig?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";

// // ── Helpers ──
// function fmtDate(ts) {
//   if (!ts) return "—";
//   const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
//   return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
// }
// function fmtTime(ts) {
//   if (!ts) return "—";
//   const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
//   return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
// }
// function fmtMoney(cents) { return `$${(cents / 100).toFixed(2)}`; }
// function getPlanPrice(planId) {
//   return servicesConfig.plans.find(p => p.id === planId)?.priceInCents || 199;
// }
// function getPlanName(planId) {
//   return servicesConfig.plans.find(p => p.id === planId)?.name || planId || "Unknown";
// }
// function getPlanIncludes(planId, includes) {
//   if (Array.isArray(includes) && includes.length > 0) return includes;
//   return servicesConfig.plans.find(p => p.id === planId)?.includes || [];
// }

// // ── Stat card ──
// function StatCard({ label, value, sub, color = "#2563eb", icon }) {
//   return (
//     <div style={{ background: "#fff", borderRadius: 14, padding: "20px 22px", border: "1px solid #e2e8f0", flex: 1, minWidth: 140 }}>
//       <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
//         <div style={{ width: 36, height: 36, borderRadius: 10, background: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>{icon}</div>
//         <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</span>
//       </div>
//       <div style={{ fontSize: 28, fontWeight: 800, color: "#0f172a", letterSpacing: "-0.02em" }}>{value}</div>
//       {sub && <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{sub}</div>}
//     </div>
//   );
// }

// // ── Service tag ──
// function ServiceTag({ code, used }) {
//   const svc = servicesConfig.services.find(s => s.serviceCode === code);
//   return (
//     <span style={{
//       display: "inline-flex", alignItems: "center", gap: 4,
//       fontSize: 11, padding: "3px 8px", borderRadius: 20, fontWeight: 600,
//       background: used ? "#f0fdf4" : "#f8fafc",
//       color: used ? "#059669" : "#94a3b8",
//       border: `1px solid ${used ? "#bbf7d0" : "#e2e8f0"}`,
//     }}>
//       {svc?.icon || "•"} {svc?.title || code}
//       {used ? " ✓" : " —"}
//     </span>
//   );
// }

// // ── Refund button — handles the full flow ──
// function RefundButton({ uid, tx, onRefunded }) {
//   const [state,  setState]  = useState("idle"); // idle | confirm | loading | done | error
//   const [error,  setError]  = useState("");
//   const [reason, setReason] = useState("requested_by_customer");

//   const REASONS = [
//     { value: "requested_by_customer", label: "Requested by customer" },
//     { value: "duplicate",             label: "Duplicate charge" },
//     { value: "fraudulent",            label: "Fraudulent" },
//     { value: "service_not_delivered", label: "Service not delivered" },
//   ];

//   // Already refunded — show badge only
//   if (tx.refunded) {
//     return (
//       <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//         <span style={{ fontSize: 11, background: "#fef2f2", color: "#dc2626", padding: "3px 10px", borderRadius: 20, fontWeight: 700, border: "1px solid #fecaca" }}>
//           ↩ Refunded {tx.refundAmount ? fmtMoney(tx.refundAmount) : ""} · {fmtDate(tx.refundedAt)}
//         </span>
//         {tx.refundId && (
//           <span style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>
//             {tx.refundId.slice(-8)}
//           </span>
//         )}
//       </div>
//     );
//   }

//   async function handleRefund() {
//     setState("loading");
//     setError("");
//     try {
//       // Step 1 — call server to issue Stripe refund
//       const res = await fetch(`${BACKEND}/admin/refund`, {
//         method:  "POST",
//         headers: {
//           "Content-Type":  "application/json",
//           "x-admin-token": ADMIN_SECRET,
//         },
//         body: JSON.stringify({
//           paymentIntentId: tx.paymentIntentId,
//           reason,
//         }),
//       });

//       const data = await res.json();
//       if (!res.ok) throw new Error(data.error || "Refund failed");

//       // Step 2 — record refund in Firestore on the transaction doc
//       await updateDoc(doc(db, "users", uid, "transactions", tx.id), {
//         refunded:    true,
//         refundId:    data.refundId,
//         refundAmount: data.amount,
//         refundReason: reason,
//         refundStatus: data.status,
//         refundedAt:  serverTimestamp(),
//         refundedBy:  "admin",
//       });

//       setState("done");
//       onRefunded(tx.id, {
//         refunded:     true,
//         refundId:     data.refundId,
//         refundAmount: data.amount,
//         refundReason: reason,
//         refundStatus: data.status,
//       });

//     } catch (err) {
//       console.error("Refund error:", err.message);
//       setError(err.message);
//       setState("error");
//     }
//   }

//   if (state === "done") {
//     return (
//       <span style={{ fontSize: 11, background: "#f0fdf4", color: "#059669", padding: "3px 10px", borderRadius: 20, fontWeight: 700, border: "1px solid #bbf7d0" }}>
//         ✓ Refund issued
//       </span>
//     );
//   }

//   if (state === "confirm") {
//     return (
//       <div style={{ background: "#fef2f2", borderRadius: 10, padding: "12px 14px", border: "1px solid #fecaca", marginTop: 8 }}>
//         <div style={{ fontSize: 12, fontWeight: 700, color: "#dc2626", marginBottom: 8 }}>
//           Confirm refund of {fmtMoney(getPlanPrice(tx.planId))} to this user?
//         </div>
//         <div style={{ marginBottom: 10 }}>
//           <select
//             value={reason}
//             onChange={e => setReason(e.target.value)}
//             style={{ width: "100%", padding: "6px 10px", border: "1px solid #fecaca", borderRadius: 7, fontSize: 12, background: "#fff" }}
//           >
//             {REASONS.map(r => (
//               <option key={r.value} value={r.value}>{r.label}</option>
//             ))}
//           </select>
//         </div>
//         <div style={{ display: "flex", gap: 8 }}>
//           <button
//             onClick={handleRefund}
//             style={{ padding: "6px 14px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer" }}
//           >
//             Yes, refund now
//           </button>
//           <button
//             onClick={() => setState("idle")}
//             style={{ padding: "6px 14px", background: "#fff", color: "#64748b", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, cursor: "pointer" }}
//           >
//             Cancel
//           </button>
//         </div>
//         {state === "error" && (
//           <div style={{ fontSize: 12, color: "#dc2626", marginTop: 8 }}>{error}</div>
//         )}
//       </div>
//     );
//   }

//   if (state === "loading") {
//     return (
//       <span style={{ fontSize: 12, color: "#64748b", display: "flex", alignItems: "center", gap: 6 }}>
//         <span style={{ width: 12, height: 12, borderRadius: "50%", border: "2px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.7s linear infinite", display: "inline-block" }} />
//         Processing refund...
//       </span>
//     );
//   }

//   return (
//     <div>
//       <button
//         onClick={() => setState("confirm")}
//         style={{ padding: "5px 12px", background: "#fff", color: "#dc2626", border: "1.5px solid #fca5a5", borderRadius: 7, fontSize: 11, fontWeight: 700, cursor: "pointer", transition: "all 0.15s" }}
//         onMouseEnter={e => { e.currentTarget.style.background = "#fef2f2"; }}
//         onMouseLeave={e => { e.currentTarget.style.background = "#fff"; }}
//       >
//         ↩ Issue Refund
//       </button>
//       {state === "error" && (
//         <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>{error}</div>
//       )}
//     </div>
//   );
// }

// export default function AdminPage() {
//   const { user } = useAuth();
//   const navigate = useNavigate();

//   const [activeTab,   setActiveTab]   = useState("users");
//   const [loading,     setLoading]     = useState(true);
//   const [users,       setUsers]       = useState([]);
//   const [filter,      setFilter]      = useState("all");
//   const [planFilter,  setPlanFilter]  = useState("all");
//   const [search,      setSearch]      = useState("");
//   const [expanded,    setExpanded]    = useState(null);
//   const [sortBy,      setSortBy]      = useState("recent");

//   useEffect(() => {
//     if (!user) { navigate("/login"); return; }
//     if (!ADMIN_EMAILS.includes(user.email)) { navigate("/dashboard"); return; }
//   }, [user, navigate]);

//   const loadData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const usersSnap = await getDocs(collection(db, "users"));
//       const usersData = [];

//       for (const userDoc of usersSnap.docs) {
//         const userData = userDoc.data();
//         const uid = userDoc.id;

//         const txSnap = await getDocs(collection(db, "users", uid, "transactions"));
//         const transactions = txSnap.docs.map(d => ({ id: d.id, ...d.data() }))
//           .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//         const analysesSnap = await getDocs(collection(db, "users", uid, "analyses"));
//         const analyses = analysesSnap.docs.map(d => ({ id: d.id, ...d.data() }))
//           .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//         const paidTransactions = transactions.filter(t => t.status === "paid");
//         const totalRevenue = paidTransactions.reduce((sum, t) => sum + getPlanPrice(t.planId), 0);
//         const refundedAmount = paidTransactions
//           .filter(t => t.refunded)
//           .reduce((sum, t) => sum + (t.refundAmount || getPlanPrice(t.planId)), 0);

//         const firstName = userData.firstName || userData.displayName?.split(" ")[0] || "";
//         const lastName  = userData.lastName  || userData.displayName?.split(" ").slice(1).join(" ") || "";
//         const email     = userData.email     || uid;

//         const templatesUsed = transactions
//           .filter(t => t.resumeGenerated && t.resumeTemplateId)
//           .map(t => t.resumeTemplateId);
//         const templateCounts = templatesUsed.reduce((acc, t) => {
//           acc[t] = (acc[t] || 0) + 1; return acc;
//         }, {});

//         usersData.push({
//           uid, email, firstName, lastName,
//           createdAt:             userData.createdAt,
//           lastPaymentAt:         userData.lastPaymentAt,
//           totalPayments:         userData.totalPayments  || paidTransactions.length,
//           totalAnalyses:         userData.totalAnalyses  || transactions.filter(t => t.analysed).length,
//           totalResumesGenerated: userData.totalResumesGenerated || transactions.filter(t => t.resumeGenerated).length,
//           transactions:          paidTransactions,
//           analyses,
//           totalRevenue,
//           refundedAmount,
//           templateCounts,
//         });
//       }

//       setUsers(usersData);
//     } catch (err) {
//       console.error("Admin load error:", err);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     if (user && ADMIN_EMAILS.includes(user.email)) loadData();
//   }, [user, loadData]);

//   // ── Update a transaction locally after refund — no reload needed ──
//   function handleRefunded(uid, txId, refundData) {
//     setUsers(prev => prev.map(u => {
//       if (u.uid !== uid) return u;
//       return {
//         ...u,
//         refundedAmount: (u.refundedAmount || 0) + (refundData.refundAmount || 0),
//         transactions: u.transactions.map(t =>
//           t.id === txId ? { ...t, ...refundData } : t
//         ),
//       };
//     }));
//   }

//   // ── Derived stats ──
//   const totalUsers      = users.length;
//   const totalRevenue    = users.reduce((s, u) => s + u.totalRevenue, 0);
//   const totalRefunded   = users.reduce((s, u) => s + (u.refundedAmount || 0), 0);
//   const totalTx         = users.reduce((s, u) => s + u.transactions.length, 0);
//   const totalAnalyses   = users.reduce((s, u) => s + u.totalAnalyses, 0);
//   const pendingUsers    = users.filter(u => u.transactions.some(t => !t.analysed)).length;
//   const refundedCount   = users.reduce((s, u) => s + u.transactions.filter(t => t.refunded).length, 0);

//   const filteredUsers = users
//     .filter(u => {
//       if (search) {
//         const q = search.toLowerCase();
//         if (!u.email.toLowerCase().includes(q) &&
//             !`${u.firstName} ${u.lastName}`.toLowerCase().includes(q)) return false;
//       }
//       if (planFilter !== "all") {
//         if (!u.transactions.some(t => t.planId === planFilter)) return false;
//       }
//       if (filter === "paid")     return u.transactions.length > 0;
//       if (filter === "analysed") return u.totalAnalyses > 0;
//       if (filter === "pending")  return u.transactions.some(t => t.status === "paid" && !t.analysed);
//       if (filter === "refunded") return u.transactions.some(t => t.refunded);
//       return true;
//     })
//     .sort((a, b) => {
//       if (sortBy === "revenue") return b.totalRevenue - a.totalRevenue;
//       if (sortBy === "name")    return `${a.firstName}${a.lastName}`.localeCompare(`${b.firstName}${b.lastName}`);
//       return (b.lastPaymentAt?.seconds || b.createdAt?.seconds || 0) - (a.lastPaymentAt?.seconds || a.createdAt?.seconds || 0);
//     });

//   if (!user || !ADMIN_EMAILS.includes(user?.email)) return null;

//   return (
//     <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Inter',-apple-system,sans-serif" }}>
//       <style>{`
//         * { box-sizing: border-box; }
//         @keyframes spin { to { transform: rotate(360deg); } }
//         @media (max-width: 768px) {
//           .admin-stats { flex-wrap: wrap !important; }
//           .admin-stats > div { min-width: calc(50% - 8px) !important; }
//           .admin-filters { flex-wrap: wrap !important; }
//           .plan-body-grid { grid-template-columns: 1fr !important; gap: 20px !important; }
//           .services-grid { grid-template-columns: 1fr !important; }
//           .templates-grid { grid-template-columns: 1fr !important; }
//           .revenue-breakdown { flex-direction: column !important; }
//           .user-row { flex-wrap: wrap !important; }
//           .filter-buttons { flex-wrap: wrap !important; }
//           .transaction-header { flex-direction: column !important; align-items: flex-start !important; }
//           .analysis-details { flex-direction: column !important; align-items: flex-start !important; }
//         }
//         @media (max-width: 480px) {
//           .admin-stats > div { min-width: 100% !important; }
//         }
//       `}</style>

//       {/* NAV */}
//       <nav style={{ background: "#0f172a", padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
//         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//           <div style={{ width: 32, height: 32, background: "linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
//             <span style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>R</span>
//           </div>
//           <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>ResumeScoreAI</span>
//           <span style={{ background: "#1e293b", color: "#94a3b8", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>Admin</span>
//         </div>
//         <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
//           <div style={{ display: "flex", background: "#1e293b", borderRadius: 9, padding: 3, gap: 2 }}>
//             {[{ id: "users", label: "👥 Users" }, { id: "plans", label: "📦 Plans" }, { id: "cleanup", label: "🗑️ Cleanup" }].map(tab => (
//               <button key={tab.id} onClick={() => setActiveTab(tab.id)}
//                 style={{ padding: "6px 12px", borderRadius: 7, border: "none", fontSize: 12, fontWeight: 600, cursor: "pointer", background: activeTab === tab.id ? "#fff" : "transparent", color: activeTab === tab.id ? "#0f172a" : "#64748b", transition: "all 0.2s" }}
//               >{tab.label}</button>
//             ))}
//           </div>
//           <button onClick={loadData} style={{ padding: "7px 14px", background: "#1e293b", color: "#94a3b8", border: "1px solid #334155", borderRadius: 8, fontSize: 13, cursor: "pointer" }}>🔄 Refresh</button>
//           <button onClick={() => navigate("/dashboard")} style={{ padding: "7px 14px", background: "transparent", color: "#64748b", border: "1px solid #334155", borderRadius: 8, fontSize: 13, cursor: "pointer" }}>← Dashboard</button>
//         </div>
//       </nav>

//       <div style={{ maxWidth: 1300, margin: "0 auto", padding: "24px 16px" }}>
//         <div style={{ marginBottom: 24 }}>
//           <h1 style={{ fontSize: "clamp(22px,6vw,26px)", fontWeight: 800, color: "#0f172a", marginBottom: 4, letterSpacing: "-0.02em" }}>Admin Dashboard</h1>
//           <p style={{ fontSize: 14, color: "#64748b" }}>User transactions, refunds, and service utilization</p>
//         </div>

//         {activeTab === "plans" && <PlansTab />}
//         {activeTab === "cleanup" && <CleanupTab />}

//         {activeTab === "users" && (loading ? (
//           <div style={{ textAlign: "center", padding: "80px 20px" }}>
//             <div style={{ width: 40, height: 40, borderRadius: "50%", border: "4px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.8s linear infinite", margin: "0 auto 16px" }} />
//             <p style={{ color: "#64748b", fontSize: 14 }}>Loading all user data...</p>
//           </div>
//         ) : (
//           <>
//             {/* STATS */}
//             <div className="admin-stats" style={{ display: "flex", gap: 16, marginBottom: 20, flexWrap: "wrap" }}>
//               <StatCard label="Total Users"   value={totalUsers}    icon="👥" color="#2563eb" sub={`${pendingUsers} with pending analysis`} />
//               <StatCard label="Analyses Done" value={totalAnalyses} icon="🎯" color="#0891b2" sub="completed analyses" />
//               <StatCard label="Refunds Issued" value={refundedCount} icon="↩" color="#dc2626" sub={fmtMoney(totalRefunded)} />
//             </div>

//             {/* REVENUE SUMMARY — prominent, always visible */}
//             <div style={{ background: "#0f172a", borderRadius: 16, padding: "20px 24px", marginBottom: 24, display: "flex", gap: 0, flexWrap: "wrap", overflow: "hidden", position: "relative" }}>
//               <div style={{ position: "absolute", top: -30, right: -30, width: 160, height: 160, borderRadius: "50%", background: "radial-gradient(circle,rgba(37,99,235,0.15),transparent)", pointerEvents: "none" }} />

//               {/* Gross */}
//               <div style={{ flex: 1, minWidth: 140, padding: "0 20px 0 0", borderRight: "1px solid #1e293b" }}>
//                 <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Gross Revenue</div>
//                 <div style={{ fontSize: 32, fontWeight: 800, color: "#fff", letterSpacing: "-0.03em" }}>{fmtMoney(totalRevenue)}</div>
//                 <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>{totalTx} paid transactions</div>
//               </div>

//               {/* Refunded */}
//               <div style={{ flex: 1, minWidth: 140, padding: "0 20px", borderRight: "1px solid #1e293b" }}>
//                 <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Refunded</div>
//                 <div style={{ fontSize: 32, fontWeight: 800, color: "#dc2626", letterSpacing: "-0.03em" }}>− {fmtMoney(totalRefunded)}</div>
//                 <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>{refundedCount} refund{refundedCount !== 1 ? "s" : ""} issued</div>
//               </div>

//               {/* Net — highlighted */}
//               <div style={{ flex: 1, minWidth: 140, padding: "0 0 0 20px", position: "relative" }}>
//                 <div style={{ fontSize: 11, fontWeight: 700, color: "#60a5fa", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Net Revenue</div>
//                 <div style={{ fontSize: 32, fontWeight: 800, color: "#60a5fa", letterSpacing: "-0.03em" }}>{fmtMoney(totalRevenue - totalRefunded)}</div>
//                 <div style={{ fontSize: 12, color: "#475569", marginTop: 4 }}>after all refunds</div>
//                 {totalRefunded > 0 && (
//                   <div style={{ marginTop: 8, fontSize: 11, color: "#475569" }}>
//                     Refund rate:{" "}
//                     <span style={{ color: totalRefunded / totalRevenue > 0.1 ? "#dc2626" : "#64748b", fontWeight: 700 }}>
//                       {Math.round((totalRefunded / totalRevenue) * 100)}%
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* PLAN BREAKDOWN */}
//             <div style={{ background: "#fff", borderRadius: 14, padding: "16px 20px", border: "1px solid #e2e8f0", marginBottom: 24 }}>
//               <h3 style={{ fontSize: 14, fontWeight: 700, color: "#374151", marginBottom: 16 }}>Revenue by Plan</h3>
//               <div className="revenue-breakdown" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
//                 {servicesConfig.plans.filter(p => p.enabled).map(plan => {
//                   const planTxs = users.flatMap(u => u.transactions.filter(t => t.planId === plan.id));
//                   const planRevenue = planTxs.length * plan.priceInCents;
//                   const planRefunds = planTxs.filter(t => t.refunded).length * plan.priceInCents;
//                   return (
//                     <div key={plan.id} style={{ flex: 1, minWidth: 150, background: "#f8fafc", borderRadius: 10, padding: "12px 14px", border: "1px solid #e2e8f0" }}>
//                       <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 6 }}>{plan.name}</div>

//                       {/* Gross */}
//                       <div style={{ display: "flex", alignItems: "baseline", gap: 4, marginBottom: 2 }}>
//                         <div style={{ fontSize: 20, fontWeight: 800, color: "#0f172a" }}>{fmtMoney(planRevenue)}</div>
//                         <div style={{ fontSize: 11, color: "#94a3b8" }}>gross</div>
//                       </div>

//                       {/* Refunded */}
//                       {planRefunds > 0 && (
//                         <div style={{ display: "flex", alignItems: "baseline", gap: 4, marginBottom: 2 }}>
//                           <div style={{ fontSize: 14, fontWeight: 700, color: "#dc2626" }}>− {fmtMoney(planRefunds)}</div>
//                           <div style={{ fontSize: 11, color: "#dc2626" }}>refunded</div>
//                         </div>
//                       )}

//                       {/* Net */}
//                       <div style={{ display: "flex", alignItems: "baseline", gap: 4, paddingTop: planRefunds > 0 ? 6 : 0, borderTop: planRefunds > 0 ? "1px solid #e2e8f0" : "none", marginTop: planRefunds > 0 ? 4 : 0 }}>
//                         <div style={{ fontSize: planRefunds > 0 ? 18 : 14, fontWeight: 800, color: planRefunds > 0 ? "#2563eb" : "#94a3b8" }}>
//                           {fmtMoney(planRevenue - planRefunds)}
//                         </div>
//                         <div style={{ fontSize: 11, color: planRefunds > 0 ? "#2563eb" : "#94a3b8" }}>net</div>
//                       </div>

//                       <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 6, display: "flex", gap: 8, flexWrap: "wrap" }}>
//                         <span>{planTxs.length} purchases</span>
//                         {planTxs.filter(t => t.refunded).length > 0 && (
//                           <span style={{ color: "#dc2626" }}>
//                             {planTxs.filter(t => t.refunded).length} refunded
//                           </span>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             {/* FILTERS */}
//             <div className="admin-filters" style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap", alignItems: "center" }}>
//               <input
//                 type="text" placeholder="🔍 Search by name or email..."
//                 value={search} onChange={e => setSearch(e.target.value)}
//                 style={{ padding: "9px 14px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 13, minWidth: 200, flex: "1 1 200px", outline: "none", background: "#fff" }}
//               />
//               <div className="filter-buttons" style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
//                 {[
//                   { id: "all",      label: "All Users" },
//                   { id: "paid",     label: "💳 Paid" },
//                   { id: "analysed", label: "✅ Analysed" },
//                   { id: "pending",  label: "⏳ Pending" },
//                   { id: "refunded", label: "↩ Refunded" },
//                 ].map(f => (
//                   <button key={f.id} onClick={() => setFilter(f.id)}
//                     style={{ padding: "7px 12px", borderRadius: 8, border: "1px solid", fontSize: 12, fontWeight: 600, cursor: "pointer", borderColor: filter === f.id ? "#2563eb" : "#e2e8f0", background: filter === f.id ? "#eff6ff" : "#fff", color: filter === f.id ? "#2563eb" : "#64748b", whiteSpace: "nowrap" }}
//                   >{f.label}</button>
//                 ))}
//               </div>
//               <select value={planFilter} onChange={e => setPlanFilter(e.target.value)}
//                 style={{ padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 12, fontWeight: 600, color: "#374151", background: "#fff", cursor: "pointer" }}>
//                 <option value="all">All Plans</option>
//                 {servicesConfig.plans.filter(p => p.enabled).map(p => (
//                   <option key={p.id} value={p.id}>{p.name}</option>
//                 ))}
//               </select>
//               <select value={sortBy} onChange={e => setSortBy(e.target.value)}
//                 style={{ padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 12, fontWeight: 600, color: "#374151", background: "#fff", cursor: "pointer" }}>
//                 <option value="recent">Sort: Most Recent</option>
//                 <option value="revenue">Sort: Highest Revenue</option>
//                 <option value="name">Sort: Name A–Z</option>
//               </select>
//               <span style={{ fontSize: 13, color: "#94a3b8", marginLeft: "auto" }}>{filteredUsers.length} of {totalUsers} users</span>
//             </div>

//             {/* USERS LIST */}
//             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//               {filteredUsers.length === 0 ? (
//                 <div style={{ textAlign: "center", padding: "48px", background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", color: "#94a3b8" }}>
//                   No users match your filters.
//                 </div>
//               ) : filteredUsers.map(u => (
//                 <div key={u.uid} style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>

//                   {/* User row */}
//                   <div
//                     onClick={() => setExpanded(expanded === u.uid ? null : u.uid)}
//                     className="user-row"
//                     style={{ padding: "16px 20px", cursor: "pointer", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}
//                   >
//                     <div style={{ width: 42, height: 42, borderRadius: "50%", background: `linear-gradient(135deg,${["#2563eb","#7c3aed","#059669","#d97706"][u.uid.charCodeAt(0) % 4]},${["#1d4ed8","#6d28d9","#047857","#b45309"][u.uid.charCodeAt(0) % 4]})`, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: 15, flexShrink: 0 }}>
//                       {(u.firstName?.[0] || u.email?.[0] || "?").toUpperCase()}
//                     </div>
//                     <div style={{ flex: 1, minWidth: 160 }}>
//                       <div style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>
//                         {u.firstName || u.lastName ? `${u.firstName} ${u.lastName}`.trim() : u.email?.split("@")[0] || "Unknown"}
//                       </div>
//                       <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{u.email}</div>
//                     </div>
//                     <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
//                       <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.transactions.length > 0 ? "#eff6ff" : "#f8fafc", color: u.transactions.length > 0 ? "#2563eb" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.transactions.length > 0 ? "#bfdbfe" : "#e2e8f0" }}>
//                         💳 {u.transactions.length} {u.transactions.length === 1 ? "payment" : "payments"}
//                       </span>
//                       <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.totalAnalyses > 0 ? "#f0fdf4" : "#f8fafc", color: u.totalAnalyses > 0 ? "#059669" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.totalAnalyses > 0 ? "#bbf7d0" : "#e2e8f0" }}>
//                         🎯 {u.totalAnalyses} {u.totalAnalyses === 1 ? "analysis" : "analyses"}
//                       </span>
//                       {u.totalRevenue > 0 && (
//                         <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#f0fdf4", color: "#059669", fontWeight: 700, border: "1px solid #bbf7d0" }}>
//                           {fmtMoney(u.totalRevenue)}
//                         </span>
//                       )}
//                       {u.refundedAmount > 0 && (
//                         <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#fef2f2", color: "#dc2626", fontWeight: 700, border: "1px solid #fecaca" }}>
//                           ↩ {fmtMoney(u.refundedAmount)}
//                         </span>
//                       )}
//                       {u.transactions.some(t => !t.analysed && !t.refunded) && (
//                         <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#fffbeb", color: "#d97706", fontWeight: 600, border: "1px solid #fde68a" }}>⏳ Pending</span>
//                       )}
//                     </div>
//                     <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "right", minWidth: 90 }}>Joined {fmtDate(u.createdAt)}</div>
//                     <span style={{ fontSize: 12, color: "#94a3b8", transition: "transform 0.2s", display: "inline-block", transform: expanded === u.uid ? "rotate(180deg)" : "rotate(0)" }}>▼</span>
//                   </div>

//                   {/* Expanded detail */}
//                   {expanded === u.uid && (
//                     <div style={{ borderTop: "1px solid #f1f5f9", padding: "20px 20px 24px" }}>
//                       {u.transactions.length === 0 ? (
//                         <p style={{ fontSize: 13, color: "#94a3b8", fontStyle: "italic" }}>No transactions yet.</p>
//                       ) : (
//                         <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//                           <h4 style={{ fontSize: 13, fontWeight: 700, color: "#374151", margin: 0 }}>
//                             Transactions ({u.transactions.length})
//                           </h4>

//                           {u.transactions.map(tx => {
//                             const includes  = getPlanIncludes(tx.planId, tx.includes);
//                             const analysis  = u.analyses.find(a => a.transactionId === tx.id);

//                             return (
//                               <div key={tx.id} style={{ background: tx.refunded ? "#fef9f9" : "#f8fafc", borderRadius: 12, padding: "16px 18px", border: `1px solid ${tx.refunded ? "#fecaca" : "#e2e8f0"}` }}>

//                                 {/* Transaction header */}
//                                 <div className="transaction-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
//                                   <div>
//                                     <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
//                                       <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{getPlanName(tx.planId)}</span>
//                                       <span style={{ fontSize: 11, background: "#eff6ff", color: "#2563eb", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: "1px solid #bfdbfe" }}>
//                                         {fmtMoney(getPlanPrice(tx.planId))}
//                                       </span>
//                                       <span style={{ fontSize: 11, background: tx.analysed ? "#f0fdf4" : "#fffbeb", color: tx.analysed ? "#059669" : "#d97706", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: `1px solid ${tx.analysed ? "#bbf7d0" : "#fde68a"}` }}>
//                                         {tx.analysed ? "✅ Analysed" : "⏳ Pending"}
//                                       </span>
//                                       {tx.refunded && (
//                                         <span style={{ fontSize: 11, background: "#fef2f2", color: "#dc2626", padding: "2px 8px", borderRadius: 20, fontWeight: 700, border: "1px solid #fecaca" }}>
//                                           ↩ Refunded
//                                         </span>
//                                       )}
//                                     </div>
//                                     <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
//                                       {fmtTime(tx.createdAt)} · TX: {tx.id?.slice(-8)?.toUpperCase()}
//                                     </div>
//                                     <div style={{ fontSize: 11, color: "#94a3b8" }}>
//                                       Payment: {tx.paymentIntentId?.slice(-12)}
//                                     </div>
//                                   </div>

//                                   {/* Refund button — only for paid, non-refunded transactions */}
//                                   <RefundButton
//                                     uid={u.uid}
//                                     tx={tx}
//                                     onRefunded={(txId, refundData) => handleRefunded(u.uid, txId, refundData)}
//                                   />
//                                 </div>

//                                 {/* Services */}
//                                 <div style={{ marginBottom: 12 }}>
//                                   <div style={{ fontSize: 11, fontWeight: 600, color: "#64748b", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>Services in this plan</div>
//                                   <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
//                                     {includes.map(code => {
//                                       let used = false;
//                                       if (code === "ATS_ANALYSIS")     used = tx.analysed;
//                                       if (code === "ATS_RESUME_SAMPLE") used = tx.resumeGenerated;
//                                       if (code === "DOCUMENT_SUMMARY") used = tx.documentSummarized;
//                                       if (code === "DOCUMENT_CHAT")    used = tx.documentChatUsed;
//                                       return <ServiceTag key={code} code={code} used={used} />;
//                                     })}
//                                   </div>
//                                 </div>

//                                 {/* Analysis */}
//                                 {analysis && (
//                                   <div style={{ background: "#fff", borderRadius: 8, padding: "12px 14px", border: "1px solid #e2e8f0" }}>
//                                     <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 8 }}>Analysis Result</div>
//                                     <div className="analysis-details" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
//                                       <div style={{ textAlign: "center" }}>
//                                         <div style={{ fontSize: 22, fontWeight: 800, color: analysis.ats_score >= 70 ? "#059669" : analysis.ats_score >= 50 ? "#d97706" : "#dc2626" }}>
//                                           {analysis.ats_score}
//                                         </div>
//                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>ATS SCORE</div>
//                                       </div>
//                                       <div style={{ textAlign: "center" }}>
//                                         <div style={{ fontSize: 22, fontWeight: 800, color: "#374151" }}>{analysis.match_rate || "—"}%</div>
//                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>MATCH RATE</div>
//                                       </div>
//                                       <div style={{ textAlign: "center" }}>
//                                         <div style={{ fontSize: 22, fontWeight: 800, color: "#374151" }}>{analysis.missing_count || 0}</div>
//                                         <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>MISSING KW</div>
//                                       </div>
//                                       <div style={{ flex: 1, minWidth: 160, fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
//                                         {analysis.summary?.slice(0, 120)}{analysis.summary?.length > 120 ? "..." : ""}
//                                       </div>
//                                     </div>
//                                     <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>Completed {fmtTime(analysis.createdAt)}</div>
//                                   </div>
//                                 )}

//                                 {/* Refund record if done */}
//                                 {tx.refunded && tx.refundId && (
//                                   <div style={{ marginTop: 10, background: "#fef2f2", borderRadius: 8, padding: "10px 14px", border: "1px solid #fecaca" }}>
//                                     <div style={{ fontSize: 11, fontWeight: 700, color: "#dc2626", marginBottom: 4 }}>Refund Record</div>
//                                     <div style={{ fontSize: 11, color: "#7f1d1d", lineHeight: 1.7 }}>
//                                       <div>Refund ID: <code style={{ fontFamily: "monospace" }}>{tx.refundId}</code></div>
//                                       <div>Amount: {tx.refundAmount ? fmtMoney(tx.refundAmount) : "Full amount"}</div>
//                                       <div>Reason: {tx.refundReason || "—"}</div>
//                                       <div>Status: {tx.refundStatus || "—"}</div>
//                                       <div>Issued: {fmtDate(tx.refundedAt)}</div>
//                                     </div>
//                                   </div>
//                                 )}

//                               </div>
//                             );
//                           })}
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </>
//         ))}
//       </div>
//     </div>
//   );
// }

// // ── Plans tab — unchanged from original ──
// function PlansTab() {
//   const plans    = servicesConfig.plans;
//   const services = servicesConfig.services;

//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: 28 }}>
//       <div>
//         <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>Plans ({plans.length})</h2>
//         <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
//           {plans.map(plan => (
//             <div key={plan.id} style={{ background: "#fff", borderRadius: 14, border: `1.5px solid ${plan.active ? "#bfdbfe" : "#e2e8f0"}`, overflow: "hidden" }}>
//               <div style={{ padding: "16px 20px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap", background: plan.active ? "#f0f7ff" : "#f8fafc" }}>
//                 <div style={{ flex: 1 }}>
//                   <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 4 }}>
//                     <span style={{ fontSize: 15, fontWeight: 800, color: "#0f172a" }}>{plan.name}</span>
//                     <span style={{ fontSize: 11, background: plan.active ? "#dcfce7" : "#f1f5f9", color: plan.active ? "#059669" : "#94a3b8", padding: "2px 8px", borderRadius: 20, fontWeight: 700 }}>
//                       {plan.active ? "● Active" : "○ Coming Soon"}
//                     </span>
//                   </div>
//                   <div style={{ fontSize: 13, color: "#64748b" }}>{plan.description}</div>
//                 </div>
//                 <div style={{ textAlign: "right" }}>
//                   <div style={{ fontSize: 26, fontWeight: 800, color: "#1d4ed8" }}>{plan.price}</div>
//                   <div style={{ fontSize: 11, color: "#94a3b8" }}>{plan.period}</div>
//                 </div>
//               </div>
//               <div style={{ padding: "12px 20px", background: "#f8fafc", borderTop: "1px solid #f1f5f9", fontSize: 10, color: "#94a3b8", fontFamily: "monospace", display: "flex", gap: 16, flexWrap: "wrap" }}>
//                 <span>id: "{plan.id}"</span>
//                 <span>priceInCents: {plan.priceInCents}</span>
//                 <span>includes: [{(plan.includes || []).join(", ")}]</span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div>
//         <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>Services ({services.length})</h2>
//         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 12 }}>
//           {services.map(svc => (
//             <div key={svc.serviceCode} style={{ background: "#fff", borderRadius: 12, border: `1.5px solid ${svc.active ? "#bbf7d0" : "#e2e8f0"}`, padding: "16px" }}>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                   <span style={{ fontSize: 22 }}>{svc.icon}</span>
//                   <div>
//                     <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{svc.title}</div>
//                     <div style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>{svc.serviceCode}</div>
//                   </div>
//                 </div>
//                 <span style={{ fontSize: 10, background: svc.active ? "#dcfce7" : "#f1f5f9", color: svc.active ? "#059669" : "#94a3b8", padding: "2px 8px", borderRadius: 10, fontWeight: 700 }}>
//                   {svc.active ? "● Active" : "○ Inactive"}
//                 </span>
//               </div>
//               <p style={{ fontSize: 12, color: "#64748b", lineHeight: 1.6 }}>{svc.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────
// // CLEANUP TAB
// // Finds and deletes/archives expired documents (>30 days old)
// // across all users' generatedDocs and generatedResumes collections
// // Accessible only to admin emails
// // ─────────────────────────────────────────────────────────────
// function CleanupTab() {
//   const [scanning,   setScanning]   = useState(false);
//   const [deleting,   setDeleting]   = useState(false);
//   const [scanned,    setScanned]    = useState(false);
//   const [expired,    setExpired]    = useState([]);   // { uid, email, collection, docId, type, createdAt, expiresAt, size }
//   const [deleted,    setDeleted]    = useState([]);
//   const [error,      setError]      = useState("");
//   const [selected,   setSelected]   = useState(new Set()); // selected doc ids
//   const [filterType, setFilterType] = useState("all");     // all | resume | cover_letter
//   const [log,        setLog]        = useState([]);

//   const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

//   function addLog(msg) {
//     setLog(prev => [`${new Date().toLocaleTimeString()} — ${msg}`, ...prev.slice(0, 49)]);
//   }

//   function isExpired(doc) {
//     // Check expiresAt first, fall back to createdAt + 30 days
//     if (doc.expiresAt) {
//       const exp = doc.expiresAt.seconds
//         ? new Date(doc.expiresAt.seconds * 1000)
//         : new Date(doc.expiresAt);
//       return exp < new Date();
//     }
//     if (doc.createdAt) {
//       const created = doc.createdAt.seconds
//         ? new Date(doc.createdAt.seconds * 1000)
//         : new Date(doc.createdAt);
//       return (Date.now() - created.getTime()) > THIRTY_DAYS_MS;
//     }
//     return false;
//   }

//   function fmtExpiry(doc) {
//     if (doc.expiresAt) {
//       const d = doc.expiresAt.seconds
//         ? new Date(doc.expiresAt.seconds * 1000)
//         : new Date(doc.expiresAt);
//       const daysAgo = Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
//       return `Expired ${daysAgo}d ago (${d.toLocaleDateString()})`;
//     }
//     if (doc.createdAt) {
//       const created = doc.createdAt.seconds
//         ? new Date(doc.createdAt.seconds * 1000)
//         : new Date(doc.createdAt);
//       const age = Math.floor((Date.now() - created.getTime()) / (1000 * 60 * 60 * 24));
//       return `${age} days old (no expiry field)`;
//     }
//     return "Unknown age";
//   }

//   // Estimate doc size in KB based on resumeData presence
//   function estimateSize(d) {
//     try {
//       return Math.round(JSON.stringify(d).length / 1024);
//     } catch {
//       return 0;
//     }
//   }

//   async function scanExpired() {
//     setScanning(true);
//     setScanned(false);
//     setExpired([]);
//     setSelected(new Set());
//     setError("");
//     setLog([]);
//     addLog("Starting scan across all users...");

//     try {
//       const usersSnap = await getDocs(collection(db, "users"));
//       addLog(`Found ${usersSnap.docs.length} users — scanning documents...`);

//       const expiredDocs = [];
//       let totalScanned  = 0;

//       for (const userDoc of usersSnap.docs) {
//         const uid      = userDoc.id;
//         const userData = userDoc.data();
//         const email    = userData.email || uid;

//         // Check both collections
//         for (const colName of ["generatedDocs", "generatedResumes"]) {
//           try {
//             const colSnap = await getDocs(collection(db, "users", uid, colName));
//             totalScanned += colSnap.docs.length;

//             for (const d of colSnap.docs) {
//               const data = d.data();
//               if (isExpired(data)) {
//                 expiredDocs.push({
//                   uid,
//                   email,
//                   collection: colName,
//                   docId:      d.id,
//                   type:       data.type || (colName === "generatedResumes" ? "resume" : "unknown"),
//                   mode:       data.mode || "improved",
//                   createdAt:  data.createdAt,
//                   expiresAt:  data.expiresAt,
//                   expiryLabel: fmtExpiry(data),
//                   sizeKB:     estimateSize(data),
//                   hasData:    !!(data.resumeData || data.letterData),
//                 });
//               }
//             }
//           } catch (colErr) {
//             // Collection may not exist for this user — skip silently
//           }
//         }
//       }

//       addLog(`Scanned ${totalScanned} documents across ${usersSnap.docs.length} users`);
//       addLog(`Found ${expiredDocs.length} expired documents`);

//       // Sort by oldest first
//       expiredDocs.sort((a, b) => {
//         const aTime = a.createdAt?.seconds || 0;
//         const bTime = b.createdAt?.seconds || 0;
//         return aTime - bTime;
//       });

//       setExpired(expiredDocs);
//       setScanned(true);

//       if (expiredDocs.length === 0) {
//         addLog("✅ No expired documents found — database is clean");
//       } else {
//         const totalKB = expiredDocs.reduce((s, d) => s + d.sizeKB, 0);
//         addLog(`Total reclaimable storage: ~${totalKB}KB`);
//       }

//     } catch (err) {
//       setError(err.message);
//       addLog(`❌ Scan failed: ${err.message}`);
//     }
//     setScanning(false);
//   }

//   async function deleteSelected() {
//     const toDelete = expired.filter(d => selected.has(d.docId));
//     if (toDelete.length === 0) return;

//     setDeleting(true);
//     setError("");
//     addLog(`Starting deletion of ${toDelete.length} documents...`);

//     const deletedIds = [];
//     let failCount    = 0;

//     // Process in batches of 20 to avoid Firestore limits
//     const BATCH_SIZE = 20;
//     for (let i = 0; i < toDelete.length; i += BATCH_SIZE) {
//       const batch     = writeBatch(db);
//       const batchDocs = toDelete.slice(i, i + BATCH_SIZE);

//       batchDocs.forEach(d => {
//         const ref = doc(db, "users", d.uid, d.collection, d.docId);
//         batch.delete(ref);
//       });

//       try {
//         await batch.commit();
//         batchDocs.forEach(d => {
//           deletedIds.push(d.docId);
//           addLog(`🗑️ Deleted ${d.type} (${d.docId.slice(-8)}) — ${d.email}`);
//         });
//       } catch (batchErr) {
//         failCount += batchDocs.length;
//         addLog(`❌ Batch ${Math.floor(i / BATCH_SIZE) + 1} failed: ${batchErr.message}`);
//       }
//     }

//     // Remove deleted docs from expired list
//     setExpired(prev => prev.filter(d => !deletedIds.includes(d.docId)));
//     setDeleted(prev => [...prev, ...toDelete.filter(d => deletedIds.includes(d.docId))]);
//     setSelected(new Set());

//     addLog(`✅ Deleted ${deletedIds.length} documents${failCount > 0 ? ` (${failCount} failed)` : ""}`);
//     setDeleting(false);
//   }

//   // eslint-disable-next-line no-unused-vars
//   async function deleteAll() {
//     // Select all and delete
//     const allIds = new Set(filtered.map(d => d.docId));
//     setSelected(allIds);
//     // Small delay to let state update
//     setTimeout(() => deleteSelected(), 100);
//   }

//   function toggleSelect(docId) {
//     setSelected(prev => {
//       const next = new Set(prev);
//       if (next.has(docId)) next.delete(docId);
//       else next.add(docId);
//       return next;
//     });
//   }

//   function selectAll() {
//     setSelected(new Set(filtered.map(d => d.docId)));
//   }

//   function selectNone() {
//     setSelected(new Set());
//   }

//   const filtered = expired.filter(d =>
//     filterType === "all" ? true : d.type === filterType
//   );

//   const totalKB       = filtered.reduce((s, d) => s + d.sizeKB, 0);
//   const selectedCount = filtered.filter(d => selected.has(d.docId)).length;

//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

//       {/* Header */}
//       <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "20px 24px" }}>
//         <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 16, marginBottom: 16 }}>
//           <div>
//             <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>🗑️ Document Cleanup</h2>
//             <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>
//               Find and delete expired documents (older than 30 days) across all user accounts.
//               This frees up Firestore storage and keeps the database clean.
//             </p>
//           </div>
//           <button
//             onClick={scanExpired}
//             disabled={scanning || deleting}
//             style={{ padding: "10px 20px", background: scanning ? "#f1f5f9" : "linear-gradient(135deg,#2563eb,#1d4ed8)", color: scanning ? "#94a3b8" : "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: scanning ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}
//           >
//             {scanning ? (
//               <>
//                 <span style={{ width: 14, height: 14, borderRadius: "50%", border: "2px solid #e2e8f0", borderTopColor: "#94a3b8", animation: "spin 0.7s linear infinite", display: "inline-block" }} />
//                 Scanning...
//               </>
//             ) : "🔍 Scan for Expired Docs"}
//           </button>
//         </div>

//         {/* Stats row */}
//         {scanned && (
//           <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
//             {[
//               { label: "Expired docs", value: expired.length, color: expired.length > 0 ? "#dc2626" : "#059669", bg: expired.length > 0 ? "#fef2f2" : "#f0fdf4" },
//               { label: "Resumes",      value: expired.filter(d => d.type === "resume").length, color: "#7c3aed", bg: "#f5f3ff" },
//               { label: "Cover letters", value: expired.filter(d => d.type === "cover_letter").length, color: "#0891b2", bg: "#f0f9ff" },
//               { label: "Storage ~",    value: `${totalKB}KB`, color: "#d97706", bg: "#fffbeb" },
//               { label: "Deleted this session", value: deleted.length, color: "#059669", bg: "#f0fdf4" },
//             ].map(s => (
//               <div key={s.label} style={{ background: s.bg, borderRadius: 9, padding: "8px 14px", textAlign: "center", minWidth: 90 }}>
//                 <div style={{ fontSize: 9, fontWeight: 700, color: s.color, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 2 }}>{s.label}</div>
//                 <div style={{ fontSize: 20, fontWeight: 800, color: s.color }}>{s.value}</div>
//               </div>
//             ))}
//           </div>
//         )}

//         {error && (
//           <div style={{ marginTop: 12, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#dc2626" }}>
//             ❌ {error}
//           </div>
//         )}
//       </div>

//       {/* Controls */}
//       {scanned && expired.length > 0 && (
//         <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "14px 20px", display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
//           {/* Filter */}
//           <div style={{ display: "flex", gap: 6 }}>
//             {[
//               { id: "all",          label: `All (${expired.length})` },
//               { id: "resume",       label: `Resumes (${expired.filter(d=>d.type==="resume").length})` },
//               { id: "cover_letter", label: `Cover Letters (${expired.filter(d=>d.type==="cover_letter").length})` },
//             ].map(f => (
//               <button key={f.id} onClick={() => setFilterType(f.id)}
//                 style={{ padding: "5px 12px", borderRadius: 7, border: "1px solid", fontSize: 12, fontWeight: 600, cursor: "pointer", borderColor: filterType === f.id ? "#2563eb" : "#e2e8f0", background: filterType === f.id ? "#eff6ff" : "#fff", color: filterType === f.id ? "#2563eb" : "#64748b" }}>
//                 {f.label}
//               </button>
//             ))}
//           </div>

//           <div style={{ display: "flex", gap: 6, marginLeft: "auto" }}>
//             <button onClick={selectAll} style={{ padding: "5px 12px", background: "#f8fafc", color: "#374151", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
//               Select All
//             </button>
//             <button onClick={selectNone} style={{ padding: "5px 12px", background: "#f8fafc", color: "#374151", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
//               Select None
//             </button>
//             <button
//               onClick={deleteSelected}
//               disabled={selectedCount === 0 || deleting}
//               style={{ padding: "5px 14px", background: selectedCount > 0 ? "#dc2626" : "#f1f5f9", color: selectedCount > 0 ? "#fff" : "#94a3b8", border: "none", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: selectedCount > 0 ? "pointer" : "not-allowed", display: "flex", alignItems: "center", gap: 6 }}
//             >
//               {deleting ? (
//                 <>
//                   <span style={{ width: 12, height: 12, borderRadius: "50%", border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff", animation: "spin 0.7s linear infinite", display: "inline-block" }} />
//                   Deleting...
//                 </>
//               ) : `🗑️ Delete Selected (${selectedCount})`}
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Expired docs list */}
//       {scanned && (
//         <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>
//           {filtered.length === 0 ? (
//             <div style={{ textAlign: "center", padding: "48px 24px", color: "#94a3b8" }}>
//               <div style={{ fontSize: 36, marginBottom: 12 }}>✅</div>
//               <div style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>No expired documents found</div>
//               <div style={{ fontSize: 13, marginTop: 4 }}>Database is clean for this filter</div>
//             </div>
//           ) : (
//             <div>
//               {/* Table header */}
//               <div style={{ display: "grid", gridTemplateColumns: "40px 1fr 140px 100px 80px 80px", gap: 12, padding: "10px 16px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0", fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>
//                 <div></div>
//                 <div>User / Document</div>
//                 <div>Expiry</div>
//                 <div>Type</div>
//                 <div>Size</div>
//                 <div>Data</div>
//               </div>

//               {/* Rows */}
//               <div style={{ maxHeight: 500, overflowY: "auto" }}>
//                 {filtered.map((d, i) => (
//                   <div key={d.docId}
//                     onClick={() => toggleSelect(d.docId)}
//                     style={{ display: "grid", gridTemplateColumns: "40px 1fr 140px 100px 80px 80px", gap: 12, padding: "12px 16px", borderBottom: "1px solid #f1f5f9", cursor: "pointer", background: selected.has(d.docId) ? "#fef2f2" : i % 2 === 0 ? "#fff" : "#fafafa", transition: "background 0.1s" }}
//                   >
//                     {/* Checkbox */}
//                     <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
//                       <div style={{ width: 18, height: 18, borderRadius: 4, border: `2px solid ${selected.has(d.docId) ? "#dc2626" : "#d1d5db"}`, background: selected.has(d.docId) ? "#dc2626" : "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                         {selected.has(d.docId) && <span style={{ color: "#fff", fontSize: 11, fontWeight: 800 }}>✓</span>}
//                       </div>
//                     </div>

//                     {/* User / doc info */}
//                     <div>
//                       <div style={{ fontSize: 12, fontWeight: 600, color: "#0f172a", marginBottom: 2 }}>{d.email}</div>
//                       <div style={{ fontSize: 11, color: "#94a3b8", fontFamily: "monospace" }}>{d.docId.slice(-12)}</div>
//                     </div>

//                     {/* Expiry */}
//                     <div style={{ fontSize: 11, color: "#dc2626", display: "flex", alignItems: "center" }}>
//                       {d.expiryLabel}
//                     </div>

//                     {/* Type */}
//                     <div style={{ display: "flex", alignItems: "center" }}>
//                       <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 20, fontWeight: 600, background: d.type === "resume" ? "#f0fdf4" : "#f5f3ff", color: d.type === "resume" ? "#059669" : "#7c3aed" }}>
//                         {d.type === "resume" ? (d.mode === "scratch" ? "📝 Scratch" : "✨ Resume") : "✉️ Cover Letter"}
//                       </span>
//                     </div>

//                     {/* Size */}
//                     <div style={{ fontSize: 12, color: "#64748b", display: "flex", alignItems: "center" }}>
//                       {d.sizeKB}KB
//                     </div>

//                     {/* Has data */}
//                     <div style={{ display: "flex", alignItems: "center" }}>
//                       <span style={{ fontSize: 11, color: d.hasData ? "#059669" : "#94a3b8" }}>
//                         {d.hasData ? "✓ Has data" : "Empty"}
//                       </span>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Footer total */}
//               <div style={{ padding: "10px 16px", background: "#f8fafc", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                 <span style={{ fontSize: 12, color: "#64748b" }}>
//                   {filtered.length} expired documents · ~{totalKB}KB total · {selectedCount} selected
//                 </span>
//                 {filtered.length > 0 && (
//                   <button
//                     onClick={() => { selectAll(); setTimeout(deleteSelected, 100); }}
//                     disabled={deleting}
//                     style={{ padding: "6px 16px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer" }}
//                   >
//                     🗑️ Delete All {filtered.length} Expired
//                   </button>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Activity log */}
//       {log.length > 0 && (
//         <div style={{ background: "#0f172a", borderRadius: 14, padding: "16px 20px" }}>
//           <div style={{ fontSize: 12, fontWeight: 700, color: "#60a5fa", marginBottom: 10 }}>📋 Activity Log</div>
//           <div style={{ maxHeight: 200, overflowY: "auto", display: "flex", flexDirection: "column", gap: 4 }}>
//             {log.map((entry, i) => (
//               <div key={i} style={{ fontSize: 11, color: entry.includes("❌") ? "#f87171" : entry.includes("✅") ? "#34d399" : entry.includes("🗑️") ? "#fbbf24" : "#94a3b8", fontFamily: "monospace" }}>
//                 {entry}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Deleted summary */}
//       {deleted.length > 0 && (
//         <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 14, padding: "16px 20px" }}>
//           <div style={{ fontSize: 13, fontWeight: 700, color: "#059669", marginBottom: 8 }}>
//             ✅ {deleted.length} documents deleted this session
//           </div>
//           <div style={{ fontSize: 12, color: "#065f46" }}>
//             {deleted.filter(d => d.type === "resume").length} resumes · {deleted.filter(d => d.type === "cover_letter").length} cover letters · ~{deleted.reduce((s, d) => s + d.sizeKB, 0)}KB freed
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// new code
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import {
  // eslint-disable-next-line no-unused-vars
  collection, getDocs, doc, updateDoc, deleteDoc,
  // eslint-disable-next-line no-unused-vars
  serverTimestamp, writeBatch, query, where, orderBy, limit,
} from "firebase/firestore";
import { db } from "../utils/firebase";
import servicesConfig from "../utils/servicesConfig";
import apiConfig from "../utils/apiConfig";

const ADMIN_EMAILS  = ["arsh1916@gmail.com", "support@smartaicareer.com"];
const ADMIN_SECRET  = process.env.REACT_APP_ADMIN_SECRET || "";
const BACKEND       = apiConfig?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";

// ── Helpers ──
function fmtDate(ts) {
  if (!ts) return "—";
  const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}
function fmtTime(ts) {
  if (!ts) return "—";
  const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
  return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}
function fmtMoney(cents) { return `$${(cents / 100).toFixed(2)}`; }
function getPlanPrice(planId) {
  return servicesConfig.plans.find(p => p.id === planId)?.priceInCents || 199;
}
function getPlanName(planId) {
  return servicesConfig.plans.find(p => p.id === planId)?.name || planId || "Unknown";
}
function getPlanIncludes(planId, includes) {
  if (Array.isArray(includes) && includes.length > 0) return includes;
  return servicesConfig.plans.find(p => p.id === planId)?.includes || [];
}

// ── Stat card ──
function StatCard({ label, value, sub, color = "#2563eb", icon }) {
  return (
    <div style={{ background: "#fff", borderRadius: 14, padding: "20px 22px", border: "1px solid #e2e8f0", flex: 1, minWidth: 140 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>{icon}</div>
        <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</span>
      </div>
      <div style={{ fontSize: 28, fontWeight: 800, color: "#0f172a", letterSpacing: "-0.02em" }}>{value}</div>
      {sub && <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{sub}</div>}
    </div>
  );
}

// ── Service tag ──
function ServiceTag({ code, used }) {
  const svc = servicesConfig.services.find(s => s.serviceCode === code);
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4,
      fontSize: 11, padding: "3px 8px", borderRadius: 20, fontWeight: 600,
      background: used ? "#f0fdf4" : "#f8fafc",
      color: used ? "#059669" : "#94a3b8",
      border: `1px solid ${used ? "#bbf7d0" : "#e2e8f0"}`,
    }}>
      {svc?.icon || "•"} {svc?.title || code}
      {used ? " ✓" : " —"}
    </span>
  );
}

// ── Refund button — handles the full flow ──
function RefundButton({ uid, tx, userEmail, userName, onRefunded }) {
  const [state,  setState]  = useState("idle"); // idle | confirm | loading | done | error
  const [error,  setError]  = useState("");
  const [reason, setReason] = useState("requested_by_customer");

  const REASONS = [
    { value: "requested_by_customer", label: "Requested by customer" },
    { value: "duplicate",             label: "Duplicate charge" },
    { value: "fraudulent",            label: "Fraudulent" },
    { value: "service_not_delivered", label: "Service not delivered" },
  ];

  // Already refunded — show badge only
  if (tx.refunded) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span style={{ fontSize: 11, background: "#fef2f2", color: "#dc2626", padding: "3px 10px", borderRadius: 20, fontWeight: 700, border: "1px solid #fecaca" }}>
          ↩ Refunded {tx.refundAmount ? fmtMoney(tx.refundAmount) : ""} · {fmtDate(tx.refundedAt)}
        </span>
        {tx.refundId && (
          <span style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>
            {tx.refundId.slice(-8)}
          </span>
        )}
      </div>
    );
  }

// // ── Refund button — handles the full flow ──
// function RefundButton({ uid, tx, onRefunded }) {
//   const [state,  setState]  = useState("idle"); // idle | confirm | loading | done | error
//   const [error,  setError]  = useState("");
//   const [reason, setReason] = useState("requested_by_customer");

//   const REASONS = [
//     { value: "requested_by_customer", label: "Requested by customer" },
//     { value: "duplicate",             label: "Duplicate charge" },
//     { value: "fraudulent",            label: "Fraudulent" },
//     { value: "service_not_delivered", label: "Service not delivered" },
//   ];

//   // Already refunded — show badge only
//   if (tx.refunded) {
//     return (
//       <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//         <span style={{ fontSize: 11, background: "#fef2f2", color: "#dc2626", padding: "3px 10px", borderRadius: 20, fontWeight: 700, border: "1px solid #fecaca" }}>
//           ↩ Refunded {tx.refundAmount ? fmtMoney(tx.refundAmount) : ""} · {fmtDate(tx.refundedAt)}
//         </span>
//         {tx.refundId && (
//           <span style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>
//             {tx.refundId.slice(-8)}
//           </span>
//         )}
//       </div>
//     );
//   }

  async function handleRefund() {
    setState("loading");
    setError("");
    try {
      // Step 1 — call server to issue Stripe refund
      const res = await fetch(`${BACKEND}/admin/refund`, {
        method:  "POST",
        headers: {
          "Content-Type":  "application/json",
          "x-admin-token": ADMIN_SECRET,
        },
        body: JSON.stringify({
          paymentIntentId: tx.paymentIntentId,
          reason,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Refund failed");

      // Step 2 — record refund in Firestore on the transaction doc
      await updateDoc(doc(db, "users", uid, "transactions", tx.id), {
        refunded:    true,
        refundId:    data.refundId,
        refundAmount: data.amount,
        refundReason: reason,
        refundStatus: data.status,
        refundedAt:  serverTimestamp(),
        refundedBy:  "admin",
      });

      setState("done");
      onRefunded(tx.id, {
        refunded:     true,
        refundId:     data.refundId,
        refundAmount: data.amount,
        refundReason: reason,
        refundStatus: data.status,
      });

      // Send refund confirmation email — non-blocking
      fetch(`${BACKEND}/email/refund`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userEmail:     userEmail,   // ← prop, not u.email
          userName:      userName,    // ← prop, not u.firstName
          amount:        fmtMoney(data.amount),
          reason:        reason,
          transactionId: tx.id?.slice(-8)?.toUpperCase(),
        }),
      }).catch(err => console.warn("Refund email failed (non-critical):", err.message));

    } catch (err) {
      console.error("Refund error:", err.message);
      setError(err.message);
      setState("error");
    }
  }

  if (state === "done") {
    return (
      <span style={{ fontSize: 11, background: "#f0fdf4", color: "#059669", padding: "3px 10px", borderRadius: 20, fontWeight: 700, border: "1px solid #bbf7d0" }}>
        ✓ Refund issued
      </span>
    );
  }

  if (state === "confirm") {
    return (
      <div style={{ background: "#fef2f2", borderRadius: 10, padding: "12px 14px", border: "1px solid #fecaca", marginTop: 8 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#dc2626", marginBottom: 8 }}>
          Confirm refund of {fmtMoney(getPlanPrice(tx.planId))} to this user?
        </div>
        <div style={{ marginBottom: 10 }}>
          <select
            value={reason}
            onChange={e => setReason(e.target.value)}
            style={{ width: "100%", padding: "6px 10px", border: "1px solid #fecaca", borderRadius: 7, fontSize: 12, background: "#fff" }}
          >
            {REASONS.map(r => (
              <option key={r.value} value={r.value}>{r.label}</option>
            ))}
          </select>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button
            onClick={handleRefund}
            style={{ padding: "6px 14px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer" }}
          >
            Yes, refund now
          </button>
          <button
            onClick={() => setState("idle")}
            style={{ padding: "6px 14px", background: "#fff", color: "#64748b", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, cursor: "pointer" }}
          >
            Cancel
          </button>
        </div>
        {state === "error" && (
          <div style={{ fontSize: 12, color: "#dc2626", marginTop: 8 }}>{error}</div>
        )}
      </div>
    );
  }

  if (state === "loading") {
    return (
      <span style={{ fontSize: 12, color: "#64748b", display: "flex", alignItems: "center", gap: 6 }}>
        <span style={{ width: 12, height: 12, borderRadius: "50%", border: "2px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.7s linear infinite", display: "inline-block" }} />
        Processing refund...
      </span>
    );
  }

  return (
    <div>
      <button
        onClick={() => setState("confirm")}
        style={{ padding: "5px 12px", background: "#fff", color: "#dc2626", border: "1.5px solid #fca5a5", borderRadius: 7, fontSize: 11, fontWeight: 700, cursor: "pointer", transition: "all 0.15s" }}
        onMouseEnter={e => { e.currentTarget.style.background = "#fef2f2"; }}
        onMouseLeave={e => { e.currentTarget.style.background = "#fff"; }}
      >
        ↩ Issue Refund
      </button>
      {state === "error" && (
        <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>{error}</div>
      )}
    </div>
  );
}

export default function AdminPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [activeTab,   setActiveTab]   = useState("users");
  const [loading,     setLoading]     = useState(true);
  const [users,       setUsers]       = useState([]);
  const [filter,      setFilter]      = useState("all");
  const [planFilter,  setPlanFilter]  = useState("all");
  const [search,      setSearch]      = useState("");
  const [expanded,    setExpanded]    = useState(null);
  const [sortBy,      setSortBy]      = useState("recent");

  useEffect(() => {
    if (!user) { navigate("/login"); return; }
    if (!ADMIN_EMAILS.includes(user.email)) { navigate("/dashboard"); return; }
  }, [user, navigate]);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const usersSnap = await getDocs(collection(db, "users"));
      const usersData = [];

      for (const userDoc of usersSnap.docs) {
        const userData = userDoc.data();
        const uid = userDoc.id;

        const txSnap = await getDocs(collection(db, "users", uid, "transactions"));
        const transactions = txSnap.docs.map(d => ({ id: d.id, ...d.data() }))
          .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

        const analysesSnap = await getDocs(collection(db, "users", uid, "analyses"));
        const analyses = analysesSnap.docs.map(d => ({ id: d.id, ...d.data() }))
          .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

        const paidTransactions = transactions.filter(t => t.status === "paid");
        const totalRevenue = paidTransactions.reduce((sum, t) => sum + getPlanPrice(t.planId), 0);
        const refundedAmount = paidTransactions
          .filter(t => t.refunded)
          .reduce((sum, t) => sum + (t.refundAmount || getPlanPrice(t.planId)), 0);

        const firstName = userData.firstName || userData.displayName?.split(" ")[0] || "";
        const lastName  = userData.lastName  || userData.displayName?.split(" ").slice(1).join(" ") || "";
        const email     = userData.email     || uid;

        const templatesUsed = transactions
          .filter(t => t.resumeGenerated && t.resumeTemplateId)
          .map(t => t.resumeTemplateId);
        const templateCounts = templatesUsed.reduce((acc, t) => {
          acc[t] = (acc[t] || 0) + 1; return acc;
        }, {});

        usersData.push({
          uid, email, firstName, lastName,
          createdAt:             userData.createdAt,
          lastPaymentAt:         userData.lastPaymentAt,
          totalPayments:         userData.totalPayments  || paidTransactions.length,
          totalAnalyses:         userData.totalAnalyses  || transactions.filter(t => t.analysed).length,
          totalResumesGenerated: userData.totalResumesGenerated || transactions.filter(t => t.resumeGenerated).length,
          transactions:          paidTransactions,
          analyses,
          totalRevenue,
          refundedAmount,
          templateCounts,
        });
      }

      setUsers(usersData);
    } catch (err) {
      console.error("Admin load error:", err);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (user && ADMIN_EMAILS.includes(user.email)) loadData();
  }, [user, loadData]);

  // ── Update a transaction locally after refund — no reload needed ──
  function handleRefunded(uid, txId, refundData) {
    setUsers(prev => prev.map(u => {
      if (u.uid !== uid) return u;
      return {
        ...u,
        refundedAmount: (u.refundedAmount || 0) + (refundData.refundAmount || 0),
        transactions: u.transactions.map(t =>
          t.id === txId ? { ...t, ...refundData } : t
        ),
      };
    }));
  }

  // ── Derived stats ──
  const totalUsers      = users.length;
  const totalRevenue    = users.reduce((s, u) => s + u.totalRevenue, 0);
  const totalRefunded   = users.reduce((s, u) => s + (u.refundedAmount || 0), 0);
  const totalTx         = users.reduce((s, u) => s + u.transactions.length, 0);
  const totalAnalyses   = users.reduce((s, u) => s + u.totalAnalyses, 0);
  const pendingUsers    = users.filter(u => u.transactions.some(t => !t.analysed)).length;
  const refundedCount   = users.reduce((s, u) => s + u.transactions.filter(t => t.refunded).length, 0);

  const filteredUsers = users
    .filter(u => {
      if (search) {
        const q = search.toLowerCase();
        if (!u.email.toLowerCase().includes(q) &&
            !`${u.firstName} ${u.lastName}`.toLowerCase().includes(q)) return false;
      }
      if (planFilter !== "all") {
        if (!u.transactions.some(t => t.planId === planFilter)) return false;
      }
      if (filter === "paid")     return u.transactions.length > 0;
      if (filter === "analysed") return u.totalAnalyses > 0;
      if (filter === "pending")  return u.transactions.some(t => t.status === "paid" && !t.analysed);
      if (filter === "refunded") return u.transactions.some(t => t.refunded);
      return true;
    })
    .sort((a, b) => {
      if (sortBy === "revenue") return b.totalRevenue - a.totalRevenue;
      if (sortBy === "name")    return `${a.firstName}${a.lastName}`.localeCompare(`${b.firstName}${b.lastName}`);
      return (b.lastPaymentAt?.seconds || b.createdAt?.seconds || 0) - (a.lastPaymentAt?.seconds || a.createdAt?.seconds || 0);
    });

  if (!user || !ADMIN_EMAILS.includes(user?.email)) return null;

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Inter',-apple-system,sans-serif" }}>
      <style>{`
        * { box-sizing: border-box; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 768px) {
          .admin-stats { flex-wrap: wrap !important; }
          .admin-stats > div { min-width: calc(50% - 8px) !important; }
          .admin-filters { flex-wrap: wrap !important; }
          .plan-body-grid { grid-template-columns: 1fr !important; gap: 20px !important; }
          .services-grid { grid-template-columns: 1fr !important; }
          .templates-grid { grid-template-columns: 1fr !important; }
          .revenue-breakdown { flex-direction: column !important; }
          .user-row { flex-wrap: wrap !important; }
          .filter-buttons { flex-wrap: wrap !important; }
          .transaction-header { flex-direction: column !important; align-items: flex-start !important; }
          .analysis-details { flex-direction: column !important; align-items: flex-start !important; }
        }
        @media (max-width: 480px) {
          .admin-stats > div { min-width: 100% !important; }
        }
      `}</style>

      {/* NAV */}
      <nav style={{ background: "#0f172a", padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 32, height: 32, background: "linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>R</span>
          </div>
          <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>ResumeScoreAI</span>
          <span style={{ background: "#1e293b", color: "#94a3b8", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>Admin</span>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ display: "flex", background: "#1e293b", borderRadius: 9, padding: 3, gap: 2 }}>
            {[{ id: "users", label: "👥 Users" }, { id: "plans", label: "📦 Plans" }, { id: "cleanup", label: "🗑️ Cleanup" }, { id: "emails", label: "📧 Emails" }].map(tab => (
              <button key={tab.id} onClick={() => setActiveTab(tab.id)}
                style={{ padding: "6px 12px", borderRadius: 7, border: "none", fontSize: 12, fontWeight: 600, cursor: "pointer", background: activeTab === tab.id ? "#fff" : "transparent", color: activeTab === tab.id ? "#0f172a" : "#64748b", transition: "all 0.2s" }}
              >{tab.label}</button>
            ))}
          </div>
          <button onClick={loadData} style={{ padding: "7px 14px", background: "#1e293b", color: "#94a3b8", border: "1px solid #334155", borderRadius: 8, fontSize: 13, cursor: "pointer" }}>🔄 Refresh</button>
          <button onClick={() => navigate("/dashboard")} style={{ padding: "7px 14px", background: "transparent", color: "#64748b", border: "1px solid #334155", borderRadius: 8, fontSize: 13, cursor: "pointer" }}>← Dashboard</button>
        </div>
      </nav>

      <div style={{ maxWidth: 1300, margin: "0 auto", padding: "24px 16px" }}>
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ fontSize: "clamp(22px,6vw,26px)", fontWeight: 800, color: "#0f172a", marginBottom: 4, letterSpacing: "-0.02em" }}>Admin Dashboard</h1>
          <p style={{ fontSize: 14, color: "#64748b" }}>User transactions, refunds, and service utilization</p>
        </div>

        {activeTab === "plans" && <PlansTab />}
        {activeTab === "cleanup" && <CleanupTab />}
        {activeTab === "emails"  && <EmailLogsTab />}

        {activeTab === "users" && (loading ? (
          <div style={{ textAlign: "center", padding: "80px 20px" }}>
            <div style={{ width: 40, height: 40, borderRadius: "50%", border: "4px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.8s linear infinite", margin: "0 auto 16px" }} />
            <p style={{ color: "#64748b", fontSize: 14 }}>Loading all user data...</p>
          </div>
        ) : (
          <>
            {/* STATS */}
            <div className="admin-stats" style={{ display: "flex", gap: 16, marginBottom: 20, flexWrap: "wrap" }}>
              <StatCard label="Total Users"   value={totalUsers}    icon="👥" color="#2563eb" sub={`${pendingUsers} with pending analysis`} />
              <StatCard label="Analyses Done" value={totalAnalyses} icon="🎯" color="#0891b2" sub="completed analyses" />
              <StatCard label="Refunds Issued" value={refundedCount} icon="↩" color="#dc2626" sub={fmtMoney(totalRefunded)} />
            </div>

            {/* REVENUE SUMMARY — prominent, always visible */}
            <div style={{ background: "#0f172a", borderRadius: 16, padding: "20px 24px", marginBottom: 24, display: "flex", gap: 0, flexWrap: "wrap", overflow: "hidden", position: "relative" }}>
              <div style={{ position: "absolute", top: -30, right: -30, width: 160, height: 160, borderRadius: "50%", background: "radial-gradient(circle,rgba(37,99,235,0.15),transparent)", pointerEvents: "none" }} />

              {/* Gross */}
              <div style={{ flex: 1, minWidth: 140, padding: "0 20px 0 0", borderRight: "1px solid #1e293b" }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Gross Revenue</div>
                <div style={{ fontSize: 32, fontWeight: 800, color: "#fff", letterSpacing: "-0.03em" }}>{fmtMoney(totalRevenue)}</div>
                <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>{totalTx} paid transactions</div>
              </div>

              {/* Refunded */}
              <div style={{ flex: 1, minWidth: 140, padding: "0 20px", borderRight: "1px solid #1e293b" }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Refunded</div>
                <div style={{ fontSize: 32, fontWeight: 800, color: "#dc2626", letterSpacing: "-0.03em" }}>− {fmtMoney(totalRefunded)}</div>
                <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>{refundedCount} refund{refundedCount !== 1 ? "s" : ""} issued</div>
              </div>

              {/* Net — highlighted */}
              <div style={{ flex: 1, minWidth: 140, padding: "0 0 0 20px", position: "relative" }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#60a5fa", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Net Revenue</div>
                <div style={{ fontSize: 32, fontWeight: 800, color: "#60a5fa", letterSpacing: "-0.03em" }}>{fmtMoney(totalRevenue - totalRefunded)}</div>
                <div style={{ fontSize: 12, color: "#475569", marginTop: 4 }}>after all refunds</div>
                {totalRefunded > 0 && (
                  <div style={{ marginTop: 8, fontSize: 11, color: "#475569" }}>
                    Refund rate:{" "}
                    <span style={{ color: totalRefunded / totalRevenue > 0.1 ? "#dc2626" : "#64748b", fontWeight: 700 }}>
                      {Math.round((totalRefunded / totalRevenue) * 100)}%
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* PLAN BREAKDOWN */}
            <div style={{ background: "#fff", borderRadius: 14, padding: "16px 20px", border: "1px solid #e2e8f0", marginBottom: 24 }}>
              <h3 style={{ fontSize: 14, fontWeight: 700, color: "#374151", marginBottom: 16 }}>Revenue by Plan</h3>
              <div className="revenue-breakdown" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                {servicesConfig.plans.filter(p => p.enabled).map(plan => {
                  const planTxs = users.flatMap(u => u.transactions.filter(t => t.planId === plan.id));
                  const planRevenue = planTxs.length * plan.priceInCents;
                  const planRefunds = planTxs.filter(t => t.refunded).length * plan.priceInCents;
                  return (
                    <div key={plan.id} style={{ flex: 1, minWidth: 150, background: "#f8fafc", borderRadius: 10, padding: "12px 14px", border: "1px solid #e2e8f0" }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 6 }}>{plan.name}</div>

                      {/* Gross */}
                      <div style={{ display: "flex", alignItems: "baseline", gap: 4, marginBottom: 2 }}>
                        <div style={{ fontSize: 20, fontWeight: 800, color: "#0f172a" }}>{fmtMoney(planRevenue)}</div>
                        <div style={{ fontSize: 11, color: "#94a3b8" }}>gross</div>
                      </div>

                      {/* Refunded */}
                      {planRefunds > 0 && (
                        <div style={{ display: "flex", alignItems: "baseline", gap: 4, marginBottom: 2 }}>
                          <div style={{ fontSize: 14, fontWeight: 700, color: "#dc2626" }}>− {fmtMoney(planRefunds)}</div>
                          <div style={{ fontSize: 11, color: "#dc2626" }}>refunded</div>
                        </div>
                      )}

                      {/* Net */}
                      <div style={{ display: "flex", alignItems: "baseline", gap: 4, paddingTop: planRefunds > 0 ? 6 : 0, borderTop: planRefunds > 0 ? "1px solid #e2e8f0" : "none", marginTop: planRefunds > 0 ? 4 : 0 }}>
                        <div style={{ fontSize: planRefunds > 0 ? 18 : 14, fontWeight: 800, color: planRefunds > 0 ? "#2563eb" : "#94a3b8" }}>
                          {fmtMoney(planRevenue - planRefunds)}
                        </div>
                        <div style={{ fontSize: 11, color: planRefunds > 0 ? "#2563eb" : "#94a3b8" }}>net</div>
                      </div>

                      <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 6, display: "flex", gap: 8, flexWrap: "wrap" }}>
                        <span>{planTxs.length} purchases</span>
                        {planTxs.filter(t => t.refunded).length > 0 && (
                          <span style={{ color: "#dc2626" }}>
                            {planTxs.filter(t => t.refunded).length} refunded
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* FILTERS */}
            <div className="admin-filters" style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap", alignItems: "center" }}>
              <input
                type="text" placeholder="🔍 Search by name or email..."
                value={search} onChange={e => setSearch(e.target.value)}
                style={{ padding: "9px 14px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 13, minWidth: 200, flex: "1 1 200px", outline: "none", background: "#fff" }}
              />
              <div className="filter-buttons" style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {[
                  { id: "all",      label: "All Users" },
                  { id: "paid",     label: "💳 Paid" },
                  { id: "analysed", label: "✅ Analysed" },
                  { id: "pending",  label: "⏳ Pending" },
                  { id: "refunded", label: "↩ Refunded" },
                ].map(f => (
                  <button key={f.id} onClick={() => setFilter(f.id)}
                    style={{ padding: "7px 12px", borderRadius: 8, border: "1px solid", fontSize: 12, fontWeight: 600, cursor: "pointer", borderColor: filter === f.id ? "#2563eb" : "#e2e8f0", background: filter === f.id ? "#eff6ff" : "#fff", color: filter === f.id ? "#2563eb" : "#64748b", whiteSpace: "nowrap" }}
                  >{f.label}</button>
                ))}
              </div>
              <select value={planFilter} onChange={e => setPlanFilter(e.target.value)}
                style={{ padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 12, fontWeight: 600, color: "#374151", background: "#fff", cursor: "pointer" }}>
                <option value="all">All Plans</option>
                {servicesConfig.plans.filter(p => p.enabled).map(p => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
              <select value={sortBy} onChange={e => setSortBy(e.target.value)}
                style={{ padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 12, fontWeight: 600, color: "#374151", background: "#fff", cursor: "pointer" }}>
                <option value="recent">Sort: Most Recent</option>
                <option value="revenue">Sort: Highest Revenue</option>
                <option value="name">Sort: Name A–Z</option>
              </select>
              <span style={{ fontSize: 13, color: "#94a3b8", marginLeft: "auto" }}>{filteredUsers.length} of {totalUsers} users</span>
            </div>

            {/* USERS LIST */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {filteredUsers.length === 0 ? (
                <div style={{ textAlign: "center", padding: "48px", background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", color: "#94a3b8" }}>
                  No users match your filters.
                </div>
              ) : filteredUsers.map(u => (
                <div key={u.uid} style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>

                  {/* User row */}
                  <div
                    onClick={() => setExpanded(expanded === u.uid ? null : u.uid)}
                    className="user-row"
                    style={{ padding: "16px 20px", cursor: "pointer", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}
                  >
                    <div style={{ width: 42, height: 42, borderRadius: "50%", background: `linear-gradient(135deg,${["#2563eb","#7c3aed","#059669","#d97706"][u.uid.charCodeAt(0) % 4]},${["#1d4ed8","#6d28d9","#047857","#b45309"][u.uid.charCodeAt(0) % 4]})`, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: 15, flexShrink: 0 }}>
                      {(u.firstName?.[0] || u.email?.[0] || "?").toUpperCase()}
                    </div>
                    <div style={{ flex: 1, minWidth: 160 }}>
                      <div style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>
                        {u.firstName || u.lastName ? `${u.firstName} ${u.lastName}`.trim() : u.email?.split("@")[0] || "Unknown"}
                      </div>
                      <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{u.email}</div>
                    </div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.transactions.length > 0 ? "#eff6ff" : "#f8fafc", color: u.transactions.length > 0 ? "#2563eb" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.transactions.length > 0 ? "#bfdbfe" : "#e2e8f0" }}>
                        💳 {u.transactions.length} {u.transactions.length === 1 ? "payment" : "payments"}
                      </span>
                      <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: u.totalAnalyses > 0 ? "#f0fdf4" : "#f8fafc", color: u.totalAnalyses > 0 ? "#059669" : "#94a3b8", fontWeight: 600, border: "1px solid", borderColor: u.totalAnalyses > 0 ? "#bbf7d0" : "#e2e8f0" }}>
                        🎯 {u.totalAnalyses} {u.totalAnalyses === 1 ? "analysis" : "analyses"}
                      </span>
                      {u.totalRevenue > 0 && (
                        <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#f0fdf4", color: "#059669", fontWeight: 700, border: "1px solid #bbf7d0" }}>
                          {fmtMoney(u.totalRevenue)}
                        </span>
                      )}
                      {u.refundedAmount > 0 && (
                        <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#fef2f2", color: "#dc2626", fontWeight: 700, border: "1px solid #fecaca" }}>
                          ↩ {fmtMoney(u.refundedAmount)}
                        </span>
                      )}
                      {u.transactions.some(t => !t.analysed && !t.refunded) && (
                        <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#fffbeb", color: "#d97706", fontWeight: 600, border: "1px solid #fde68a" }}>⏳ Pending</span>
                      )}
                    </div>
                    <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "right", minWidth: 90 }}>Joined {fmtDate(u.createdAt)}</div>
                    <span style={{ fontSize: 12, color: "#94a3b8", transition: "transform 0.2s", display: "inline-block", transform: expanded === u.uid ? "rotate(180deg)" : "rotate(0)" }}>▼</span>
                  </div>

                  {/* Expanded detail */}
                  {expanded === u.uid && (
                    <div style={{ borderTop: "1px solid #f1f5f9", padding: "20px 20px 24px" }}>
                      {u.transactions.length === 0 ? (
                        <p style={{ fontSize: 13, color: "#94a3b8", fontStyle: "italic" }}>No transactions yet.</p>
                      ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                          <h4 style={{ fontSize: 13, fontWeight: 700, color: "#374151", margin: 0 }}>
                            Transactions ({u.transactions.length})
                          </h4>

                          {u.transactions.map(tx => {
                            const includes  = getPlanIncludes(tx.planId, tx.includes);
                            const analysis  = u.analyses.find(a => a.transactionId === tx.id);

                            return (
                              <div key={tx.id} style={{ background: tx.refunded ? "#fef9f9" : "#f8fafc", borderRadius: 12, padding: "16px 18px", border: `1px solid ${tx.refunded ? "#fecaca" : "#e2e8f0"}` }}>

                                {/* Transaction header */}
                                <div className="transaction-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
                                  <div>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                      <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{getPlanName(tx.planId)}</span>
                                      <span style={{ fontSize: 11, background: "#eff6ff", color: "#2563eb", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: "1px solid #bfdbfe" }}>
                                        {fmtMoney(getPlanPrice(tx.planId))}
                                      </span>
                                      <span style={{ fontSize: 11, background: tx.analysed ? "#f0fdf4" : "#fffbeb", color: tx.analysed ? "#059669" : "#d97706", padding: "2px 8px", borderRadius: 20, fontWeight: 600, border: `1px solid ${tx.analysed ? "#bbf7d0" : "#fde68a"}` }}>
                                        {tx.analysed ? "✅ Analysed" : "⏳ Pending"}
                                      </span>
                                      {tx.refunded && (
                                        <span style={{ fontSize: 11, background: "#fef2f2", color: "#dc2626", padding: "2px 8px", borderRadius: 20, fontWeight: 700, border: "1px solid #fecaca" }}>
                                          ↩ Refunded
                                        </span>
                                      )}
                                    </div>
                                    <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
                                      {fmtTime(tx.createdAt)} · TX: {tx.id?.slice(-8)?.toUpperCase()}
                                    </div>
                                    <div style={{ fontSize: 11, color: "#94a3b8" }}>
                                      Payment: {tx.paymentIntentId?.slice(-12)}
                                    </div>
                                  </div>

                                  {/* Refund button — only for paid, non-refunded transactions */}
                                  <RefundButton
                                    uid={u.uid}
                                    tx={tx}
                                    userEmail={u.email}                                          // ← add this
                                    userName={`${u.firstName} ${u.lastName}`.trim() || u.email} // ← add this
                                    onRefunded={(txId, refundData) => handleRefunded(u.uid, txId, refundData)}
                                  />
                                </div>

                                {/* Services */}
                                <div style={{ marginBottom: 12 }}>
                                  <div style={{ fontSize: 11, fontWeight: 600, color: "#64748b", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>Services in this plan</div>
                                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                                    {includes.map(code => {
                                      let used = false;
                                      if (code === "ATS_ANALYSIS")     used = tx.analysed;
                                      if (code === "ATS_RESUME_SAMPLE") used = tx.resumeGenerated;
                                      if (code === "DOCUMENT_SUMMARY") used = tx.documentSummarized;
                                      if (code === "DOCUMENT_CHAT")    used = tx.documentChatUsed;
                                      return <ServiceTag key={code} code={code} used={used} />;
                                    })}
                                  </div>
                                </div>

                                {/* Analysis */}
                                {analysis && (
                                  <div style={{ background: "#fff", borderRadius: 8, padding: "12px 14px", border: "1px solid #e2e8f0" }}>
                                    <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 8 }}>Analysis Result</div>
                                    <div className="analysis-details" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                                      <div style={{ textAlign: "center" }}>
                                        <div style={{ fontSize: 22, fontWeight: 800, color: analysis.ats_score >= 70 ? "#059669" : analysis.ats_score >= 50 ? "#d97706" : "#dc2626" }}>
                                          {analysis.ats_score}
                                        </div>
                                        <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>ATS SCORE</div>
                                      </div>
                                      <div style={{ textAlign: "center" }}>
                                        <div style={{ fontSize: 22, fontWeight: 800, color: "#374151" }}>{analysis.match_rate || "—"}%</div>
                                        <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>MATCH RATE</div>
                                      </div>
                                      <div style={{ textAlign: "center" }}>
                                        <div style={{ fontSize: 22, fontWeight: 800, color: "#374151" }}>{analysis.missing_count || 0}</div>
                                        <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>MISSING KW</div>
                                      </div>
                                      <div style={{ flex: 1, minWidth: 160, fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
                                        {analysis.summary?.slice(0, 120)}{analysis.summary?.length > 120 ? "..." : ""}
                                      </div>
                                    </div>
                                    <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>Completed {fmtTime(analysis.createdAt)}</div>
                                  </div>
                                )}

                                {/* Refund record if done */}
                                {tx.refunded && tx.refundId && (
                                  <div style={{ marginTop: 10, background: "#fef2f2", borderRadius: 8, padding: "10px 14px", border: "1px solid #fecaca" }}>
                                    <div style={{ fontSize: 11, fontWeight: 700, color: "#dc2626", marginBottom: 4 }}>Refund Record</div>
                                    <div style={{ fontSize: 11, color: "#7f1d1d", lineHeight: 1.7 }}>
                                      <div>Refund ID: <code style={{ fontFamily: "monospace" }}>{tx.refundId}</code></div>
                                      <div>Amount: {tx.refundAmount ? fmtMoney(tx.refundAmount) : "Full amount"}</div>
                                      <div>Reason: {tx.refundReason || "—"}</div>
                                      <div>Status: {tx.refundStatus || "—"}</div>
                                      <div>Issued: {fmtDate(tx.refundedAt)}</div>
                                    </div>
                                  </div>
                                )}

                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        ))}
      </div>
    </div>
  );
}

// ── Plans tab — unchanged from original ──
function PlansTab() {
  const plans    = servicesConfig.plans;
  const services = servicesConfig.services;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 28 }}>
      <div>
        <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>Plans ({plans.length})</h2>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {plans.map(plan => (
            <div key={plan.id} style={{ background: "#fff", borderRadius: 14, border: `1.5px solid ${plan.active ? "#bfdbfe" : "#e2e8f0"}`, overflow: "hidden" }}>
              <div style={{ padding: "16px 20px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap", background: plan.active ? "#f0f7ff" : "#f8fafc" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 4 }}>
                    <span style={{ fontSize: 15, fontWeight: 800, color: "#0f172a" }}>{plan.name}</span>
                    <span style={{ fontSize: 11, background: plan.active ? "#dcfce7" : "#f1f5f9", color: plan.active ? "#059669" : "#94a3b8", padding: "2px 8px", borderRadius: 20, fontWeight: 700 }}>
                      {plan.active ? "● Active" : "○ Coming Soon"}
                    </span>
                  </div>
                  <div style={{ fontSize: 13, color: "#64748b" }}>{plan.description}</div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 26, fontWeight: 800, color: "#1d4ed8" }}>{plan.price}</div>
                  <div style={{ fontSize: 11, color: "#94a3b8" }}>{plan.period}</div>
                </div>
              </div>
              <div style={{ padding: "12px 20px", background: "#f8fafc", borderTop: "1px solid #f1f5f9", fontSize: 10, color: "#94a3b8", fontFamily: "monospace", display: "flex", gap: 16, flexWrap: "wrap" }}>
                <span>id: "{plan.id}"</span>
                <span>priceInCents: {plan.priceInCents}</span>
                <span>includes: [{(plan.includes || []).join(", ")}]</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>Services ({services.length})</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 12 }}>
          {services.map(svc => (
            <div key={svc.serviceCode} style={{ background: "#fff", borderRadius: 12, border: `1.5px solid ${svc.active ? "#bbf7d0" : "#e2e8f0"}`, padding: "16px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 22 }}>{svc.icon}</span>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{svc.title}</div>
                    <div style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>{svc.serviceCode}</div>
                  </div>
                </div>
                <span style={{ fontSize: 10, background: svc.active ? "#dcfce7" : "#f1f5f9", color: svc.active ? "#059669" : "#94a3b8", padding: "2px 8px", borderRadius: 10, fontWeight: 700 }}>
                  {svc.active ? "● Active" : "○ Inactive"}
                </span>
              </div>
              <p style={{ fontSize: 12, color: "#64748b", lineHeight: 1.6 }}>{svc.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
// CLEANUP TAB
// Finds and deletes/archives expired documents (>30 days old)
// across all users' generatedDocs and generatedResumes collections
// Accessible only to admin emails
// ─────────────────────────────────────────────────────────────
function CleanupTab() {
  const [scanning,   setScanning]   = useState(false);
  const [deleting,   setDeleting]   = useState(false);
  const [scanned,    setScanned]    = useState(false);
  const [expired,    setExpired]    = useState([]);   // { uid, email, collection, docId, type, createdAt, expiresAt, size }
  const [deleted,    setDeleted]    = useState([]);
  const [error,      setError]      = useState("");
  const [selected,   setSelected]   = useState(new Set()); // selected doc ids
  const [filterType, setFilterType] = useState("all");     // all | resume | cover_letter
  const [log,        setLog]        = useState([]);

  const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

  function addLog(msg) {
    setLog(prev => [`${new Date().toLocaleTimeString()} — ${msg}`, ...prev.slice(0, 49)]);
  }

  function isExpired(doc) {
    // Check expiresAt first, fall back to createdAt + 30 days
    if (doc.expiresAt) {
      const exp = doc.expiresAt.seconds
        ? new Date(doc.expiresAt.seconds * 1000)
        : new Date(doc.expiresAt);
      return exp < new Date();
    }
    if (doc.createdAt) {
      const created = doc.createdAt.seconds
        ? new Date(doc.createdAt.seconds * 1000)
        : new Date(doc.createdAt);
      return (Date.now() - created.getTime()) > THIRTY_DAYS_MS;
    }
    return false;
  }

  function fmtExpiry(doc) {
    if (doc.expiresAt) {
      const d = doc.expiresAt.seconds
        ? new Date(doc.expiresAt.seconds * 1000)
        : new Date(doc.expiresAt);
      const daysAgo = Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
      return `Expired ${daysAgo}d ago (${d.toLocaleDateString()})`;
    }
    if (doc.createdAt) {
      const created = doc.createdAt.seconds
        ? new Date(doc.createdAt.seconds * 1000)
        : new Date(doc.createdAt);
      const age = Math.floor((Date.now() - created.getTime()) / (1000 * 60 * 60 * 24));
      return `${age} days old (no expiry field)`;
    }
    return "Unknown age";
  }

  // Estimate doc size in KB based on resumeData presence
  function estimateSize(d) {
    try {
      return Math.round(JSON.stringify(d).length / 1024);
    } catch {
      return 0;
    }
  }

  async function scanExpired() {
    setScanning(true);
    setScanned(false);
    setExpired([]);
    setSelected(new Set());
    setError("");
    setLog([]);
    addLog("Starting scan across all users...");

    try {
      const usersSnap = await getDocs(collection(db, "users"));
      addLog(`Found ${usersSnap.docs.length} users — scanning documents...`);

      const expiredDocs = [];
      let totalScanned  = 0;

      for (const userDoc of usersSnap.docs) {
        const uid      = userDoc.id;
        const userData = userDoc.data();
        const email    = userData.email || uid;

        // Check both collections
        for (const colName of ["generatedDocs", "generatedResumes"]) {
          try {
            const colSnap = await getDocs(collection(db, "users", uid, colName));
            totalScanned += colSnap.docs.length;

            for (const d of colSnap.docs) {
              const data = d.data();
              if (isExpired(data)) {
                expiredDocs.push({
                  uid,
                  email,
                  collection: colName,
                  docId:      d.id,
                  type:       data.type || (colName === "generatedResumes" ? "resume" : "unknown"),
                  mode:       data.mode || "improved",
                  createdAt:  data.createdAt,
                  expiresAt:  data.expiresAt,
                  expiryLabel: fmtExpiry(data),
                  sizeKB:     estimateSize(data),
                  hasData:    !!(data.resumeData || data.letterData),
                });
              }
            }
          } catch (colErr) {
            // Collection may not exist for this user — skip silently
          }
        }
      }

      addLog(`Scanned ${totalScanned} documents across ${usersSnap.docs.length} users`);
      addLog(`Found ${expiredDocs.length} expired documents`);

      // Sort by oldest first
      expiredDocs.sort((a, b) => {
        const aTime = a.createdAt?.seconds || 0;
        const bTime = b.createdAt?.seconds || 0;
        return aTime - bTime;
      });

      setExpired(expiredDocs);
      setScanned(true);

      if (expiredDocs.length === 0) {
        addLog("✅ No expired documents found — database is clean");
      } else {
        const totalKB = expiredDocs.reduce((s, d) => s + d.sizeKB, 0);
        addLog(`Total reclaimable storage: ~${totalKB}KB`);
      }

    } catch (err) {
      setError(err.message);
      addLog(`❌ Scan failed: ${err.message}`);
    }
    setScanning(false);
  }

  async function deleteSelected() {
    const toDelete = expired.filter(d => selected.has(d.docId));
    if (toDelete.length === 0) return;

    setDeleting(true);
    setError("");
    addLog(`Starting deletion of ${toDelete.length} documents...`);

    const deletedIds = [];
    let failCount    = 0;

    // Process in batches of 20 to avoid Firestore limits
    const BATCH_SIZE = 20;
    for (let i = 0; i < toDelete.length; i += BATCH_SIZE) {
      const batch     = writeBatch(db);
      const batchDocs = toDelete.slice(i, i + BATCH_SIZE);

      batchDocs.forEach(d => {
        const ref = doc(db, "users", d.uid, d.collection, d.docId);
        batch.delete(ref);
      });

      try {
        await batch.commit();
        batchDocs.forEach(d => {
          deletedIds.push(d.docId);
          addLog(`🗑️ Deleted ${d.type} (${d.docId.slice(-8)}) — ${d.email}`);
        });
      } catch (batchErr) {
        failCount += batchDocs.length;
        addLog(`❌ Batch ${Math.floor(i / BATCH_SIZE) + 1} failed: ${batchErr.message}`);
      }
    }

    // Remove deleted docs from expired list
    setExpired(prev => prev.filter(d => !deletedIds.includes(d.docId)));
    setDeleted(prev => [...prev, ...toDelete.filter(d => deletedIds.includes(d.docId))]);
    setSelected(new Set());

    addLog(`✅ Deleted ${deletedIds.length} documents${failCount > 0 ? ` (${failCount} failed)` : ""}`);
    setDeleting(false);
  }

  // eslint-disable-next-line no-unused-vars
  async function deleteAll() {
    // Select all and delete
    const allIds = new Set(filtered.map(d => d.docId));
    setSelected(allIds);
    // Small delay to let state update
    setTimeout(() => deleteSelected(), 100);
  }

  function toggleSelect(docId) {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(docId)) next.delete(docId);
      else next.add(docId);
      return next;
    });
  }

  function selectAll() {
    setSelected(new Set(filtered.map(d => d.docId)));
  }

  function selectNone() {
    setSelected(new Set());
  }

  const filtered = expired.filter(d =>
    filterType === "all" ? true : d.type === filterType
  );

  const totalKB       = filtered.reduce((s, d) => s + d.sizeKB, 0);
  const selectedCount = filtered.filter(d => selected.has(d.docId)).length;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

      {/* Header */}
      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "20px 24px" }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 16, marginBottom: 16 }}>
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>🗑️ Document Cleanup</h2>
            <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>
              Find and delete expired documents (older than 30 days) across all user accounts.
              This frees up Firestore storage and keeps the database clean.
            </p>
          </div>
          <button
            onClick={scanExpired}
            disabled={scanning || deleting}
            style={{ padding: "10px 20px", background: scanning ? "#f1f5f9" : "linear-gradient(135deg,#2563eb,#1d4ed8)", color: scanning ? "#94a3b8" : "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: scanning ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}
          >
            {scanning ? (
              <>
                <span style={{ width: 14, height: 14, borderRadius: "50%", border: "2px solid #e2e8f0", borderTopColor: "#94a3b8", animation: "spin 0.7s linear infinite", display: "inline-block" }} />
                Scanning...
              </>
            ) : "🔍 Scan for Expired Docs"}
          </button>
        </div>

        {/* Stats row */}
        {scanned && (
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            {[
              { label: "Expired docs", value: expired.length, color: expired.length > 0 ? "#dc2626" : "#059669", bg: expired.length > 0 ? "#fef2f2" : "#f0fdf4" },
              { label: "Resumes",      value: expired.filter(d => d.type === "resume").length, color: "#7c3aed", bg: "#f5f3ff" },
              { label: "Cover letters", value: expired.filter(d => d.type === "cover_letter").length, color: "#0891b2", bg: "#f0f9ff" },
              { label: "Storage ~",    value: `${totalKB}KB`, color: "#d97706", bg: "#fffbeb" },
              { label: "Deleted this session", value: deleted.length, color: "#059669", bg: "#f0fdf4" },
            ].map(s => (
              <div key={s.label} style={{ background: s.bg, borderRadius: 9, padding: "8px 14px", textAlign: "center", minWidth: 90 }}>
                <div style={{ fontSize: 9, fontWeight: 700, color: s.color, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 2 }}>{s.label}</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: s.color }}>{s.value}</div>
              </div>
            ))}
          </div>
        )}

        {error && (
          <div style={{ marginTop: 12, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#dc2626" }}>
            ❌ {error}
          </div>
        )}
      </div>

      {/* Controls */}
      {scanned && expired.length > 0 && (
        <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "14px 20px", display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          {/* Filter */}
          <div style={{ display: "flex", gap: 6 }}>
            {[
              { id: "all",          label: `All (${expired.length})` },
              { id: "resume",       label: `Resumes (${expired.filter(d=>d.type==="resume").length})` },
              { id: "cover_letter", label: `Cover Letters (${expired.filter(d=>d.type==="cover_letter").length})` },
            ].map(f => (
              <button key={f.id} onClick={() => setFilterType(f.id)}
                style={{ padding: "5px 12px", borderRadius: 7, border: "1px solid", fontSize: 12, fontWeight: 600, cursor: "pointer", borderColor: filterType === f.id ? "#2563eb" : "#e2e8f0", background: filterType === f.id ? "#eff6ff" : "#fff", color: filterType === f.id ? "#2563eb" : "#64748b" }}>
                {f.label}
              </button>
            ))}
          </div>

          <div style={{ display: "flex", gap: 6, marginLeft: "auto" }}>
            <button onClick={selectAll} style={{ padding: "5px 12px", background: "#f8fafc", color: "#374151", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
              Select All
            </button>
            <button onClick={selectNone} style={{ padding: "5px 12px", background: "#f8fafc", color: "#374151", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
              Select None
            </button>
            <button
              onClick={deleteSelected}
              disabled={selectedCount === 0 || deleting}
              style={{ padding: "5px 14px", background: selectedCount > 0 ? "#dc2626" : "#f1f5f9", color: selectedCount > 0 ? "#fff" : "#94a3b8", border: "none", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: selectedCount > 0 ? "pointer" : "not-allowed", display: "flex", alignItems: "center", gap: 6 }}
            >
              {deleting ? (
                <>
                  <span style={{ width: 12, height: 12, borderRadius: "50%", border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff", animation: "spin 0.7s linear infinite", display: "inline-block" }} />
                  Deleting...
                </>
              ) : `🗑️ Delete Selected (${selectedCount})`}
            </button>
          </div>
        </div>
      )}

      {/* Expired docs list */}
      {scanned && (
        <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>
          {filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: "48px 24px", color: "#94a3b8" }}>
              <div style={{ fontSize: 36, marginBottom: 12 }}>✅</div>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>No expired documents found</div>
              <div style={{ fontSize: 13, marginTop: 4 }}>Database is clean for this filter</div>
            </div>
          ) : (
            <div>
              {/* Table header */}
              <div style={{ display: "grid", gridTemplateColumns: "40px 1fr 140px 100px 80px 80px", gap: 12, padding: "10px 16px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0", fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                <div></div>
                <div>User / Document</div>
                <div>Expiry</div>
                <div>Type</div>
                <div>Size</div>
                <div>Data</div>
              </div>

              {/* Rows */}
              <div style={{ maxHeight: 500, overflowY: "auto" }}>
                {filtered.map((d, i) => (
                  <div key={d.docId}
                    onClick={() => toggleSelect(d.docId)}
                    style={{ display: "grid", gridTemplateColumns: "40px 1fr 140px 100px 80px 80px", gap: 12, padding: "12px 16px", borderBottom: "1px solid #f1f5f9", cursor: "pointer", background: selected.has(d.docId) ? "#fef2f2" : i % 2 === 0 ? "#fff" : "#fafafa", transition: "background 0.1s" }}
                  >
                    {/* Checkbox */}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <div style={{ width: 18, height: 18, borderRadius: 4, border: `2px solid ${selected.has(d.docId) ? "#dc2626" : "#d1d5db"}`, background: selected.has(d.docId) ? "#dc2626" : "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        {selected.has(d.docId) && <span style={{ color: "#fff", fontSize: 11, fontWeight: 800 }}>✓</span>}
                      </div>
                    </div>

                    {/* User / doc info */}
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#0f172a", marginBottom: 2 }}>{d.email}</div>
                      <div style={{ fontSize: 11, color: "#94a3b8", fontFamily: "monospace" }}>{d.docId.slice(-12)}</div>
                    </div>

                    {/* Expiry */}
                    <div style={{ fontSize: 11, color: "#dc2626", display: "flex", alignItems: "center" }}>
                      {d.expiryLabel}
                    </div>

                    {/* Type */}
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 20, fontWeight: 600, background: d.type === "resume" ? "#f0fdf4" : "#f5f3ff", color: d.type === "resume" ? "#059669" : "#7c3aed" }}>
                        {d.type === "resume" ? (d.mode === "scratch" ? "📝 Scratch" : "✨ Resume") : "✉️ Cover Letter"}
                      </span>
                    </div>

                    {/* Size */}
                    <div style={{ fontSize: 12, color: "#64748b", display: "flex", alignItems: "center" }}>
                      {d.sizeKB}KB
                    </div>

                    {/* Has data */}
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ fontSize: 11, color: d.hasData ? "#059669" : "#94a3b8" }}>
                        {d.hasData ? "✓ Has data" : "Empty"}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Footer total */}
              <div style={{ padding: "10px 16px", background: "#f8fafc", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, color: "#64748b" }}>
                  {filtered.length} expired documents · ~{totalKB}KB total · {selectedCount} selected
                </span>
                {filtered.length > 0 && (
                  <button
                    onClick={() => { selectAll(); setTimeout(deleteSelected, 100); }}
                    disabled={deleting}
                    style={{ padding: "6px 16px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer" }}
                  >
                    🗑️ Delete All {filtered.length} Expired
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Activity log */}
      {log.length > 0 && (
        <div style={{ background: "#0f172a", borderRadius: 14, padding: "16px 20px" }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#60a5fa", marginBottom: 10 }}>📋 Activity Log</div>
          <div style={{ maxHeight: 200, overflowY: "auto", display: "flex", flexDirection: "column", gap: 4 }}>
            {log.map((entry, i) => (
              <div key={i} style={{ fontSize: 11, color: entry.includes("❌") ? "#f87171" : entry.includes("✅") ? "#34d399" : entry.includes("🗑️") ? "#fbbf24" : "#94a3b8", fontFamily: "monospace" }}>
                {entry}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Deleted summary */}
      {deleted.length > 0 && (
        <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 14, padding: "16px 20px" }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#059669", marginBottom: 8 }}>
            ✅ {deleted.length} documents deleted this session
          </div>
          <div style={{ fontSize: 12, color: "#065f46" }}>
            {deleted.filter(d => d.type === "resume").length} resumes · {deleted.filter(d => d.type === "cover_letter").length} cover letters · ~{deleted.reduce((s, d) => s + d.sizeKB, 0)}KB freed
          </div>
        </div>
      )}
    </div>
  );
}



// ─────────────────────────────────────────────────────────────
// EMAIL LOGS TAB
// Reads from /emailLogs collection in Firestore
// Shows all outbound emails with type, recipient, status, date
// ─────────────────────────────────────────────────────────────
function EmailLogsTab() {
  const [logs,       setLogs]       = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [filter,     setFilter]     = useState("all");   // all | sent | failed
  const [typeFilter, setTypeFilter] = useState("all");
  const [search,     setSearch]     = useState("");
  const [page,       setPage]       = useState(0);
  const PAGE_SIZE = 50;

  const EMAIL_TYPES = [
    { id: "all",                  label: "All Types" },
    { id: "welcome",              label: "👋 Welcome" },
    { id: "verification",         label: "✉️ Verification" },
    { id: "payment_success",      label: "💳 Payment Success" },
    { id: "payment_failed",       label: "❌ Payment Failed" },
    { id: "refund",               label: "↩ Refund" },
    { id: "support_confirmation", label: "🎫 Support Confirm" },
    { id: "support_admin",        label: "🔔 Support Admin" },
    { id: "password_reset",       label: "🔑 Password Reset" },
    { id: "error_alert",          label: "🚨 Error Alert" },
  ];

  const TYPE_COLORS = {
    welcome:              { bg: "#eff6ff", color: "#2563eb" },
    verification:         { bg: "#f0fdf4", color: "#059669" },
    payment_success:      { bg: "#f0fdf4", color: "#059669" },
    payment_failed:       { bg: "#fef2f2", color: "#dc2626" },
    refund:               { bg: "#fef2f2", color: "#dc2626" },
    support_confirmation: { bg: "#fdf4ff", color: "#7c3aed" },
    support_admin:        { bg: "#fffbeb", color: "#d97706" },
    password_reset:       { bg: "#f0f9ff", color: "#0891b2" },
    error_alert:          { bg: "#fef2f2", color: "#dc2626" },
  };

  useEffect(() => {
    loadLogs();
  }, []);

  async function loadLogs() {
    setLoading(true);
    try {
      // Load last 500 logs ordered by newest first
      const snap = await getDocs(
        query(
          collection(db, "emailLogs"),
          orderBy("sentAt", "desc"),
          limit(500)
        )
      );
      setLogs(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error("EmailLogsTab load error:", err);
      // Collection may not exist yet — that's fine
      setLogs([]);
    }
    setLoading(false);
  }

  function fmtLogDate(ts) {
    if (!ts) return "—";
    const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
    return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  }

  // ── Derived stats ──
  const totalSent   = logs.filter(l => l.status === "sent").length;
  const totalFailed = logs.filter(l => l.status === "failed").length;
  const failRate    = logs.length > 0 ? Math.round((totalFailed / logs.length) * 100) : 0;

  // Type breakdown
  const typeBreakdown = EMAIL_TYPES.slice(1).map(t => ({
    ...t,
    count: logs.filter(l => l.type === t.id).length,
  })).filter(t => t.count > 0);

  // ── Filtered logs ──
  const filtered = logs.filter(l => {
    if (filter === "sent"   && l.status !== "sent")   return false;
    if (filter === "failed" && l.status !== "failed") return false;
    if (typeFilter !== "all" && l.type !== typeFilter) return false;
    if (search) {
      const q = search.toLowerCase();
      if (!l.toEmail?.toLowerCase().includes(q) &&
          !l.toName?.toLowerCase().includes(q)  &&
          !l.type?.toLowerCase().includes(q))   return false;
    }
    return true;
  });

  const paginated = filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

      {/* Stats header */}
      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "20px 24px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexWrap: "wrap", gap: 12 }}>
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>📧 Email Logs</h2>
            <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>All outbound emails tracked from the server</p>
          </div>
          <button onClick={loadLogs} style={{ padding: "8px 16px", background: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe", borderRadius: 9, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
            🔄 Refresh
          </button>
        </div>

        {/* Summary stats */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
          {[
            { label: "Total sent",    value: totalSent,   color: "#059669", bg: "#f0fdf4" },
            { label: "Failed",        value: totalFailed, color: totalFailed > 0 ? "#dc2626" : "#059669", bg: totalFailed > 0 ? "#fef2f2" : "#f0fdf4" },
            { label: "Fail rate",     value: `${failRate}%`, color: failRate > 5 ? "#dc2626" : "#059669", bg: failRate > 5 ? "#fef2f2" : "#f0fdf4" },
            { label: "Total tracked", value: logs.length, color: "#2563eb", bg: "#eff6ff" },
          ].map(s => (
            <div key={s.label} style={{ background: s.bg, borderRadius: 9, padding: "8px 14px", textAlign: "center", minWidth: 80 }}>
              <div style={{ fontSize: 9, fontWeight: 700, color: s.color, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 2 }}>{s.label}</div>
              <div style={{ fontSize: 20, fontWeight: 800, color: s.color }}>{s.value}</div>
            </div>
          ))}
        </div>

        {/* Type breakdown pills */}
        {typeBreakdown.length > 0 && (
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {typeBreakdown.map(t => {
              const c = TYPE_COLORS[t.id] || { bg: "#f1f5f9", color: "#64748b" };
              return (
                <span key={t.id}
                  onClick={() => setTypeFilter(typeFilter === t.id ? "all" : t.id)}
                  style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, fontWeight: 600, cursor: "pointer", background: typeFilter === t.id ? c.color : c.bg, color: typeFilter === t.id ? "#fff" : c.color, border: `1px solid ${c.color}30` }}>
                  {t.label} ({t.count})
                </span>
              );
            })}
          </div>
        )}
      </div>

      {/* Filters */}
      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "14px 20px", display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
        <input
          type="text" placeholder="🔍 Search by email or name..."
          value={search} onChange={e => { setSearch(e.target.value); setPage(0); }}
          style={{ padding: "8px 14px", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 13, minWidth: 200, flex: "1 1 200px", outline: "none" }}
        />
        <div style={{ display: "flex", gap: 6 }}>
          {[
            { id: "all",    label: `All (${logs.length})` },
            { id: "sent",   label: `✅ Sent (${totalSent})` },
            { id: "failed", label: `❌ Failed (${totalFailed})` },
          ].map(f => (
            <button key={f.id} onClick={() => { setFilter(f.id); setPage(0); }}
              style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid", fontSize: 12, fontWeight: 600, cursor: "pointer", borderColor: filter === f.id ? "#2563eb" : "#e2e8f0", background: filter === f.id ? "#eff6ff" : "#fff", color: filter === f.id ? "#2563eb" : "#64748b" }}>
              {f.label}
            </button>
          ))}
        </div>
        <span style={{ fontSize: 12, color: "#94a3b8", marginLeft: "auto" }}>
          {filtered.length} results
        </span>
      </div>

      {/* Logs table */}
      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "48px", color: "#94a3b8" }}>
            <div style={{ width: 32, height: 32, borderRadius: "50%", border: "3px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.8s linear infinite", margin: "0 auto 12px" }} />
            Loading email logs...
          </div>
        ) : logs.length === 0 ? (
          <div style={{ textAlign: "center", padding: "48px", color: "#94a3b8" }}>
            <div style={{ fontSize: 36, marginBottom: 12 }}>📭</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 4 }}>No email logs yet</div>
            <div style={{ fontSize: 13 }}>Emails will appear here once users start signing up and making purchases.</div>
            <div style={{ fontSize: 12, marginTop: 8, color: "#64748b" }}>
              Make sure <code style={{ background: "#f1f5f9", padding: "1px 6px", borderRadius: 4 }}>emailLogger.js</code> is deployed and Firebase Admin is configured.
            </div>
          </div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "32px", color: "#94a3b8", fontSize: 13 }}>
            No logs match your filters.
          </div>
        ) : (
          <>
            {/* Table header */}
            <div style={{ display: "grid", gridTemplateColumns: "140px 1fr 180px 80px 100px", gap: 12, padding: "10px 16px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0", fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>
              <div>Type</div>
              <div>Recipient</div>
              <div>Subject</div>
              <div>Status</div>
              <div>Sent At</div>
            </div>

            <div style={{ maxHeight: 600, overflowY: "auto" }}>
              {paginated.map((log, i) => {
                const tc = TYPE_COLORS[log.type] || { bg: "#f1f5f9", color: "#64748b" };
                const isFailed = log.status === "failed";
                return (
                  <div key={log.id} style={{ display: "grid", gridTemplateColumns: "140px 1fr 180px 80px 100px", gap: 12, padding: "11px 16px", borderBottom: "1px solid #f1f5f9", background: isFailed ? "#fef9f9" : i % 2 === 0 ? "#fff" : "#fafafa", alignItems: "center" }}>

                    {/* Type badge */}
                    <div>
                      <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 20, fontWeight: 600, background: tc.bg, color: tc.color, whiteSpace: "nowrap" }}>
                        {EMAIL_TYPES.find(t => t.id === log.type)?.label || log.type}
                      </span>
                    </div>

                    {/* Recipient */}
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#0f172a" }}>{log.toName || "—"}</div>
                      <div style={{ fontSize: 11, color: "#64748b" }}>{log.toEmail}</div>
                    </div>

                    {/* Subject */}
                    <div style={{ fontSize: 11, color: "#475569", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {log.subject || "—"}
                    </div>

                    {/* Status */}
                    <div>
                      <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 20, fontWeight: 700, background: isFailed ? "#fef2f2" : "#f0fdf4", color: isFailed ? "#dc2626" : "#059669" }}>
                        {isFailed ? "❌ Failed" : "✅ Sent"}
                      </span>
                      {isFailed && log.error && (
                        <div style={{ fontSize: 10, color: "#dc2626", marginTop: 2, maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={log.error}>
                          {log.error}
                        </div>
                      )}
                    </div>

                    {/* Date */}
                    <div style={{ fontSize: 11, color: "#94a3b8" }}>
                      {fmtLogDate(log.sentAt)}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={{ padding: "12px 16px", borderTop: "1px solid #e2e8f0", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                <span style={{ fontSize: 12, color: "#64748b" }}>
                  Page {page + 1} of {totalPages} · {filtered.length} results
                </span>
                <div style={{ display: "flex", gap: 6 }}>
                  <button onClick={() => setPage(p => Math.max(0, p - 1))} disabled={page === 0}
                    style={{ padding: "5px 12px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, cursor: page === 0 ? "not-allowed" : "pointer", color: page === 0 ? "#94a3b8" : "#374151", fontWeight: 600 }}>
                    ← Prev
                  </button>
                  <button onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))} disabled={page >= totalPages - 1}
                    style={{ padding: "5px 12px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, cursor: page >= totalPages - 1 ? "not-allowed" : "pointer", color: page >= totalPages - 1 ? "#94a3b8" : "#374151", fontWeight: 600 }}>
                    Next →
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Setup guide — shown when no logs */}
      {!loading && logs.length === 0 && (
        <div style={{ background: "#0f172a", borderRadius: 14, padding: "20px 24px", color: "#e2e8f0" }}>
          <h3 style={{ fontSize: 14, fontWeight: 700, color: "#fff", marginBottom: 12 }}>⚙️ Setup Guide</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 8, fontSize: 13, color: "#94a3b8", lineHeight: 1.7 }}>
            <div><strong style={{ color: "#60a5fa" }}>Step 1</strong> — Install Firebase Admin: <code style={{ background: "#1e293b", padding: "1px 6px", borderRadius: 4 }}>npm install firebase-admin</code></div>
            <div><strong style={{ color: "#60a5fa" }}>Step 2</strong> — Download service account key from Firebase Console → Project Settings → Service Accounts → Generate new private key</div>
            <div><strong style={{ color: "#60a5fa" }}>Step 3</strong> — Save as <code style={{ background: "#1e293b", padding: "1px 6px", borderRadius: 4 }}>serviceAccountKey.json</code> in your backend root (add to .gitignore)</div>
            <div><strong style={{ color: "#60a5fa" }}>Step 4</strong> — For Render: add <code style={{ background: "#1e293b", padding: "1px 6px", borderRadius: 4 }}>FIREBASE_SERVICE_ACCOUNT</code> env var with the JSON contents</div>
            <div><strong style={{ color: "#60a5fa" }}>Step 5</strong> — Add Firestore rule: <code style={{ background: "#1e293b", padding: "1px 6px", borderRadius: 4 }}>match /emailLogs/{"{docId}"} {"{ allow read: if isAdmin(); allow write: if false; }"}</code></div>
          </div>
        </div>
      )}
    </div>
  );
}
